// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%236c757d%27%3e%3cpath d=%27M12 15l-5-5h10z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-card-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.5rem 0;
}
@media (min-width: 768px) {
  .admin-card-list {
    gap: 1rem;
  }
}

.admin-card-item {
  background: var(--vz-card-bg);
  border: 1px solid var(--vz-card-border-color);
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}
.admin-card-item:active {
  transform: scale(0.99);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
@media (min-width: 768px) {
  .admin-card-item {
    border-radius: 0.875rem;
  }
  .admin-card-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.admin-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--vz-border-color);
  background: linear-gradient(to bottom, rgba(var(--vz-primary-rgb), 0.02), transparent);
}
@media (min-width: 768px) {
  .admin-card-header {
    padding: 1rem 1.25rem;
  }
}

.admin-card-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #212529;
  margin: 0;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (min-width: 768px) {
  .admin-card-title {
    font-size: 1rem;
  }
}

.admin-card-badge {
  flex-shrink: 0;
  margin-left: 0.75rem;
  font-size: 0.6875rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.admin-card-badge.badge-active {
  background: rgba(var(--vz-success-rgb), 0.1);
  color: var(--vz-success);
}
.admin-card-badge.badge-inactive {
  background: rgba(var(--vz-danger-rgb), 0.1);
  color: var(--vz-danger);
}
.admin-card-badge.badge-pending {
  background: rgba(var(--vz-warning-rgb), 0.1);
  color: var(--vz-warning);
}
.admin-card-badge.badge-completed {
  background: rgba(var(--vz-info-rgb), 0.1);
  color: var(--vz-info);
}
.admin-card-badge.badge-primary {
  background: rgba(var(--vz-primary-rgb), 0.1);
  color: var(--vz-primary);
}

.admin-card-body {
  padding: 1rem;
}
@media (min-width: 768px) {
  .admin-card-body {
    padding: 1.25rem;
  }
}

.admin-card-footer {
  display: flex;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  border-top: 1px solid var(--vz-border-color);
  background: rgba(var(--vz-primary-rgb), 0.01);
}
@media (min-width: 768px) {
  .admin-card-footer {
    padding: 1rem 1.25rem;
    gap: 0.75rem;
  }
}

.admin-info-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0;
}
.admin-info-row:not(:last-child) {
  border-bottom: 1px solid rgba(var(--vz-border-color), 0.4);
}
@media (min-width: 768px) {
  .admin-info-row {
    padding: 0.625rem 0;
    gap: 1rem;
  }
}

.admin-info-label {
  flex-shrink: 0;
  width: 90px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.admin-info-label i {
  font-size: 0.875rem;
  margin-right: 0.375rem;
  color: var(--vz-primary);
}
@media (min-width: 768px) {
  .admin-info-label {
    width: 110px;
    font-size: 0.8125rem;
  }
}

.admin-info-value {
  flex: 1 1;
  font-size: 0.875rem;
  color: #212529;
  font-weight: 500;
  word-break: break-word;
}
.admin-info-value.value-muted {
  color: #6c757d;
  font-style: italic;
}
.admin-info-value.value-highlight {
  color: var(--vz-primary);
  font-weight: 600;
}
.admin-info-value.value-success {
  color: var(--vz-success);
  font-weight: 600;
}
.admin-info-value.value-danger {
  color: var(--vz-danger);
  font-weight: 600;
}
@media (min-width: 768px) {
  .admin-info-value {
    font-size: 0.9375rem;
  }
}

.admin-info-row-compact {
  padding: 0.375rem 0;
  gap: 0.5rem;
}
.admin-info-row-compact .admin-info-label {
  width: 70px;
  font-size: 0.6875rem;
}
.admin-info-row-compact .admin-info-value {
  font-size: 0.8125rem;
}

.admin-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  min-height: 44px;
  padding: 0.625rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.15s ease;
  text-decoration: none;
  white-space: nowrap;
}
.admin-action-btn i {
  font-size: 1rem;
}
.admin-action-btn:active:not(:disabled) {
  transform: scale(0.96);
}
.admin-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.admin-action-btn.btn-block {
  width: 100%;
}
@media (min-width: 768px) {
  .admin-action-btn {
    min-height: 40px;
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
  .admin-action-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  }
  .admin-action-btn:active:not(:disabled) {
    transform: translateY(0);
  }
}

.admin-btn-primary {
  background: var(--vz-primary);
  color: white;
}
.admin-btn-primary:hover:not(:disabled) {
  background: rgba(var(--vz-primary-rgb), 0.9);
}
.admin-btn-primary:active:not(:disabled) {
  background: rgba(var(--vz-primary-rgb), 0.85);
}

.admin-btn-success {
  background: var(--vz-success);
  color: white;
}
.admin-btn-success:hover:not(:disabled) {
  background: rgba(var(--vz-success-rgb), 0.9);
}
.admin-btn-success:active:not(:disabled) {
  background: rgba(var(--vz-success-rgb), 0.85);
}

.admin-btn-danger {
  background: var(--vz-danger);
  color: white;
}
.admin-btn-danger:hover:not(:disabled) {
  background: rgba(var(--vz-danger-rgb), 0.9);
}
.admin-btn-danger:active:not(:disabled) {
  background: rgba(var(--vz-danger-rgb), 0.85);
}

.admin-btn-warning {
  background: var(--vz-warning);
  color: #212529;
}
.admin-btn-warning:hover:not(:disabled) {
  background: rgba(var(--vz-warning-rgb), 0.9);
}
.admin-btn-warning:active:not(:disabled) {
  background: rgba(var(--vz-warning-rgb), 0.85);
}

.admin-btn-outline {
  background: white;
  color: var(--vz-primary);
  border: 1px solid var(--vz-primary);
}
.admin-btn-outline:hover:not(:disabled) {
  background: rgba(var(--vz-primary-rgb), 0.05);
}
.admin-btn-outline:active:not(:disabled) {
  background: rgba(var(--vz-primary-rgb), 0.1);
}
.admin-btn-outline.btn-outline-danger {
  color: var(--vz-danger);
  border-color: var(--vz-danger);
}
.admin-btn-outline.btn-outline-danger:hover:not(:disabled) {
  background: rgba(var(--vz-danger-rgb), 0.05);
}
.admin-btn-outline.btn-outline-danger:active:not(:disabled) {
  background: rgba(var(--vz-danger-rgb), 0.1);
}
.admin-btn-outline.btn-outline-success {
  color: var(--vz-success);
  border-color: var(--vz-success);
}
.admin-btn-outline.btn-outline-success:hover:not(:disabled) {
  background: rgba(var(--vz-success-rgb), 0.05);
}
.admin-btn-outline.btn-outline-success:active:not(:disabled) {
  background: rgba(var(--vz-success-rgb), 0.1);
}

.admin-btn-ghost {
  background: rgba(var(--vz-primary-rgb), 0.08);
  color: var(--vz-primary);
}
.admin-btn-ghost:hover:not(:disabled) {
  background: rgba(var(--vz-primary-rgb), 0.12);
}
.admin-btn-ghost:active:not(:disabled) {
  background: rgba(var(--vz-primary-rgb), 0.16);
}

.admin-btn-icon {
  padding: 0.625rem;
  min-width: 44px;
  border-radius: 0.5rem;
}
.admin-btn-icon i {
  font-size: 1.125rem;
  margin: 0;
}
@media (min-width: 768px) {
  .admin-btn-icon {
    min-width: 40px;
    padding: 0.5rem;
  }
}

.admin-filter-section {
  background: var(--vz-card-bg);
  border: 1px solid var(--vz-card-border-color);
  border-radius: 0.75rem;
  margin-bottom: 1rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.admin-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.15s ease;
}
.admin-filter-toggle:active {
  background: rgba(var(--vz-primary-rgb), 0.04);
}
@media (min-width: 768px) {
  .admin-filter-toggle:hover {
    background: rgba(var(--vz-primary-rgb), 0.03);
  }
}

.admin-filter-toggle-text {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #212529;
}
.admin-filter-toggle-text i {
  font-size: 1.125rem;
  color: var(--vz-primary);
}

.admin-filter-toggle-icon {
  font-size: 1.25rem;
  color: #6c757d;
  transition: transform 0.2s ease;
}
.admin-filter-toggle-icon.expanded {
  transform: rotate(180deg);
}

.admin-filter-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.admin-filter-content.expanded {
  max-height: 1000px;
}

.admin-filter-body {
  padding: 0 1rem 1rem;
  border-top: 1px solid var(--vz-border-color);
  padding-top: 1rem;
}

.admin-filter-row {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .admin-filter-row {
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
  }
}

.admin-filter-label {
  flex-shrink: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #495057;
  min-width: 80px;
}

.admin-filter-input {
  flex: 1 1;
  min-height: 44px;
  padding: 0.625rem 0.875rem;
  font-size: 0.875rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background: white;
  transition: border-color 0.15s ease;
}
.admin-filter-input:focus {
  outline: none;
  border-color: var(--vz-primary);
  box-shadow: 0 0 0 3px rgba(var(--vz-primary-rgb), 0.1);
}
@media (min-width: 768px) {
  .admin-filter-input {
    min-height: 40px;
    font-size: 16px;
  }
}

.admin-filter-actions {
  display: flex;
  gap: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px dashed var(--vz-border-color);
}

.admin-filter-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.375rem;
  background: var(--vz-primary);
  color: white;
  border-radius: 0.625rem;
  font-size: 0.6875rem;
  font-weight: 700;
  margin-left: 0.5rem;
}

.admin-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  text-align: center;
  background: var(--vz-card-bg);
  border: 1px dashed var(--vz-card-border-color);
  border-radius: 0.75rem;
  min-height: 280px;
}
@media (min-width: 768px) {
  .admin-empty-state {
    padding: 4rem 2rem;
    min-height: 320px;
  }
}

.admin-empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(var(--vz-primary-rgb), 0.1), rgba(var(--vz-primary-rgb), 0.05));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
}
.admin-empty-icon i {
  font-size: 2.5rem;
  color: rgba(var(--vz-primary-rgb), 0.6);
}
@media (min-width: 768px) {
  .admin-empty-icon {
    width: 100px;
    height: 100px;
  }
  .admin-empty-icon i {
    font-size: 3rem;
  }
}

.admin-empty-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #212529;
  margin: 0 0 0.5rem;
}
@media (min-width: 768px) {
  .admin-empty-title {
    font-size: 1.25rem;
  }
}

.admin-empty-text {
  font-size: 0.875rem;
  color: #6c757d;
  margin: 0 0 1.5rem;
  max-width: 400px;
  line-height: 1.6;
}
@media (min-width: 768px) {
  .admin-empty-text {
    font-size: 0.9375rem;
  }
}

.admin-empty-action {
  margin-top: 0.5rem;
}

.admin-skeleton {
  animation: skeleton-loading 1.2s ease-in-out infinite;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 0.375rem;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.admin-skeleton-card {
  background: var(--vz-card-bg);
  border: 1px solid var(--vz-card-border-color);
  border-radius: 0.75rem;
  padding: 1rem;
  margin-bottom: 0.75rem;
}
@media (min-width: 768px) {
  .admin-skeleton-card {
    padding: 1.25rem;
    margin-bottom: 1rem;
  }
}

.admin-skeleton-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.admin-skeleton-title {
  height: 1.25rem;
  width: 60%;
  max-width: 200px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.2s ease-in-out infinite;
  border-radius: 0.375rem;
}

.admin-skeleton-badge {
  height: 1.5rem;
  width: 60px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.2s ease-in-out infinite;
  border-radius: 0.375rem;
}

.admin-skeleton-line {
  height: 0.875rem;
  margin-bottom: 0.75rem;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.2s ease-in-out infinite;
  border-radius: 0.375rem;
}
.admin-skeleton-line:last-child {
  margin-bottom: 0;
}
.admin-skeleton-line.line-short {
  width: 40%;
}
.admin-skeleton-line.line-medium {
  width: 65%;
}
.admin-skeleton-line.line-long {
  width: 85%;
}

.admin-skeleton-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--vz-border-color);
}

.admin-skeleton-button {
  flex: 1 1;
  height: 44px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.2s ease-in-out infinite;
  border-radius: 0.5rem;
}

.admin-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 0.75rem;
}
@media (min-width: 768px) {
  .admin-page-header {
    padding: 1rem 0;
    margin-bottom: 1.5rem;
  }
}

.admin-page-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #212529;
  margin: 0;
  flex: 1 1;
  min-width: 0;
}
@media (min-width: 768px) {
  .admin-page-title {
    font-size: 1.375rem;
  }
}

.admin-page-subtitle {
  font-size: 0.8125rem;
  color: #6c757d;
  margin: 0.25rem 0 0;
  font-weight: 400;
}

.admin-page-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
@media (max-width: 575.98px) {
  .admin-page-actions {
    width: 100%;
  }
  .admin-page-actions .admin-action-btn {
    flex: 1 1;
  }
}

.admin-page-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding-top: 0.5rem;
  font-size: 0.8125rem;
  color: #6c757d;
}
@media (min-width: 768px) {
  .admin-page-meta {
    width: auto;
  }
}

.admin-page-meta-item {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}
.admin-page-meta-item i {
  font-size: 0.9375rem;
  color: var(--vz-primary);
}

.admin-sticky-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid var(--vz-border-color);
  padding: 0.75rem 1rem;
  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0));
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  transition: transform 0.3s ease;
}
.admin-sticky-action-bar.hidden {
  transform: translateY(100%);
}
@media (min-width: 992px) {
  .admin-sticky-action-bar {
    display: none;
  }
}

.admin-sticky-action-content {
  display: flex;
  gap: 0.75rem;
  max-width: 600px;
  margin: 0 auto;
}

.admin-sticky-action-primary {
  flex: 1 1;
}

.admin-sticky-action-secondary {
  flex-shrink: 0;
}

.has-sticky-action-bar {
  padding-bottom: calc(80px + env(safe-area-inset-bottom, 0)) !important;
}

.admin-status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 0.5rem;
}
.admin-status-dot.status-active {
  background: var(--vz-success);
  box-shadow: 0 0 0 3px rgba(var(--vz-success-rgb), 0.2);
}
.admin-status-dot.status-inactive {
  background: #adb5bd;
}
.admin-status-dot.status-pending {
  background: var(--vz-warning);
  animation: pulse 2s ease-in-out infinite;
}
.admin-status-dot.status-error {
  background: var(--vz-danger);
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.admin-quick-stats {
  display: flex;
  gap: 0.75rem;
  padding: 0.75rem 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.admin-quick-stats::-webkit-scrollbar {
  display: none;
}

.admin-stat-card {
  flex-shrink: 0;
  min-width: 140px;
  padding: 0.875rem 1rem;
  background: linear-gradient(135deg, rgba(var(--vz-primary-rgb), 0.1), rgba(var(--vz-primary-rgb), 0.05));
  border-radius: 0.75rem;
  border: 1px solid rgba(var(--vz-primary-rgb), 0.15);
}
.admin-stat-card.stat-success {
  background: linear-gradient(135deg, rgba(var(--vz-success-rgb), 0.1), rgba(var(--vz-success-rgb), 0.05));
  border-color: rgba(var(--vz-success-rgb), 0.15);
}
.admin-stat-card.stat-warning {
  background: linear-gradient(135deg, rgba(var(--vz-warning-rgb), 0.1), rgba(var(--vz-warning-rgb), 0.05));
  border-color: rgba(var(--vz-warning-rgb), 0.15);
}
.admin-stat-card.stat-danger {
  background: linear-gradient(135deg, rgba(var(--vz-danger-rgb), 0.1), rgba(var(--vz-danger-rgb), 0.05));
  border-color: rgba(var(--vz-danger-rgb), 0.15);
}

.admin-stat-label {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0.25rem;
}

.admin-stat-value {
  font-size: 1.375rem;
  font-weight: 700;
  color: var(--vz-primary);
  margin: 0;
}
.stat-success .admin-stat-value {
  color: var(--vz-success);
}
.stat-warning .admin-stat-value {
  color: var(--vz-warning);
}
.stat-danger .admin-stat-value {
  color: var(--vz-danger);
}

.admin-divider {
  height: 1px;
  background: var(--vz-border-color);
  margin: 1rem 0;
}
.admin-divider.divider-dashed {
  background: none;
  border-bottom: 1px dashed var(--vz-border-color);
}

.admin-text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-text-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.admin-text-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (hover: none) and (pointer: coarse) {
  .admin-card-item,
  .admin-action-btn,
  .admin-filter-toggle {
    -webkit-tap-highlight-color: rgba(var(--vz-primary-rgb), 0.1);
    -webkit-user-select: none;
            user-select: none;
  }
}
@supports (padding: env(safe-area-inset-bottom)) {
  .admin-sticky-action-bar {
    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom));
  }
}
@media (min-width: 992px) {
  .admin-table-container {
    max-height: calc(100vh - 280px);
    overflow-y: auto;
    position: relative;
  }
  .admin-table-container .table thead th {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
}
@media (min-width: 992px) and (prefers-color-scheme: dark) {
  .admin-table-container .table thead th {
    background: var(--vz-card-bg);
  }
}
@media (min-width: 768px) {
  .admin-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
  }
  .admin-table thead th {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
    color: #6c757d;
    padding: 0.875rem 1rem;
    border-bottom: 2px solid var(--vz-border-color);
  }
  .admin-table thead th.sortable {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: all 0.2s ease;
  }
  .admin-table thead th.sortable:hover {
    background: rgba(var(--vz-primary-rgb), 0.04);
    color: var(--vz-primary);
  }
  .admin-table thead th.sortable::after {
    content: "\\f0dc";
    font-family: "remixicon";
    margin-left: 0.5rem;
    opacity: 0.3;
    transition: opacity 0.2s ease;
  }
  .admin-table thead th.sortable.sort-asc::after {
    content: "\\f0de";
    opacity: 1;
    color: var(--vz-primary);
  }
  .admin-table thead th.sortable.sort-desc::after {
    content: "\\f0dd";
    opacity: 1;
    color: var(--vz-primary);
  }
  .admin-table tbody tr {
    border-bottom: 1px solid rgba(var(--vz-border-color), 0.5);
    transition: all 0.2s ease;
  }
  .admin-table tbody tr:hover {
    background: rgba(var(--vz-primary-rgb), 0.03);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transform: translateY(-1px);
  }
  .admin-table tbody tr:last-child {
    border-bottom: none;
  }
  .admin-table tbody tr td {
    padding: 1rem;
    color: #212529;
    font-size: 0.875rem;
    vertical-align: middle;
  }
  .admin-table tbody.table-striped tr:nth-child(even) {
    background: rgba(var(--vz-primary-rgb), 0.02);
  }
  .admin-table tbody.table-striped tr:nth-child(even):hover {
    background: rgba(var(--vz-primary-rgb), 0.05);
  }
  .admin-table tbody tr.selected {
    background: rgba(var(--vz-primary-rgb), 0.08);
  }
  .admin-table tbody tr.selected:hover {
    background: rgba(var(--vz-primary-rgb), 0.12);
  }
}
.admin-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}
@media (min-width: 1200px) {
  .admin-stats-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .admin-stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .admin-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.admin-stats-card {
  background: var(--vz-card-bg);
  border: 1px solid var(--vz-card-border-color);
  border-radius: 0.75rem;
  padding: 1.25rem;
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;
}
.admin-stats-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, var(--vz-primary), rgba(var(--vz-primary-rgb), 0.6));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}
@media (min-width: 768px) {
  .admin-stats-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  }
  .admin-stats-card:hover::before {
    transform: scaleX(1);
  }
}
.admin-stats-card .stats-icon {
  width: 48px;
  height: 48px;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  background: rgba(var(--vz-primary-rgb), 0.1);
  color: var(--vz-primary);
}
.admin-stats-card .stats-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #212529;
  margin-bottom: 0.25rem;
}
.admin-stats-card .stats-label {
  font-size: 0.8125rem;
  color: #6c757d;
  font-weight: 500;
}
.admin-stats-card .stats-change {
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: 0.5rem;
}
.admin-stats-card .stats-change.positive {
  color: var(--vz-success);
}
.admin-stats-card .stats-change.negative {
  color: var(--vz-danger);
}

.admin-form-grid {
  display: grid;
  gap: 1rem;
}
@media (min-width: 768px) {
  .admin-form-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }
}
.admin-form-grid .admin-form-field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}
.admin-form-grid .admin-form-field label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0;
}
.admin-form-grid .admin-form-field label .required {
  color: var(--vz-danger);
  margin-left: 0.25rem;
}
.admin-form-grid .admin-form-field input,
.admin-form-grid .admin-form-field select,
.admin-form-grid .admin-form-field textarea {
  padding: 0.625rem 0.875rem;
  font-size: 0.875rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  background: white;
}
.admin-form-grid .admin-form-field input:focus,
.admin-form-grid .admin-form-field select:focus,
.admin-form-grid .admin-form-field textarea:focus {
  outline: none;
  border-color: var(--vz-primary);
  box-shadow: 0 0 0 3px rgba(var(--vz-primary-rgb), 0.1);
}
.admin-form-grid .admin-form-field input:disabled,
.admin-form-grid .admin-form-field select:disabled,
.admin-form-grid .admin-form-field textarea:disabled {
  background: #f8f9fa;
  cursor: not-allowed;
  opacity: 0.7;
}
.admin-form-grid .admin-form-field input.is-invalid,
.admin-form-grid .admin-form-field select.is-invalid,
.admin-form-grid .admin-form-field textarea.is-invalid {
  border-color: var(--vz-danger);
}
.admin-form-grid .admin-form-field input.is-invalid:focus,
.admin-form-grid .admin-form-field select.is-invalid:focus,
.admin-form-grid .admin-form-field textarea.is-invalid:focus {
  box-shadow: 0 0 0 3px rgba(var(--vz-danger-rgb), 0.1);
}
.admin-form-grid .admin-form-field input.is-valid,
.admin-form-grid .admin-form-field select.is-valid,
.admin-form-grid .admin-form-field textarea.is-valid {
  border-color: var(--vz-success);
}
.admin-form-grid .admin-form-field input.is-valid:focus,
.admin-form-grid .admin-form-field select.is-valid:focus,
.admin-form-grid .admin-form-field textarea.is-valid:focus {
  box-shadow: 0 0 0 3px rgba(var(--vz-success-rgb), 0.1);
}
.admin-form-grid .admin-form-field textarea {
  min-height: 100px;
  resize: vertical;
}
.admin-form-grid .admin-form-field .field-hint {
  font-size: 0.75rem;
  color: #6c757d;
  margin-top: 0.25rem;
}
.admin-form-grid .admin-form-field .field-error {
  font-size: 0.75rem;
  color: var(--vz-danger);
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.admin-form-grid .admin-form-field .field-error i {
  font-size: 0.875rem;
}
.admin-form-grid .admin-form-field-full {
  grid-column: 1/-1;
}

.admin-btn-group {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
}
@media (min-width: 768px) {
  .admin-btn-group {
    gap: 0.75rem;
  }
}
.admin-btn-group.btn-group-end {
  justify-content: flex-end;
}
.admin-btn-group.btn-group-center {
  justify-content: center;
}
.admin-btn-group.btn-group-between {
  justify-content: space-between;
}
.admin-btn-group.btn-group-connected {
  gap: 0;
}
.admin-btn-group.btn-group-connected .admin-action-btn {
  border-radius: 0;
  margin-left: -1px;
}
.admin-btn-group.btn-group-connected .admin-action-btn:first-child {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  margin-left: 0;
}
.admin-btn-group.btn-group-connected .admin-action-btn:last-child {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.admin-btn-group.btn-group-connected .admin-action-btn:hover, .admin-btn-group.btn-group-connected .admin-action-btn:focus {
  z-index: 1;
}

.admin-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--vz-border-color);
}
@media (min-width: 992px) {
  .admin-page-header {
    margin-bottom: 2rem;
    padding-bottom: 1.25rem;
  }
}
.admin-page-header .header-left {
  flex: 1 1;
  min-width: 0;
}
.admin-page-header .header-left .page-breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.8125rem;
  color: #6c757d;
}
.admin-page-header .header-left .page-breadcrumb a {
  color: var(--vz-primary);
  text-decoration: none;
  transition: color 0.2s ease;
}
.admin-page-header .header-left .page-breadcrumb a:hover {
  color: rgba(var(--vz-primary-rgb), 0.8);
  text-decoration: underline;
}
.admin-page-header .header-left .page-breadcrumb .breadcrumb-separator {
  color: #adb5bd;
}
.admin-page-header .header-right {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}
@media (max-width: 767.98px) {
  .admin-page-header .header-right {
    width: 100%;
  }
}

.admin-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
  transition: all 0.2s ease;
}
.admin-badge i {
  font-size: 0.875rem;
}
.admin-badge.badge-primary {
  background: linear-gradient(135deg, rgba(var(--vz-primary-rgb), 0.15), rgba(var(--vz-primary-rgb), 0.1));
  color: var(--vz-primary);
  border: 1px solid rgba(var(--vz-primary-rgb), 0.2);
}
.admin-badge.badge-success {
  background: linear-gradient(135deg, rgba(var(--vz-success-rgb), 0.15), rgba(var(--vz-success-rgb), 0.1));
  color: var(--vz-success);
  border: 1px solid rgba(var(--vz-success-rgb), 0.2);
}
.admin-badge.badge-danger {
  background: linear-gradient(135deg, rgba(var(--vz-danger-rgb), 0.15), rgba(var(--vz-danger-rgb), 0.1));
  color: var(--vz-danger);
  border: 1px solid rgba(var(--vz-danger-rgb), 0.2);
}
.admin-badge.badge-warning {
  background: linear-gradient(135deg, rgba(var(--vz-warning-rgb), 0.15), rgba(var(--vz-warning-rgb), 0.1));
  color: #856404;
  border: 1px solid rgba(var(--vz-warning-rgb), 0.2);
}
.admin-badge.badge-info {
  background: linear-gradient(135deg, rgba(var(--vz-info-rgb), 0.15), rgba(var(--vz-info-rgb), 0.1));
  color: var(--vz-info);
  border: 1px solid rgba(var(--vz-info-rgb), 0.2);
}
.admin-badge.badge-dark {
  background: linear-gradient(135deg, rgba(33, 37, 41, 0.15), rgba(33, 37, 41, 0.1));
  color: #212529;
  border: 1px solid rgba(33, 37, 41, 0.2);
}
.admin-badge.badge-light {
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #dee2e6;
}
.admin-badge.badge-solid {
  border: none;
}
.admin-badge.badge-solid.badge-primary {
  background: var(--vz-primary);
  color: white;
}
.admin-badge.badge-solid.badge-success {
  background: var(--vz-success);
  color: white;
}
.admin-badge.badge-solid.badge-danger {
  background: var(--vz-danger);
  color: white;
}
.admin-badge.badge-solid.badge-warning {
  background: var(--vz-warning);
  color: #212529;
}
.admin-badge.badge-solid.badge-info {
  background: var(--vz-info);
  color: white;
}
.admin-badge.badge-pill {
  border-radius: 50rem;
}
.admin-badge.badge-dot::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  display: inline-block;
}

@media (min-width: 768px) {
  .admin-card-item,
  .admin-action-btn,
  .admin-table tbody tr,
  .admin-stats-card,
  .admin-badge {
    will-change: transform;
  }
  .admin-fade-in {
    animation: fadeIn 0.4s ease-out;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .admin-slide-in-right {
    animation: slideInRight 0.3s ease-out;
  }
  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateX(20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  .admin-scale-in {
    animation: scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
}
.admin-stagger-list > * {
  opacity: 0;
  animation: fadeIn 0.4s ease-out forwards;
}
.admin-stagger-list > *:nth-child(1) {
  animation-delay: 0.05s;
}
.admin-stagger-list > *:nth-child(2) {
  animation-delay: 0.1s;
}
.admin-stagger-list > *:nth-child(3) {
  animation-delay: 0.15s;
}
.admin-stagger-list > *:nth-child(4) {
  animation-delay: 0.2s;
}
.admin-stagger-list > *:nth-child(5) {
  animation-delay: 0.25s;
}
.admin-stagger-list > *:nth-child(6) {
  animation-delay: 0.3s;
}
.admin-stagger-list > *:nth-child(7) {
  animation-delay: 0.35s;
}
.admin-stagger-list > *:nth-child(8) {
  animation-delay: 0.4s;
}
.admin-stagger-list > *:nth-child(9) {
  animation-delay: 0.45s;
}
.admin-stagger-list > *:nth-child(10) {
  animation-delay: 0.5s;
}
.admin-stagger-list > *:nth-child(11) {
  animation-delay: 0.55s;
}
.admin-stagger-list > *:nth-child(12) {
  animation-delay: 0.6s;
}
.admin-stagger-list > *:nth-child(13) {
  animation-delay: 0.65s;
}
.admin-stagger-list > *:nth-child(14) {
  animation-delay: 0.7s;
}
.admin-stagger-list > *:nth-child(15) {
  animation-delay: 0.75s;
}
.admin-stagger-list > *:nth-child(16) {
  animation-delay: 0.8s;
}
.admin-stagger-list > *:nth-child(17) {
  animation-delay: 0.85s;
}
.admin-stagger-list > *:nth-child(18) {
  animation-delay: 0.9s;
}
.admin-stagger-list > *:nth-child(19) {
  animation-delay: 0.95s;
}
.admin-stagger-list > *:nth-child(20) {
  animation-delay: 1s;
}

.admin-spinner {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  border: 2px solid rgba(var(--vz-primary-rgb), 0.2);
  border-top-color: var(--vz-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
.admin-spinner.spinner-sm {
  width: 1rem;
  height: 1rem;
  border-width: 1.5px;
}
.admin-spinner.spinner-lg {
  width: 2.5rem;
  height: 2.5rem;
  border-width: 3px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.admin-smooth-scroll {
  scroll-behavior: smooth;
}
.admin-smooth-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.admin-smooth-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.admin-smooth-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.admin-smooth-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.admin-action-btn:focus-visible,
.admin-filter-toggle:focus-visible,
.admin-table thead th.sortable:focus-visible {
  outline: 2px solid var(--vz-primary);
  outline-offset: 2px;
}

@media print {
  .admin-action-btn,
  .admin-filter-section,
  .admin-page-actions,
  .admin-sticky-action-bar {
    display: none !important;
  }
  .admin-table-container {
    max-height: none !important;
    overflow: visible !important;
  }
  .admin-card-item {
    page-break-inside: avoid;
  }
}
:root {
  --vz-primary: #405189;
  --vz-primary-rgb: 64, 81, 137;
  --vz-secondary: #3577f1;
  --vz-secondary-rgb: 53, 119, 241;
  --vz-success: #0ab39c;
  --vz-success-rgb: 10, 179, 156;
  --vz-info: #299cdb;
  --vz-info-rgb: 41, 156, 219;
  --vz-warning: #f7b84b;
  --vz-warning-rgb: 247, 184, 75;
  --vz-danger: #f06548;
  --vz-danger-rgb: 240, 101, 72;
  --vz-light: #f3f6f9;
  --vz-dark: #212529;
  --vz-body-bg: #f3f3f9;
  --vz-body-color: #495057;
  --vz-card-bg: #ffffff;
  --vz-card-border-color: #e9ebec;
  --vz-vertical-menu-width: 250px;
  --vz-vertical-menu-width-md: 180px;
  --vz-vertical-menu-width-sm: 70px;
  --vz-vertical-menu-bg: #405189;
  --vz-vertical-menu-border: #405189;
  --vz-vertical-menu-item-color: rgba(255, 255, 255, 0.5);
  --vz-vertical-menu-item-hover-color: #ffffff;
  --vz-vertical-menu-item-active-color: #ffffff;
  --vz-vertical-menu-item-active-bg: rgba(255, 255, 255, 0.15);
  --vz-vertical-menu-sub-item-color: rgba(255, 255, 255, 0.5);
  --vz-vertical-menu-sub-item-hover-color: #ffffff;
  --vz-vertical-menu-title-color: rgba(255, 255, 255, 0.5);
  --vz-vertical-menu-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  --vz-sidebar-bg: var(--vz-vertical-menu-bg);
  --vz-sidebar-width: var(--vz-vertical-menu-width);
  --vz-sidebar-width-sm: var(--vz-vertical-menu-width-sm);
  --vz-sidebar-menu-item-color: var(--vz-vertical-menu-item-color);
  --vz-sidebar-menu-item-active-color: var(--vz-vertical-menu-item-active-color);
  --vz-header-height: 70px;
  --vz-header-bg: #ffffff;
  --vz-header-item-color: #495057;
  --vz-footer-height: 50px;
  --vz-border-color: #e9ebec;
  --vz-font-sans-serif: "Manrope", sans-serif;
}

html {
  background: white;
  height: 100%;
}

body {
  font-family: var(--vz-font-sans-serif);
  background-color: var(--vz-body-bg);
  background: white;
  color: var(--vz-body-color);
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.wrapper {
  display: flex;
  min-height: 100vh;
}

.app-header {
  position: fixed;
  top: 0;
  left: var(--vz-vertical-menu-width);
  right: 0;
  height: var(--vz-header-height);
  background-color: var(--vz-header-bg);
  border-bottom: 1px solid var(--vz-border-color);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  transition: all 0.1s ease-out;
}
@media (max-width: 991.98px) {
  .app-header {
    left: 0;
  }
}

.app-menu {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: var(--vz-vertical-menu-width);
  background: var(--vz-vertical-menu-bg);
  border-right: 1px solid var(--vz-vertical-menu-border);
  z-index: 1002;
  box-shadow: var(--vz-vertical-menu-box-shadow);
  transition: all 0.1s ease-out;
  display: flex;
  flex-direction: column;
  padding: 0 0 calc(var(--vz-header-height) + 25px) 0;
  overflow: hidden;
}
@media (max-width: 767.98px) {
  .app-menu {
    margin-left: -100%;
  }
  .vertical-sidebar-enable .app-menu {
    margin-left: 0;
  }
}
.app-menu .navbar-brand-box {
  height: var(--vz-header-height);
  min-height: var(--vz-header-height);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 1.3rem;
  transition: all 0.1s ease-out;
}
.app-menu .navbar-brand-box .logo {
  text-decoration: none;
  line-height: var(--vz-header-height);
  display: flex;
  align-items: center;
}
.app-menu .navbar-brand-box .logo .logo-lg {
  display: inline-block;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
}
.app-menu .navbar-brand-box .logo .logo-sm {
  display: none;
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
}
.app-menu .navbar-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1 1;
  overflow-y: auto;
}
.app-menu .navbar-nav .menu-title {
  padding: 12px 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--vz-vertical-menu-title-color);
  cursor: default;
}
.app-menu .navbar-nav .menu-title span {
  display: inline-block;
}
.app-menu .navbar-nav .menu-title i {
  display: none;
}
.app-menu .navbar-nav .nav-item .nav-link {
  display: flex;
  align-items: center;
  padding: 0.625rem 1.5rem;
  color: var(--vz-vertical-menu-item-color);
  font-size: 0.925rem;
  text-decoration: none;
  transition: all 0.15s ease;
  position: relative;
}
.app-menu .navbar-nav .nav-item .nav-link i {
  display: inline-block;
  min-width: 1.75rem;
  font-size: 18px;
  line-height: inherit;
}
.app-menu .navbar-nav .nav-item .nav-link svg {
  width: 18px;
  margin-right: 0.665rem;
  color: var(--vz-vertical-menu-item-color);
}
.app-menu .navbar-nav .nav-item .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color);
}
.app-menu .navbar-nav .nav-item .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color);
}
.app-menu .sidebar-background {
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: 50%;
  opacity: 0.07;
}

.navbar-menu .container-fluid {
  padding: 0;
}

.main-content {
  flex: 1 1;
  margin-left: var(--vz-vertical-menu-width);
  min-height: 100vh;
  transition: all 0.1s ease-out;
}
@media (max-width: 767.98px) {
  .main-content {
    margin-left: 0;
  }
}

.page-content {
  padding: calc(var(--vz-header-height) + 1.5rem) 1.5rem 1.5rem;
  min-height: 100vh;
}

.page-title-box {
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
}
.page-title-box h4 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0;
}

.footer {
  position: fixed;
  bottom: 0;
  left: var(--vz-vertical-menu-width);
  right: 0;
  height: var(--vz-footer-height);
  background-color: var(--vz-card-bg);
  border-top: 1px solid var(--vz-border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  color: var(--vz-body-color);
  transition: all 0.1s ease-out;
}
@media (max-width: 767.98px) {
  .footer {
    left: 0;
  }
}

@media (min-width: 768px) {
  [data-sidebar-size=sm-hover] .main-content {
    margin-left: var(--vz-vertical-menu-width-sm);
  }
  [data-sidebar-size=sm-hover] .app-header {
    left: var(--vz-vertical-menu-width-sm);
  }
  [data-sidebar-size=sm-hover] .footer {
    left: var(--vz-vertical-menu-width-sm);
  }
  [data-sidebar-size=sm-hover] .topnav-hamburger {
    display: none;
  }
  [data-sidebar-size=sm-hover] .app-menu {
    position: fixed !important;
    width: var(--vz-vertical-menu-width-sm);
    overflow: hidden !important;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-brand-box {
    padding: 0;
    justify-content: center;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-brand-box .logo {
    justify-content: center;
    width: 100%;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-brand-box .logo .logo-lg {
    display: none !important;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-brand-box .logo .logo-sm {
    display: block !important;
  }
  [data-sidebar-size=sm-hover] .app-menu .simplebar-scrollbar,
  [data-sidebar-size=sm-hover] .app-menu .simplebar-track {
    display: none !important;
  }
  [data-sidebar-size=sm-hover] .app-menu #scrollbar .simplebar-content-wrapper {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    scrollbar-width: none;
  }
  [data-sidebar-size=sm-hover] .app-menu #scrollbar .simplebar-content-wrapper::-webkit-scrollbar {
    display: none;
    width: 0;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .badge {
    display: none;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .menu-title {
    text-align: center;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .menu-title span {
    display: none;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .menu-title i {
    display: block;
    color: var(--vz-vertical-menu-item-color);
    line-height: 36px;
    font-size: 1rem;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .nav-link {
    justify-content: center;
    padding: 0.625rem 0;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .nav-link span {
    display: none;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .nav-link i {
    font-size: 22px;
    min-width: auto;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .nav-link svg {
    margin-right: 0;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .nav-link:after, [data-sidebar-size=sm-hover] .app-menu .navbar-nav .nav-link:before {
    display: none;
  }
  [data-sidebar-size=sm-hover] .app-menu .navbar-nav .menu-dropdown {
    display: none;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover {
    width: var(--vz-vertical-menu-width) !important;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .simplebar-scrollbar,
  [data-sidebar-size=sm-hover] .app-menu:hover .simplebar-track {
    display: block !important;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover #scrollbar .simplebar-content-wrapper {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    scrollbar-width: auto;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover #scrollbar .simplebar-content-wrapper::-webkit-scrollbar {
    display: block;
    width: auto;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .navbar-brand-box {
    justify-content: flex-start;
    padding: 0 1.3rem;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .navbar-brand-box .logo {
    justify-content: flex-start;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .navbar-brand-box .logo .logo-lg {
    display: inline-block !important;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .navbar-brand-box .logo .logo-sm {
    display: none !important;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .navbar-nav .menu-dropdown.show {
    display: block;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .navbar-nav .nav-link {
    justify-content: flex-start;
    padding: 0.625rem 1.5rem;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .navbar-nav .nav-link i {
    font-size: 18px;
    min-width: 1.75rem;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .navbar-nav .nav-link svg {
    margin-right: 0.665rem;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .navbar-nav .nav-link span, [data-sidebar-size=sm-hover] .app-menu:hover .navbar-nav .nav-link:after, [data-sidebar-size=sm-hover] .app-menu:hover .navbar-nav .nav-link:before {
    display: inline-block;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .menu-title {
    text-align: left;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .menu-title span {
    display: inline-block;
  }
  [data-sidebar-size=sm-hover] .app-menu:hover .menu-title i {
    display: none;
  }
}

@media (min-width: 768px) {
  [data-sidebar-size=sm] .main-content {
    margin-left: var(--vz-vertical-menu-width-sm);
  }
  [data-sidebar-size=sm] .app-header {
    left: var(--vz-vertical-menu-width-sm);
    z-index: 1003;
  }
  [data-sidebar-size=sm] .footer {
    left: var(--vz-vertical-menu-width-sm);
  }
  [data-sidebar-size=sm] .navbar-brand-box {
    position: fixed;
    padding: 0;
    width: var(--vz-vertical-menu-width-sm);
    z-index: 1;
    top: 0;
    background-color: var(--vz-vertical-menu-bg);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--vz-header-height);
  }
  [data-sidebar-size=sm] .navbar-brand-box .logo .logo-lg {
    display: none !important;
  }
  [data-sidebar-size=sm] .navbar-brand-box .logo .logo-sm {
    display: block !important;
  }
  [data-sidebar-size=sm] .app-menu {
    position: fixed !important;
    width: var(--vz-vertical-menu-width-sm) !important;
    padding-top: var(--vz-header-height);
  }
  [data-sidebar-size=sm] .app-menu .simplebar-mask,
  [data-sidebar-size=sm] .app-menu .simplebar-content-wrapper {
    overflow: visible !important;
  }
  [data-sidebar-size=sm] .app-menu .simplebar-scrollbar,
  [data-sidebar-size=sm] .app-menu .vertical-menu-btn {
    display: none !important;
  }
  [data-sidebar-size=sm] .app-menu .simplebar-offset {
    bottom: 0 !important;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .badge {
    display: none !important;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .menu-title {
    text-align: center;
    font-size: 1rem;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .menu-title span {
    display: none;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .menu-title i {
    display: block;
    line-height: 36px;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-link span {
    display: none;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-link i {
    font-size: 22px;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-link svg {
    margin-right: 0;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-link:after, [data-sidebar-size=sm] .app-menu .navbar-nav .nav-link:before {
    display: none;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .menu-dropdown {
    display: none;
    height: auto !important;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-item {
    position: relative;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-item:hover > a.menu-link {
    position: relative;
    width: calc(200px + var(--vz-vertical-menu-width-sm));
    transition: none;
    background-color: var(--vz-vertical-menu-bg);
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-item:hover > a.menu-link span {
    display: inline-block;
    padding-left: 25px;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-item:hover > a.menu-link:after {
    display: block;
    transform: rotate(90deg);
    color: #fff;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-item:hover .nav-link span {
    display: inline-block;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-item:hover > .menu-dropdown {
    display: block;
    left: var(--vz-vertical-menu-width-sm);
    position: absolute;
    width: 200px;
    background: var(--vz-vertical-menu-bg);
    height: auto !important;
    padding: 0.5rem 0;
    border-radius: 0 0 3px 3px;
    box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-sm {
    padding: 0;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
    color: var(--vz-vertical-menu-item-hover-color);
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
    color: inherit;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-sm .nav-link:after {
    display: block !important;
    transform: rotate(0deg) !important;
  }
  [data-sidebar-size=sm] .app-menu .navbar-nav .nav-sm .menu-dropdown {
    left: 100% !important;
    top: 0;
    border-radius: 3px !important;
  }
}

.hamburger-icon {
  width: 20px;
  height: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block;
}
.hamburger-icon span {
  background-color: var(--vz-header-item-color);
  position: absolute;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  width: 100%;
  height: 2px;
  display: block;
  left: 0;
}
.hamburger-icon span:nth-child(1) {
  top: 0;
  width: 100%;
}
.hamburger-icon span:nth-child(2) {
  top: 6px;
}
.hamburger-icon span:nth-child(3) {
  bottom: 0;
  width: 100%;
}
.hamburger-icon.open {
  transform: rotate(-90deg);
}
.hamburger-icon.open span:nth-child(1) {
  left: 1px;
  top: 5px;
  width: 20px;
  transform: rotate(90deg);
  transition-delay: 150ms;
}
.hamburger-icon.open span:nth-child(2) {
  left: 3px;
  top: 13px;
  width: 10px;
  transform: rotate(45deg);
  transition-delay: 50ms;
}
.hamburger-icon.open span:nth-child(3) {
  left: 9px;
  top: 13px;
  width: 10px;
  transform: rotate(-45deg);
  transition-delay: 100ms;
}

.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(1) {
  top: -1px;
}
.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(3) {
  bottom: -1px;
}

.vertical-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 37, 41, 0.35);
  z-index: 1003;
  display: none;
}

.vertical-sidebar-enable .vertical-overlay {
  display: block;
}
.vertical-sidebar-enable .app-menu {
  margin-left: 0 !important;
  z-index: 1004;
}

.card {
  border: 1px solid var(--vz-card-border-color);
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  margin-bottom: 1.5rem;
  background-color: var(--vz-card-bg);
}
.card .card-header {
  background-color: transparent;
  border-bottom: 1px solid var(--vz-border-color);
  padding: 1rem 1.25rem;
}
.card .card-header .card-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0;
}
.card .card-body {
  padding: 1.25rem;
}

.card-animate {
  transition: all 0.3s ease;
}
.card-animate:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(56, 65, 74, 0.15);
}

.bg-primary-subtle {
  background-color: rgba(var(--vz-primary-rgb), 0.1) !important;
}

.bg-success-subtle {
  background-color: rgba(var(--vz-success-rgb), 0.1) !important;
}

.bg-warning-subtle {
  background-color: rgba(var(--vz-warning-rgb), 0.1) !important;
}

.bg-danger-subtle {
  background-color: rgba(var(--vz-danger-rgb), 0.1) !important;
}

.bg-info-subtle {
  background-color: rgba(var(--vz-info-rgb), 0.1) !important;
}

.text-primary {
  color: var(--vz-primary) !important;
}

.text-success {
  color: var(--vz-success) !important;
}

.text-warning {
  color: var(--vz-warning) !important;
}

.text-danger {
  color: var(--vz-danger) !important;
}

.text-info {
  color: var(--vz-info) !important;
}

.avatar-sm {
  width: 2rem;
  height: 2rem;
}

.avatar-lg {
  width: 4rem;
  height: 4rem;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 500;
  border-radius: 0.25rem;
}

.table th {
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.03rem;
  color: #878a99;
  border-bottom-width: 1px;
}
.table td {
  vertical-align: middle;
  padding: 0.75rem;
}

.table-hover tbody tr:hover {
  background-color: rgba(var(--vz-primary-rgb), 0.04);
}

.badge {
  font-weight: 500;
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
}

.nav-tabs-custom {
  border-bottom: 1px solid var(--vz-border-color);
}
.nav-tabs-custom .nav-link {
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--vz-body-color);
  padding: 0.75rem 1rem;
  font-weight: 500;
  background: none;
}
.nav-tabs-custom .nav-link:hover {
  border-color: transparent;
  color: var(--vz-primary);
}
.nav-tabs-custom .nav-link.active {
  color: var(--vz-primary);
  border-bottom-color: var(--vz-primary);
  background-color: transparent;
}

.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--vz-primary) 0%, #364574 100%);
  padding: 2rem;
}
.auth-page .auth-card {
  width: 100%;
  max-width: 420px;
}
.auth-page .auth-card .card {
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  border-radius: 0.75rem;
}
.auth-page .auth-card .auth-logo {
  text-align: center;
  margin-bottom: 1.5rem;
}
.auth-page .auth-card .auth-logo h4 {
  color: var(--vz-primary);
  font-weight: 700;
  font-size: 1.5rem;
}
.auth-page .auth-card .auth-logo p {
  color: #878a99;
  margin-bottom: 0;
}

.dropdown-menu {
  font-size: 0.875rem;
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0.375rem;
}
.dropdown-menu .dropdown-item {
  padding: 0.5rem 1rem;
}
.dropdown-menu .dropdown-item:hover, .dropdown-menu .dropdown-item:focus {
  background-color: rgba(var(--vz-primary-rgb), 0.1);
}
.dropdown-menu .dropdown-divider {
  border-color: var(--vz-border-color);
}

.user-dropdown .dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 0.375rem;
  background: none;
  border: none;
  cursor: pointer;
}
.user-dropdown .dropdown-toggle:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.user-dropdown .dropdown-toggle::after {
  display: none;
}
.user-dropdown .dropdown-toggle .user-avatar {
  width: 36px;
  height: 36px;
  background-color: var(--vz-primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
}
.user-dropdown .dropdown-toggle .user-info {
  text-align: left;
}
.user-dropdown .dropdown-toggle .user-info .user-name {
  display: block;
  font-weight: 600;
  font-size: 0.875rem;
  color: #212529;
  margin: 0;
  line-height: 1.3;
}
.user-dropdown .dropdown-toggle .user-info .user-role {
  display: block;
  font-size: 0.75rem;
  color: #878a99;
  margin: 0;
  line-height: 1.3;
}

.fs-22 {
  font-size: 22px !important;
}

.fs-24 {
  font-size: 24px !important;
}

.spinner-border {
  width: 1.5rem;
  height: 1.5rem;
}

.simplebar-scrollbar::before {
  background-color: rgba(255, 255, 255, 0.4);
}

.form-control:focus,
.form-select:focus {
  border-color: var(--vz-primary);
  box-shadow: 0 0 0 0.15rem rgba(var(--vz-primary-rgb), 0.15);
}

.menu-link {
  text-decoration: none;
}

.forman-layout {
  height: var(--app-height, 100vh);
  background: linear-gradient(180deg, #f8f9fa 0%, #f0f2f5 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overscroll-behavior: none;
}

.forman-header {
  background: var(--vz-primary);
  padding: 1rem 1.5rem;
  padding-top: calc(1rem + env(safe-area-inset-top, 0px));
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.forman-header .forman-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 600px;
  margin: 0 auto;
}
.forman-header .forman-logo .logo-text {
  color: white;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: 0.05rem;
}
.forman-header .user-dropdown .dropdown-toggle {
  padding: 0;
  background: none;
  border: none;
}
.forman-header .user-dropdown .dropdown-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}
.forman-header .user-dropdown .dropdown-toggle .user-avatar {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 1rem;
}

.forman-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.forman-dashboard {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 2rem 1.5rem;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
}

.forman-welcome {
  text-align: center;
  margin-bottom: 2rem;
}
.forman-welcome h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #212529;
  margin-bottom: 0.5rem;
}
.forman-welcome p {
  color: #6c757d;
  font-size: 1rem;
  margin: 0;
}

.forman-modules {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1 1;
}

.forman-module-card {
  display: flex;
  align-items: center;
  background: white;
  border: none;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
  width: 100%;
}
.forman-module-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}
.forman-module-card:active {
  transform: translateY(0);
}
.forman-module-card .module-icon {
  width: 64px;
  height: 64px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.forman-module-card .module-icon i {
  font-size: 2rem;
  color: white;
}
.forman-module-card .module-content {
  flex: 1 1;
  margin-left: 1rem;
}
.forman-module-card .module-content h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #212529;
  margin: 0 0 0.25rem;
}
.forman-module-card .module-content p {
  font-size: 0.875rem;
  color: #6c757d;
  margin: 0;
}
.forman-module-card .module-arrow {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.forman-module-card .module-arrow i {
  font-size: 1.25rem;
  color: #6c757d;
}
.forman-module-card.forman-module-qr .module-icon {
  background: linear-gradient(135deg, #3577f1 0%, #2962d9 100%);
}
.forman-module-card.forman-module-qr:hover .module-arrow {
  background: rgba(53, 119, 241, 0.1);
}
.forman-module-card.forman-module-qr:hover .module-arrow i {
  color: #3577f1;
}
.forman-module-card.forman-module-daily .module-icon {
  background: linear-gradient(135deg, #0ab39c 0%, #099885 100%);
}
.forman-module-card.forman-module-daily:hover .module-arrow {
  background: rgba(10, 179, 156, 0.1);
}
.forman-module-card.forman-module-daily:hover .module-arrow i {
  color: #0ab39c;
}

.forman-date {
  text-align: center;
  margin-top: 2rem;
  padding: 1rem;
  color: #6c757d;
  font-size: 0.875rem;
}
.forman-date i {
  font-size: 1rem;
}

@media (max-width: 575.98px) {
  .forman-header {
    padding: 0.875rem 1rem;
    padding-top: calc(0.875rem + env(safe-area-inset-top, 0px));
  }
  .forman-dashboard {
    padding: 1.5rem 1rem;
  }
  .forman-welcome {
    margin-bottom: 1.5rem;
  }
  .forman-welcome h1 {
    font-size: 1.5rem;
  }
  .forman-module-card {
    padding: 1.25rem;
  }
  .forman-module-card .module-icon {
    width: 56px;
    height: 56px;
  }
  .forman-module-card .module-icon i {
    font-size: 1.75rem;
  }
  .forman-module-card .module-content h2 {
    font-size: 1.1rem;
  }
  .forman-module-card .module-content p {
    font-size: 0.8rem;
  }
}
.forman-page {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  background: #f5f6f8;
  overflow: hidden;
}

.forman-page-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: white;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0;
  z-index: 10;
}
.forman-page-header .back-btn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f0f0f5;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.forman-page-header .back-btn:active {
  transform: scale(0.92);
  background: #e4e4ea;
}
.forman-page-header .back-btn i {
  font-size: 1.25rem;
  color: #333;
}
.forman-page-header h1 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #212529;
  margin: 0;
  flex: 1 1;
}

.forman-page-content {
  flex: 1 1;
  min-height: 0;
  padding: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: none;
}

.forman-field {
  margin-bottom: 0.75rem;
}
.forman-field label {
  display: block;
  font-size: 0.7rem;
  font-weight: 600;
  color: #868e96;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.forman-field-row {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.forman-field-row .flex-1 {
  flex: 1 1;
}

.forman-input,
.forman-select,
.forman-textarea {
  width: 100%;
  padding: 0.625rem 0.75rem;
  font-size: 0.9375rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background: white;
  transition: border-color 0.15s ease;
  -webkit-appearance: none;
  color: #212529;
}
.forman-input:focus,
.forman-select:focus,
.forman-textarea:focus {
  outline: none;
  border-color: var(--vz-primary);
}
.forman-input::placeholder,
.forman-select::placeholder,
.forman-textarea::placeholder {
  color: #adb5bd;
}

.forman-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1.25rem;
  padding-right: 2.25rem;
}

.forman-textarea {
  resize: none;
  min-height: 70px;
}

.forman-qr-area {
  position: relative;
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  margin: 1rem 0;
  text-align: center;
}

.forman-qr-reader {
  display: none;
  width: 100%;
  max-width: 300px;
  margin: 0 auto 1rem;
  border-radius: 0.75rem;
  overflow: hidden;
}
.forman-qr-reader.active {
  display: block;
}

.forman-qr-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem;
  background: linear-gradient(135deg, #3577f1 0%, #2962d9 100%);
  border: none;
  border-radius: 1rem;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}
.forman-qr-button:hover:not(:disabled) {
  transform: scale(1.02);
  box-shadow: 0 8px 25px rgba(53, 119, 241, 0.3);
}
.forman-qr-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.forman-qr-button i {
  font-size: 3rem;
  margin-bottom: 0.75rem;
}
.forman-qr-button span {
  font-size: 1.1rem;
  font-weight: 600;
}

.forman-qr-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  padding: 0.5rem 1rem;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 2rem;
  color: white;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  z-index: 10;
  backdrop-filter: blur(4px);
}
.forman-qr-close i {
  font-size: 1.1rem;
}
.forman-qr-close:active {
  background: rgba(0, 0, 0, 0.8);
}

.forman-qr-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.25rem;
  gap: 0.75rem;
}

.forman-qr-result-icon {
  width: 3.5rem;
  height: 3.5rem;
  background: linear-gradient(135deg, #0ab39c 0%, #099885 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(10, 179, 156, 0.3);
}
.forman-qr-result-icon i {
  font-size: 1.75rem;
  color: white;
}

.forman-qr-result-text {
  text-align: center;
}
.forman-qr-result-text strong {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #0ab39c;
  margin-bottom: 0.25rem;
}
.forman-qr-result-text span {
  display: block;
  font-size: 0.8rem;
  color: #6c757d;
  word-break: break-all;
  max-width: 200px;
}

.forman-qr-retry {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #405189 0%, #354370 100%);
  border: none;
  border-radius: 2rem;
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 0.5rem;
  box-shadow: 0 2px 8px rgba(64, 81, 137, 0.25);
  transition: transform 0.15s, box-shadow 0.15s;
}
.forman-qr-retry i {
  font-size: 1.1rem;
}
.forman-qr-retry:active {
  transform: scale(0.97);
  box-shadow: 0 1px 4px rgba(64, 81, 137, 0.2);
}

.forman-photos {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.forman-photo-item {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.forman-photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.forman-photo-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.forman-photo-remove i {
  font-size: 0.875rem;
}
.forman-photo-remove:active {
  background: rgba(0, 0, 0, 0.8);
}

.forman-photo-add {
  width: 72px;
  height: 72px;
  border: 2px dashed #ced4da;
  border-radius: 0.75rem;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.forman-photo-add i {
  font-size: 1.5rem;
  color: #6c757d;
}
.forman-photo-add span {
  font-size: 0.7rem;
  color: #6c757d;
  font-weight: 500;
}
.forman-photo-add:active {
  background: #e9ecef;
  border-color: #adb5bd;
}

.forman-tabs {
  display: flex;
  background: #e9ecef;
  border-radius: 0.5rem;
  padding: 3px;
  margin-bottom: 0.75rem;
}

.forman-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.5rem 0.625rem;
  background: transparent;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  transition: all 0.15s ease;
}
.forman-tab.active {
  background: white;
  color: #212529;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.forman-tab i {
  font-size: 0.9375rem;
}

.forman-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0 0.3rem;
  background: var(--vz-primary);
  color: white;
  border-radius: 0.75rem;
  font-size: 0.65rem;
  font-weight: 700;
}
.forman-tab:not(.active) .forman-tab-badge {
  background: #6c757d;
}

.forman-tab-dot {
  width: 6px;
  height: 6px;
  background: var(--vz-success);
  border-radius: 50%;
  margin-left: 4px;
}

.forman-stepper {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 0;
  margin-bottom: 0.5rem;
}

.forman-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  flex: 1 1;
  position: relative;
}
.forman-step:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 14px;
  left: calc(50% + 16px);
  width: calc(100% - 32px);
  height: 2px;
  background: #dee2e6;
}
.forman-step.completed:not(:last-child)::after {
  background: var(--vz-success);
}

.forman-step-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  background: #e9ecef;
  color: #6c757d;
  position: relative;
  z-index: 1;
  transition: all 0.2s ease;
}
.forman-step.active .forman-step-dot {
  background: var(--vz-primary);
  color: white;
  box-shadow: 0 0 0 4px rgba(64, 81, 137, 0.2);
}
.forman-step.completed .forman-step-dot {
  background: var(--vz-success);
  color: white;
}
.forman-step.completed .forman-step-dot i {
  font-size: 0.875rem;
}

.forman-step-label {
  font-size: 0.6875rem;
  font-weight: 500;
  color: #6c757d;
  text-align: center;
}
.forman-step.active .forman-step-label {
  color: var(--vz-primary);
  font-weight: 600;
}
.forman-step.completed .forman-step-label {
  color: var(--vz-success);
}

.forman-step-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1rem;
  height: 1rem;
  padding: 0 0.25rem;
  margin-left: 0.25rem;
  background: var(--vz-primary);
  color: white;
  border-radius: 0.5rem;
  font-size: 0.5625rem;
  font-weight: 700;
}
.forman-step.completed .forman-step-count {
  background: var(--vz-success);
}

.forman-step-title {
  text-align: center;
  margin-bottom: 1rem;
}
.forman-step-title h2 {
  font-size: 1.125rem;
  font-weight: 700;
  color: #212529;
  margin: 0 0 0.25rem;
}

.forman-step-subtitle {
  font-size: 0.8125rem;
  color: #6c757d;
}

.forman-locked-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 250px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 1rem;
  margin-top: 0.5rem;
}

.forman-locked-content {
  text-align: center;
  padding: 2rem;
}
.forman-locked-content i {
  font-size: 3rem;
  color: #adb5bd;
  margin-bottom: 1rem;
  display: block;
}
.forman-locked-content p {
  font-size: 1rem;
  color: #6c757d;
  margin: 0 0 1.25rem;
  font-weight: 500;
}

.forman-btn-select-site {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: var(--vz-primary);
  border: none;
  border-radius: 0.5rem;
  color: white;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}
.forman-btn-select-site:active {
  transform: scale(0.96);
}
.forman-btn-select-site i {
  font-size: 1.125rem;
  margin: 0;
  color: white;
}

.forman-record-exists h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #495057;
  margin: 0.75rem 0 0.5rem;
}
.forman-record-exists p {
  font-size: 0.9375rem;
  color: #6c757d;
  margin: 0 0 1rem;
  font-weight: 400;
}
.forman-record-exists p strong {
  color: #495057;
}
.forman-record-exists > i {
  font-size: 3.5rem;
  color: #f59e0b;
  margin-bottom: 0.5rem;
}

.forman-record-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}
.forman-record-info span {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.875rem;
  color: #6c757d;
}
.forman-record-info span i {
  font-size: 1rem;
  color: #6c757d;
  margin: 0;
}

.forman-record-locked-badge {
  background: #fef3c7;
  color: #92400e;
  padding: 0.25rem 0.625rem;
  border-radius: 1rem;
  font-weight: 500;
}
.forman-record-locked-badge i {
  color: #f59e0b !important;
}

.forman-record-hint {
  font-size: 0.8125rem !important;
  color: #9ca3af !important;
  font-style: italic;
}

.forman-record-actions {
  display: flex;
  gap: 0.625rem;
  justify-content: center;
  margin-top: 1.25rem;
}

.forman-locked-action-btn {
  flex: 1 1;
  padding: 0.625rem 1rem;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  transition: all 0.15s ease;
}
.forman-locked-action-btn:active {
  transform: scale(0.97);
  background: #f3f4f6;
}

.forman-btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.625rem 1rem;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}
.forman-btn-outline:active {
  transform: scale(0.97);
  background: #f8f9fa;
}
.forman-btn-outline i {
  font-size: 1rem;
  margin: 0;
  color: inherit;
}

.forman-missing-days-banner {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  background: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 0.75rem;
  padding: 0.875rem 1rem;
  margin-bottom: 1rem;
}
.forman-missing-days-banner strong {
  display: block;
  color: #92400e;
  font-size: 0.9375rem;
}
.forman-missing-days-banner p {
  color: #78350f;
}

.forman-missing-days-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.forman-missing-date-badge {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  background: #fff;
  border: 1px solid #fbbf24;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #92400e;
}
.forman-missing-date-badge i {
  font-size: 1.125rem;
  color: #f59e0b;
  margin: 0;
}

.forman-no-work-bar {
  padding: 0 1rem 0.5rem;
}

.forman-no-work-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.625rem 1rem;
  background: #fff1f2;
  border: 1.5px dashed #fda4af;
  border-radius: 0.625rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #be123c;
  cursor: pointer;
  transition: all 0.15s ease;
}
.forman-no-work-btn:active {
  transform: scale(0.98);
  background: #ffe4e6;
  border-color: #fb7185;
}
.forman-no-work-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.forman-no-work-btn i {
  font-size: 1.125rem;
  color: #e11d48;
  margin: 0;
}

.forman-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.forman-select-personnel-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.875rem 1rem;
  background: white;
  border: 1.5px dashed #ced4da;
  border-radius: 0.625rem;
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--vz-primary);
  margin-bottom: 0.75rem;
  transition: all 0.15s ease;
}
.forman-select-personnel-btn:active {
  background: #f0f7ff;
  border-color: var(--vz-primary);
}
.forman-select-personnel-btn > i:first-child {
  font-size: 1.25rem;
}
.forman-select-personnel-btn > span {
  flex: 1 1;
  text-align: left;
}
.forman-select-personnel-btn > i:last-child {
  font-size: 1.25rem;
  color: #adb5bd;
}

.forman-select-personnel-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 0.375rem;
  border-radius: 999px;
  background: var(--vz-primary);
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
}

.forman-remove-btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-radius: 50%;
  color: #adb5bd;
  cursor: pointer;
  margin-left: auto;
}
.forman-remove-btn:active {
  background: #fee2e2;
  color: #dc3545;
}
.forman-remove-btn i {
  font-size: 1.125rem;
}

.forman-group-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 0.5rem 0 0.25rem;
}
.forman-group-label:not(:first-child) {
  margin-top: 0.5rem;
}

.forman-list-item {
  background: white;
  border-radius: 0.625rem;
  overflow: hidden;
  border: 1px solid #e9ecef;
}
.forman-list-item.selected {
  border-color: var(--vz-primary);
  background: #f8faff;
}
.forman-list-item.disabled {
  opacity: 0.55;
  pointer-events: none;
  background: #f9fafb;
}

.forman-status-badge {
  flex-shrink: 0;
  font-size: 0.6875rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 1rem;
  margin-left: auto;
}
.forman-status-badge--leave {
  background: #dbeafe;
  color: #1e40af;
}
.forman-status-badge--report {
  background: #fef3c7;
  color: #92400e;
}

.forman-list-item-main {
  display: flex;
  align-items: center;
  padding: 0.875rem;
  cursor: pointer;
}
.forman-list-item-main:active {
  background: #f8f9fa;
}

.forman-list-item-check {
  margin-right: 0.75rem;
  flex-shrink: 0;
}
.forman-list-item-check i {
  font-size: 1.375rem;
  color: #ced4da;
}
.forman-list-item-check i.ri-checkbox-circle-fill {
  color: var(--vz-primary);
}

.forman-list-item-info {
  flex: 1 1;
  min-width: 0;
}
.forman-list-item-info strong {
  display: block;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.125rem;
}
.forman-list-item-info span {
  display: block;
  font-size: 0.8125rem;
  color: #6c757d;
}

.forman-list-item-options {
  padding: 0.625rem 0.875rem;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}
.forman-list-item-options label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #868e96;
  margin-bottom: 0.375rem;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.forman-wage-buttons,
.forman-usage-buttons {
  display: flex;
  gap: 0.375rem;
}

.forman-wage-btn,
.forman-usage-btn {
  flex: 1 1;
  min-height: 44px;
  padding: 0.5rem 0.625rem;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #495057;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.forman-wage-btn:active,
.forman-usage-btn:active {
  transform: scale(0.96);
}
.forman-wage-btn.active,
.forman-usage-btn.active {
  background: var(--vz-primary);
  border-color: var(--vz-primary);
  color: white;
}

.forman-work-options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.forman-work-input {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.forman-work-input label {
  flex-shrink: 0;
  margin-bottom: 0;
  min-width: 100px;
}
.forman-work-input input {
  flex: 1 1;
  max-width: 150px;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  border: 2px solid #dee2e6;
  border-radius: 0.5rem;
  background: white;
  color: var(--vz-primary);
}
.forman-work-input input:focus {
  outline: none;
  border-color: var(--vz-primary);
  box-shadow: 0 0 0 3px rgba(64, 81, 137, 0.15);
}
.forman-work-input input::placeholder {
  color: #adb5bd;
}

.forman-work-remaining {
  font-size: 0.8125rem;
  color: #6c757d;
  padding-left: 0.25rem;
}

.forman-vehicle-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.forman-vehicle-option-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.forman-vehicle-option-row label {
  flex-shrink: 0;
  margin-bottom: 0;
  min-width: 70px;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #6c757d;
}
.forman-vehicle-option-row .forman-usage-buttons {
  flex: 1 1;
}

.forman-select {
  flex: 1 1;
  min-width: 140px;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background: white;
  color: #495057;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 12px;
  padding-right: 2rem;
}
.forman-select:focus {
  outline: none;
  border-color: var(--vz-primary);
  box-shadow: 0 0 0 2px rgba(64, 81, 137, 0.15);
}

.forman-driver-hint {
  font-size: 0.75rem;
  color: #6c757d;
  font-style: italic;
  width: 100%;
  margin-top: 0.25rem;
}

.forman-driver-row {
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.forman-photo-count {
  margin-left: auto;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--vz-primary);
  background: rgba(64, 81, 137, 0.1);
  padding: 0.125rem 0.5rem;
  border-radius: 1rem;
}

.forman-photo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.forman-photo-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 0.5rem;
  overflow: hidden;
  background: #f8f9fa;
}
.forman-photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.forman-photo-remove {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  width: 1.5rem;
  height: 1.5rem;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.forman-photo-remove i {
  color: white;
  font-size: 0.875rem;
}
.forman-photo-remove:active {
  transform: scale(0.9);
}

.forman-photo-actions {
  display: flex;
  gap: 0.75rem;
}

.forman-photo-btn {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  padding: 1rem;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.15s ease;
}
.forman-photo-btn i {
  font-size: 1.5rem;
  color: #6c757d;
}
.forman-photo-btn span {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #6c757d;
}
.forman-photo-btn:active {
  transform: scale(0.98);
  background: #e9ecef;
  border-color: var(--vz-primary);
}
.forman-photo-btn:active i, .forman-photo-btn:active span {
  color: var(--vz-primary);
}

.forman-driver-trigger {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.625rem 0.875rem;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.15s ease;
}
.forman-driver-trigger span {
  flex: 1 1;
  text-align: left;
}
.forman-driver-trigger .ri-user-line {
  font-size: 1rem;
  color: #adb5bd;
}
.forman-driver-trigger .ri-arrow-down-s-line {
  font-size: 1.125rem;
  color: #adb5bd;
}
.forman-driver-trigger:active {
  transform: scale(0.98);
  background: #f8f9fa;
}
.forman-driver-trigger.has-value {
  color: #212529;
  border-color: var(--vz-primary);
  background: rgba(64, 81, 137, 0.05);
}
.forman-driver-trigger.has-value .ri-user-line {
  color: var(--vz-primary);
}

.forman-notes-section {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 0.5rem 0;
}
.forman-notes-section .forman-field {
  background: white;
  border-radius: 0.75rem;
  padding: 1rem;
  border: 1px solid #e9ecef;
}
.forman-notes-section .forman-field label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.75rem;
}
.forman-notes-section .forman-field label i {
  font-size: 1rem;
  color: var(--vz-primary);
}

.forman-textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  font-size: 0.9375rem;
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.forman-textarea:focus {
  outline: none;
  border-color: var(--vz-primary);
  box-shadow: 0 0 0 3px rgba(64, 81, 137, 0.15);
}
.forman-textarea::placeholder {
  color: #adb5bd;
}

.forman-field-hint {
  font-size: 0.8125rem;
  color: #868e96;
  margin: 0;
  font-style: italic;
}

.forman-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #6c757d;
}
.forman-empty i {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}
.forman-empty p {
  margin: 0;
}

.forman-bottom-actions {
  flex-shrink: 0;
  background: white;
  padding: 0.75rem 1rem;
  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  z-index: 100;
  transition: opacity 0.15s ease, visibility 0.15s ease;
}
.forman-bottom-actions.sheet-open {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.forman-summary {
  display: flex;
  justify-content: center;
  gap: 1rem;
  font-size: 0.8125rem;
  color: #6c757d;
}
.forman-summary span {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.forman-summary i {
  font-size: 0.9375rem;
}

.forman-btn-primary {
  width: 100%;
  padding: 0.75rem;
  background: var(--vz-primary);
  border: none;
  border-radius: 0.5rem;
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
}
.forman-btn-primary:active:not(:disabled) {
  transform: scale(0.98);
  opacity: 0.9;
}
.forman-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.forman-btn-primary i {
  font-size: 1rem;
}

.forman-btn-secondary {
  padding: 0.75rem 1.25rem;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  color: #495057;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
}
.forman-btn-secondary:active {
  transform: scale(0.98);
  background: #f8f9fa;
}
.forman-btn-secondary i {
  font-size: 1rem;
}

.forman-wizard-actions {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0));
}
.forman-wizard-actions .forman-btn-primary {
  width: auto;
  padding: 0.75rem 1.5rem;
}

.forman-summary-mini {
  display: flex;
  gap: 0.75rem;
  font-size: 0.75rem;
  color: #868e96;
}
.forman-summary-mini span {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.forman-summary-mini i {
  font-size: 0.875rem;
}

.bottom-sheet-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: flex-end;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
.bottom-sheet {
  width: 100%;
  max-height: 70vh;
  background: white;
  border-radius: 1rem 1rem 0 0;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}
.bottom-sheet:not(:has(.bottom-sheet-footer)) {
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.bottom-sheet-handle {
  width: 36px;
  height: 4px;
  background: #dee2e6;
  border-radius: 2px;
  margin: 0.75rem auto 0;
  flex-shrink: 0;
}

.bottom-sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem 0.75rem;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0;
}
.bottom-sheet-header h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
  margin: 0;
}

.bottom-sheet-close {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #f3f3f9;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.bottom-sheet-close:active {
  background: #e9ecef;
}
.bottom-sheet-close i {
  font-size: 1.25rem;
  color: #6c757d;
}

.bottom-sheet-content {
  flex: 1 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.bottom-sheet-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #6c757d;
}
.bottom-sheet-empty i {
  font-size: 2.5rem;
  margin-bottom: 0.75rem;
  opacity: 0.5;
}
.bottom-sheet-empty p {
  margin: 0;
  font-size: 0.9375rem;
}

.bottom-sheet-options {
  padding: 0.5rem 0;
}

.bottom-sheet-option {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}
.bottom-sheet-option:active {
  background: #f8f9fa;
}
.bottom-sheet-option.selected {
  background: #f0f7ff;
}

.bottom-sheet-option-content {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  flex: 1 1;
  min-width: 0;
}

.bottom-sheet-option-label {
  font-size: 0.9375rem;
  font-weight: 500;
  color: #212529;
}
.selected .bottom-sheet-option-label {
  color: var(--vz-primary);
}

.bottom-sheet-option-sublabel {
  font-size: 0.8125rem;
  color: #6c757d;
}

.bottom-sheet-option-check {
  font-size: 1.25rem;
  color: var(--vz-primary);
  flex-shrink: 0;
  margin-left: 0.75rem;
}

.bottom-sheet-search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 1rem 0.75rem;
  border-bottom: 1px solid #f2f4f7;
}
.bottom-sheet-search i {
  color: #98a2b3;
  font-size: 1.1rem;
  flex-shrink: 0;
}
.bottom-sheet-search input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 1rem;
  padding: 0.5rem 0;
  background: transparent;
}
.bottom-sheet-search input::placeholder {
  color: #adb5bd;
}
.bottom-sheet-search button {
  background: none;
  border: none;
  padding: 0.25rem;
  color: #98a2b3;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.bottom-sheet-search button:hover {
  color: #495057;
}

.bottom-sheet-group-header {
  padding: 0.625rem 1rem 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6c757d;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}
.bottom-sheet-group-header:first-child {
  border-top: none;
}

.bottom-sheet-option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.bottom-sheet-option-check-left {
  flex-shrink: 0;
  margin-right: 0.75rem;
  font-size: 1.25rem;
  color: #adb5bd;
  display: flex;
  align-items: center;
}
.selected .bottom-sheet-option-check-left {
  color: var(--vz-primary);
}
.disabled .bottom-sheet-option-check-left {
  color: #dc3545;
}

.bottom-sheet-option-badge {
  flex-shrink: 0;
  margin-left: 0.5rem;
  padding: 0.125rem 0.5rem;
  font-size: 0.6875rem;
  font-weight: 500;
  border-radius: 999px;
  background: #fff3cd;
  color: #856404;
}

.bottom-sheet-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-top: 1px solid #e9ecef;
  flex-shrink: 0;
  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0));
}

.bottom-sheet-footer-count {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
}

.bottom-sheet-footer-btn {
  padding: 0.5rem 1.5rem;
  background: var(--vz-primary);
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
}
.bottom-sheet-footer-btn:active {
  opacity: 0.85;
}

.forman-select-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 0.75rem;
  font-size: 0.9375rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background: white;
  cursor: pointer;
  transition: border-color 0.15s ease;
  text-align: left;
}
.forman-select-trigger:active {
  border-color: var(--vz-primary);
}
.forman-select-trigger.has-value {
  color: #212529;
}
.forman-select-trigger.placeholder {
  color: #adb5bd;
}
.forman-select-trigger i {
  font-size: 1.125rem;
  color: #6c757d;
  flex-shrink: 0;
}

.forman-select-trigger-text {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 991.98px) {
  .app-header {
    padding: 0 1rem;
  }
  .user-dropdown .dropdown-toggle .user-info {
    display: none;
  }
  .page-title-box {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 0.75rem;
  }
  .page-title-box .page-title-right {
    width: 100%;
  }
  .page-title-box .page-title-right .btn {
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  :root {
    --vz-header-height: 60px;
  }
  .page-content {
    padding: calc(var(--vz-header-height) + 1rem) 0.75rem 1rem;
  }
  .container-fluid {
    padding-left: 0;
    padding-right: 0;
  }
  .card {
    margin-bottom: 1rem;
    border-radius: 0.375rem;
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }
  .card .card-header {
    padding: 0.875rem 1rem;
  }
  .card .card-header .card-title {
    font-size: 0.9rem;
  }
  .card .card-body {
    padding: 1rem;
  }
  .page-title-box {
    padding-bottom: 0.75rem;
    margin-bottom: 1rem;
  }
  .page-title-box h4 {
    font-size: 1rem;
  }
  .table-responsive {
    margin: 0 -1rem;
    padding: 0 1rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table {
    font-size: 0.8rem;
    white-space: nowrap;
  }
  .table th {
    font-size: 0.7rem;
    padding: 0.5rem;
  }
  .table td {
    padding: 0.5rem;
  }
  .btn {
    min-height: 44px;
    padding: 0.5rem 1rem;
  }
  .btn-sm {
    min-height: 36px;
    padding: 0.375rem 0.75rem;
  }
  .form-control,
  .form-select {
    min-height: 44px;
    font-size: 16px;
  }
  .modal-dialog {
    margin: 0.5rem;
    max-width: calc(100% - 1rem);
  }
  .modal-lg {
    max-width: calc(100% - 1rem);
  }
  .avatar-lg {
    width: 3rem;
    height: 3rem;
  }
  .avatar-sm {
    width: 1.75rem;
    height: 1.75rem;
  }
  .btn-outline-primary.w-100,
  .btn-outline-success.w-100,
  .btn-outline-info.w-100,
  .btn-outline-warning.w-100 {
    padding: 1rem;
  }
  .btn-outline-primary.w-100 i.fs-24,
  .btn-outline-success.w-100 i.fs-24,
  .btn-outline-info.w-100 i.fs-24,
  .btn-outline-warning.w-100 i.fs-24 {
    font-size: 1.5rem !important;
  }
  .card-animate .fs-22 {
    font-size: 1.25rem !important;
  }
  .footer {
    font-size: 0.7rem;
    padding: 0 0.5rem;
  }
  .badge {
    font-size: 0.65rem;
    padding: 0.25em 0.5em;
  }
  .form-check-input {
    width: 2.5em;
    height: 1.25em;
  }
  .breadcrumb {
    display: none;
  }
  h2 .countup {
    font-size: 1.5rem;
  }
  .row {
    --bs-gutter-x: 0.75rem;
  }
  .g-3 {
    --bs-gutter-x: 0.75rem;
    --bs-gutter-y: 0.75rem;
  }
}
@media (max-width: 375px) {
  .page-content {
    padding: calc(var(--vz-header-height) + 0.75rem) 0.5rem 0.75rem;
  }
  .card .card-body {
    padding: 0.75rem;
  }
  .table {
    font-size: 0.75rem;
  }
  .table td:nth-child(n+5),
  .table th:nth-child(n+5) {
    display: none;
  }
}
@media (hover: none) and (pointer: coarse) {
  .navbar-nav .nav-item .nav-link {
    padding: 0.875rem 1.5rem;
  }
  .dropdown-item {
    padding: 0.75rem 1rem;
  }
  .table-hover tbody tr {
    cursor: pointer;
  }
}
@media (max-height: 500px) and (orientation: landscape) {
  .page-content {
    padding-top: calc(var(--vz-header-height) + 0.5rem);
    padding-bottom: 0.5rem;
  }
  .footer {
    position: relative;
  }
}
@supports (padding: env(safe-area-inset-bottom)) {
  .footer {
    padding-bottom: env(safe-area-inset-bottom);
  }
  .app-menu {
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
  }
  @media (max-width: 991.98px) {
    .app-header {
      padding-top: env(safe-area-inset-top);
      height: calc(var(--vz-header-height) + env(safe-area-inset-top));
    }
    .page-content {
      padding-top: calc(var(--vz-header-height) + env(safe-area-inset-top) + 1.5rem);
      padding-bottom: calc(env(safe-area-inset-bottom) + 1rem);
    }
  }
}
.daily-record-detail .detail-header {
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--vz-border-color);
}
.daily-record-detail .detail-header h5 {
  font-size: 1.1rem;
  font-weight: 600;
}
.daily-record-detail .detail-meta p {
  font-size: 0.9rem;
  line-height: 1.6;
}
.daily-record-detail .detail-meta p i {
  width: 1.25rem;
  text-align: center;
}
.daily-record-detail .detail-section {
  padding: 1rem 0;
  border-bottom: 1px solid var(--vz-border-color);
}
.daily-record-detail .detail-section:last-child {
  border-bottom: none;
}
.daily-record-detail .detail-section-title {
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.daily-record-detail .detail-section-title i {
  font-size: 1rem;
}
.daily-record-detail .detail-section-title .badge {
  font-size: 0.7rem;
  font-weight: 500;
}
.daily-record-detail .detail-list {
  background: var(--vz-light);
  border-radius: 0.5rem;
  overflow: hidden;
}
.daily-record-detail .detail-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--vz-border-color);
  background: var(--vz-card-bg);
}
.daily-record-detail .detail-list-item:last-child {
  border-bottom: none;
}
.daily-record-detail .detail-list-item strong {
  font-size: 0.875rem;
  font-weight: 600;
}
.daily-record-detail .detail-list-item small {
  font-size: 0.75rem;
}
.daily-record-detail .detail-list-item .badge {
  font-size: 0.7rem;
  font-weight: 500;
  white-space: nowrap;
}
.daily-record-detail .detail-list-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: rgba(var(--vz-primary-rgb), 0.08);
  font-size: 0.875rem;
}
.daily-record-detail .detail-list-footer strong {
  color: var(--vz-primary);
}
.daily-record-detail .detail-photos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 0.75rem;
}
.daily-record-detail .detail-photo {
  position: relative;
  aspect-ratio: 1;
  border-radius: 0.5rem;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.daily-record-detail .detail-photo:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.daily-record-detail .detail-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 767.98px) {
  .daily-record-detail .detail-header h5 {
    font-size: 1rem;
  }
  .daily-record-detail .detail-meta p {
    font-size: 0.85rem;
  }
  .daily-record-detail .detail-list-item {
    padding: 0.625rem 0.875rem;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .daily-record-detail .detail-list-item > div:first-child {
    flex: 1 1;
    min-width: 0;
  }
  .daily-record-detail .detail-list-item strong {
    font-size: 0.8125rem;
  }
  .daily-record-detail .detail-photos {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
  }
  .daily-record-detail .detail-photo {
    border-radius: 0.375rem;
  }
}
.daily-record-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.daily-record-form .form-section {
  background: var(--vz-card-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.5rem;
  overflow: hidden;
}
.daily-record-form .form-section-title {
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0;
  padding: 0.75rem 1rem;
  background: var(--vz-light);
  border-bottom: 1px solid var(--vz-border-color);
  display: flex;
  align-items: center;
}
.daily-record-form .form-section-title i {
  font-size: 1rem;
  color: var(--vz-primary);
}
.daily-record-form .form-section-content {
  padding: 1rem;
}
.daily-record-form .form-section-content .form-group {
  margin-bottom: 1rem;
}
.daily-record-form .form-section-content .form-group:last-child {
  margin-bottom: 0;
}
.daily-record-form .form-section-content label {
  font-size: 0.8125rem;
  font-weight: 500;
  margin-bottom: 0.375rem;
}
.daily-record-form .usage-history-list {
  max-height: 350px;
  overflow-y: auto;
}
.daily-record-form .usage-history-item {
  display: flex;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--vz-border-color);
}
.daily-record-form .usage-history-item:last-child {
  border-bottom: none;
}
.daily-record-form .usage-history-item:hover {
  background-color: var(--vz-light);
}
.daily-record-form .usage-history-date {
  flex-shrink: 0;
  font-size: 0.75rem;
  color: var(--vz-primary);
  font-weight: 500;
  white-space: nowrap;
}
.daily-record-form .usage-history-date i {
  font-size: 0.8rem;
}
.daily-record-form .usage-history-content {
  flex: 1 1;
  min-width: 0;
}
.daily-record-form .usage-history-site {
  font-size: 0.8125rem;
  margin-bottom: 0.25rem;
}
.daily-record-form .usage-history-site strong {
  color: var(--vz-heading-color);
}
.daily-record-form .usage-history-details {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}
.daily-record-form .usage-history-notes {
  font-style: italic;
}
.daily-record-form .form-tabs {
  border-bottom: none;
  background: var(--vz-light);
  padding: 0.5rem 0.5rem 0;
  gap: 0.25rem;
}
.daily-record-form .form-tabs .nav-item {
  flex: 1 1;
}
.daily-record-form .form-tabs .nav-link {
  border: none;
  border-radius: 0.375rem 0.375rem 0 0;
  padding: 0.625rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--vz-body-color);
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  transition: all 0.15s ease;
}
.daily-record-form .form-tabs .nav-link:hover {
  background: rgba(var(--vz-primary-rgb), 0.05);
}
.daily-record-form .form-tabs .nav-link.active {
  background: var(--vz-card-bg);
  color: var(--vz-primary);
  box-shadow: 0 -2px 0 var(--vz-primary) inset;
}
.daily-record-form .form-tabs .nav-link i {
  font-size: 1rem;
}
.daily-record-form .form-tabs .nav-link .tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.375rem;
  font-size: 0.6875rem;
  font-weight: 600;
  background: var(--vz-primary);
  color: white;
  border-radius: 1rem;
}
.daily-record-form .tab-content {
  background: var(--vz-card-bg);
}
.daily-record-form .tab-section {
  padding: 1rem;
}
.daily-record-form .selected-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.daily-record-form .selected-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background: var(--vz-light);
  border-radius: 0.375rem;
  gap: 0.75rem;
}
.daily-record-form .selected-item.vehicle-item, .daily-record-form .selected-item.work-item {
  flex-wrap: wrap;
}
.daily-record-form .selected-item-info {
  flex: 1 1;
  min-width: 0;
}
.daily-record-form .selected-item-info strong {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.daily-record-form .selected-item-info small {
  display: block;
  font-size: 0.75rem;
  color: var(--vz-secondary-color);
}
.daily-record-form .selected-item-actions,
.daily-record-form .selected-item-fields {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.daily-record-form .selected-item-actions .form-control,
.daily-record-form .selected-item-actions .form-select,
.daily-record-form .selected-item-fields .form-control,
.daily-record-form .selected-item-fields .form-select {
  font-size: 0.8125rem;
}
.daily-record-form .btn-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: none;
  border-radius: 0.25rem;
  background: rgba(var(--vz-danger-rgb), 0.1);
  color: var(--vz-danger);
  cursor: pointer;
  transition: all 0.15s ease;
}
.daily-record-form .btn-remove:hover {
  background: var(--vz-danger);
  color: white;
}
.daily-record-form .btn-remove i {
  font-size: 1rem;
}
.daily-record-form .selectable-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.daily-record-form .selectable-item {
  background: #f8f9fa;
  border: 1px solid var(--vz-border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  transition: all 0.15s ease;
}
.daily-record-form .selectable-item.selected {
  background: rgba(var(--vz-primary-rgb), 0.05);
  border-color: var(--vz-primary);
}
.daily-record-form .selectable-item:hover:not(.selected) {
  background: #f0f0f5;
}
.daily-record-form .selectable-item-main {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.daily-record-form .selectable-item-check {
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.daily-record-form .selectable-item-check i {
  font-size: 1.25rem;
  color: var(--vz-secondary-color);
  transition: all 0.15s ease;
}
.selectable-item.selected .daily-record-form .selectable-item-check i {
  color: var(--vz-primary);
}
.daily-record-form .selectable-item-info {
  flex: 1 1;
  min-width: 0;
}
.daily-record-form .selectable-item-info strong {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--vz-body-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.daily-record-form .selectable-item-info small {
  display: block;
  font-size: 0.75rem;
  color: var(--vz-secondary-color);
}
.daily-record-form .selectable-item-info .progress {
  margin-top: 0.375rem;
}
.daily-record-form .selectable-item-options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  padding: 0.625rem 0.75rem;
  background: rgba(var(--vz-primary-rgb), 0.03);
  border-top: 1px dashed rgba(var(--vz-primary-rgb), 0.2);
}
.daily-record-form .option-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.daily-record-form .option-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--vz-secondary-color);
  white-space: nowrap;
}
.daily-record-form .wage-buttons {
  display: flex;
  gap: 0.25rem;
}
.daily-record-form .wage-btn {
  min-width: 2.25rem;
  height: 1.75rem;
  padding: 0 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  background: white;
  color: var(--vz-body-color);
  cursor: pointer;
  transition: all 0.15s ease;
}
.daily-record-form .wage-btn:hover {
  border-color: var(--vz-primary);
  color: var(--vz-primary);
}
.daily-record-form .wage-btn.active {
  background: var(--vz-primary);
  border-color: var(--vz-primary);
  color: white;
}
.daily-record-form .usage-buttons {
  display: flex;
  gap: 0.25rem;
}
.daily-record-form .usage-btn {
  padding: 0.25rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  background: white;
  color: var(--vz-body-color);
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.daily-record-form .usage-btn:hover {
  border-color: var(--vz-success);
  color: var(--vz-success);
}
.daily-record-form .usage-btn.active {
  background: var(--vz-success);
  border-color: var(--vz-success);
  color: white;
}
.daily-record-form .vehicle-options,
.daily-record-form .work-options {
  flex-direction: column;
  align-items: flex-start;
}
.daily-record-form .vehicle-options .option-row,
.daily-record-form .work-options .option-row {
  width: 100%;
}
.daily-record-form .vehicle-options .form-select,
.daily-record-form .vehicle-options .form-control,
.daily-record-form .work-options .form-select,
.daily-record-form .work-options .form-control {
  flex: 1 1;
  font-size: 0.8125rem;
}
.daily-record-form .photo-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--vz-secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
}
.daily-record-form .photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 0.5rem;
}
.daily-record-form .photo-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 0.375rem;
  overflow: hidden;
  background: var(--vz-light);
}
.daily-record-form .photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.daily-record-form .photo-item.existing {
  opacity: 0.7;
}
.daily-record-form .photo-remove {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(var(--vz-danger-rgb), 0.9);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}
.daily-record-form .photo-remove:hover {
  background: var(--vz-danger);
  transform: scale(1.1);
}
.daily-record-form .photo-remove i {
  font-size: 0.875rem;
}
.daily-record-form .photo-upload-area {
  margin-top: 1rem;
}
.daily-record-form .photo-upload-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 100%;
  padding: 1.5rem;
  border: 2px dashed var(--vz-border-color);
  border-radius: 0.5rem;
  background: var(--vz-light);
  cursor: pointer;
  transition: all 0.15s ease;
}
.daily-record-form .photo-upload-btn:hover {
  border-color: var(--vz-primary);
  background: rgba(var(--vz-primary-rgb), 0.05);
}
.daily-record-form .photo-upload-btn i {
  font-size: 1.5rem;
  color: var(--vz-primary);
}
.daily-record-form .photo-upload-btn span {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--vz-body-color);
}
.daily-record-form .photo-upload-btn small {
  font-size: 0.75rem;
  color: var(--vz-secondary-color);
}
.daily-record-form .existing-photos,
.daily-record-form .new-photos {
  margin-bottom: 1rem;
}
.daily-record-form .form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid var(--vz-border-color);
}

@media (max-width: 767.98px) {
  .daily-record-form {
    gap: 1rem;
  }
  .daily-record-form .form-section-title {
    padding: 0.625rem 0.875rem;
    font-size: 0.85rem;
  }
  .daily-record-form .form-section-content {
    padding: 0.875rem;
  }
  .daily-record-form .form-tabs {
    padding: 0.375rem 0.375rem 0;
  }
  .daily-record-form .form-tabs .nav-link {
    padding: 0.5rem;
    font-size: 0.75rem;
  }
  .daily-record-form .form-tabs .nav-link i {
    font-size: 0.875rem;
  }
  .daily-record-form .form-tabs .nav-link .tab-badge {
    min-width: 1rem;
    height: 1rem;
    font-size: 0.625rem;
  }
  .daily-record-form .tab-section {
    padding: 0.875rem;
  }
  .daily-record-form .selectable-item-main {
    padding: 0.625rem;
    gap: 0.5rem;
  }
  .daily-record-form .selectable-item-check {
    width: 1.25rem;
    height: 1.25rem;
  }
  .daily-record-form .selectable-item-check i {
    font-size: 1.1rem;
  }
  .daily-record-form .selectable-item-info strong {
    font-size: 0.8125rem;
  }
  .daily-record-form .selectable-item-info small {
    font-size: 0.7rem;
  }
  .daily-record-form .selectable-item-options {
    padding: 0.5rem 0.625rem;
    gap: 0.375rem 0.75rem;
  }
  .daily-record-form .option-label {
    font-size: 0.7rem;
  }
  .daily-record-form .wage-btn {
    min-width: 2rem;
    height: 1.625rem;
    font-size: 0.7rem;
  }
  .daily-record-form .usage-btn {
    padding: 0.2rem 0.5rem;
    font-size: 0.7rem;
  }
  .daily-record-form .photo-grid {
    grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
    gap: 0.375rem;
  }
  .daily-record-form .photo-upload-btn {
    padding: 1rem;
  }
  .daily-record-form .photo-upload-btn i {
    font-size: 1.25rem;
  }
  .daily-record-form .photo-upload-btn span {
    font-size: 0.8125rem;
  }
  .daily-record-form .selected-item {
    padding: 0.625rem;
  }
  .daily-record-form .selected-item-info strong {
    font-size: 0.8125rem;
  }
  .daily-record-form .form-actions {
    flex-direction: column-reverse;
  }
  .daily-record-form .form-actions .btn {
    width: 100%;
  }
}
.waybill-number-link {
  cursor: pointer;
  color: #405189;
  transition: all 0.15s ease;
}
.waybill-number-link:hover {
  color: #3577f1;
  text-decoration: underline;
}

.waybill-photo-link {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.waybill-photo-link:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}
.waybill-photo-link:hover img {
  transform: scale(1.1);
}

@media screen and (max-width: 768px) {
  input[type=text],
  input[type=email],
  input[type=password],
  input[type=number],
  input[type=tel],
  input[type=url],
  input[type=search],
  input[type=date],
  select,
  textarea {
    font-size: 16px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_admin-mobile.scss","webpack://./src/assets/scss/themes.scss"],"names":[],"mappings":"AASA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;ACRF;ADUE;EANF;IAOI,SAAA;ECPF;AACF;;ADcA;EACE,6BAAA;EACA,6CAAA;EACA,sBAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;ACXF;ADaE;EACE,sBAAA;EACA,wCAAA;ACXJ;ADcE;EAbF;IAcI,uBAAA;ECXF;EDaE;IACE,2BAAA;IACA,yCAAA;ECXJ;AACF;;ADgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,+CAAA;EACA,sFAAA;ACbF;ADeE;EARF;IASI,qBAAA;ECZF;AACF;;ADeA;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ACZF;ADcE;EAXF;IAYI,eAAA;ECXF;AACF;;ADcA;EACE,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;ACXF;ADcE;EACE,4CAAA;EACA,wBAAA;ACZJ;ADeE;EACE,2CAAA;EACA,uBAAA;ACbJ;ADgBE;EACE,4CAAA;EACA,wBAAA;ACdJ;ADiBE;EACE,yCAAA;EACA,qBAAA;ACfJ;ADkBE;EACE,4CAAA;EACA,wBAAA;AChBJ;;ADqBA;EACE,aAAA;AClBF;ADoBE;EAHF;IAII,gBAAA;ECjBF;AACF;;ADqBA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,4CAAA;EACA,6CAAA;AClBF;ADoBE;EAPF;IAQI,qBAAA;IACA,YAAA;ECjBF;AACF;;ADwBA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;ACrBF;ADuBE;EACE,0DAAA;ACrBJ;ADwBE;EAVF;IAWI,mBAAA;IACA,SAAA;ECrBF;AACF;;ADwBA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;ACrBF;ADuBE;EACE,mBAAA;EACA,sBAAA;EACA,wBAAA;ACrBJ;ADwBE;EAfF;IAgBI,YAAA;IACA,oBAAA;ECrBF;AACF;;ADwBA;EACE,SAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;ACrBF;ADwBE;EACE,cAAA;EACA,kBAAA;ACtBJ;ADyBE;EACE,wBAAA;EACA,gBAAA;ACvBJ;AD0BE;EACE,wBAAA;EACA,gBAAA;ACxBJ;AD2BE;EACE,uBAAA;EACA,gBAAA;ACzBJ;AD4BE;EA5BF;IA6BI,oBAAA;ECzBF;AACF;;AD6BA;EACE,mBAAA;EACA,WAAA;AC1BF;AD4BE;EACE,WAAA;EACA,oBAAA;AC1BJ;AD6BE;EACE,oBAAA;AC3BJ;;ADmCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,0BAAA;EACA,qBAAA;EACA,mBAAA;AChCF;ADkCE;EACE,eAAA;AChCJ;ADmCE;EACE,sBAAA;ACjCJ;ADoCE;EACE,YAAA;EACA,mBAAA;AClCJ;ADsCE;EACE,WAAA;ACpCJ;ADuCE;EAlCF;IAmCI,gBAAA;IACA,oBAAA;IACA,oBAAA;ECpCF;EDsCE;IACE,2BAAA;IACA,0CAAA;ECpCJ;EDuCE;IACE,wBAAA;ECrCJ;AACF;;AD6CA;EACE,6BAAA;EACA,YAAA;AC1CF;AD4CE;EACE,4CAAA;AC1CJ;AD6CE;EACE,6CAAA;AC3CJ;;AD+CA;EACE,6BAAA;EACA,YAAA;AC5CF;AD8CE;EACE,4CAAA;AC5CJ;AD+CE;EACE,6CAAA;AC7CJ;;ADiDA;EACE,4BAAA;EACA,YAAA;AC9CF;ADgDE;EACE,2CAAA;AC9CJ;ADiDE;EACE,4CAAA;AC/CJ;;ADmDA;EACE,6BAAA;EACA,cAAA;AChDF;ADkDE;EACE,4CAAA;AChDJ;ADmDE;EACE,6CAAA;ACjDJ;;ADqDA;EACE,iBAAA;EACA,wBAAA;EACA,mCAAA;AClDF;ADoDE;EACE,6CAAA;AClDJ;ADqDE;EACE,4CAAA;ACnDJ;ADuDE;EACE,uBAAA;EACA,8BAAA;ACrDJ;ADuDI;EACE,4CAAA;ACrDN;ADwDI;EACE,2CAAA;ACtDN;AD0DE;EACE,wBAAA;EACA,+BAAA;ACxDJ;AD0DI;EACE,6CAAA;ACxDN;AD2DI;EACE,4CAAA;ACzDN;;AD8DA;EACE,6CAAA;EACA,wBAAA;AC3DF;AD6DE;EACE,6CAAA;AC3DJ;AD8DE;EACE,6CAAA;AC5DJ;;ADiEA;EACE,iBAAA;EACA,eAAA;EACA,qBAAA;AC9DF;ADgEE;EACE,mBAAA;EACA,SAAA;AC9DJ;ADiEE;EAVF;IAWI,eAAA;IACA,eAAA;EC9DF;AACF;;ADqEA;EACE,6BAAA;EACA,6CAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AClEF;;ADqEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AClEF;ADoEE;EACE,6CAAA;AClEJ;ADqEE;EACE;IACE,6CAAA;ECnEJ;AACF;;ADuEA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;ACpEF;ADsEE;EACE,mBAAA;EACA,wBAAA;ACpEJ;;ADwEA;EACE,kBAAA;EACA,cAAA;EACA,+BAAA;ACrEF;ADuEE;EACE,yBAAA;ACrEJ;;ADyEA;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;ACtEF;ADwEE;EACE,kBAAA;ACtEJ;;AD0EA;EACE,oBAAA;EACA,4CAAA;EACA,iBAAA;ACvEF;;AD0EA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;ACvEF;ADyEE;EANF;IAOI,mBAAA;IACA,mBAAA;IACA,YAAA;ECtEF;AACF;;ADyEA;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;ACtEF;;ADyEA;EACE,SAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mCAAA;ACtEF;ADwEE;EACE,aAAA;EACA,+BAAA;EACA,sDAAA;ACtEJ;ADyEE;EAhBF;IAiBI,gBAAA;IACA,eAAA;ECtEF;AACF;;ADyEA;EACE,aAAA;EACA,WAAA;EACA,oBAAA;EACA,6CAAA;ACtEF;;AD0EA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;ACvEF;;AD8EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,6BAAA;EACA,8CAAA;EACA,sBAAA;EACA,iBAAA;AC3EF;AD6EE;EAZF;IAaI,kBAAA;IACA,iBAAA;EC1EF;AACF;;AD6EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wGAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AC1EF;AD4EE;EACE,iBAAA;EACA,uCAAA;AC1EJ;AD6EE;EAfF;IAgBI,YAAA;IACA,aAAA;EC1EF;ED4EE;IACE,eAAA;EC1EJ;AACF;;AD8EA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AC3EF;AD6EE;EANF;IAOI,kBAAA;EC1EF;AACF;;AD6EA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AC1EF;AD4EE;EAPF;IAQI,oBAAA;ECzEF;AACF;;AD4EA;EACE,kBAAA;ACzEF;;ADgFA;EACE,qDAAA;EACA,yEAAA;EACA,0BAAA;EACA,uBAAA;AC7EF;;ADgFA;EACE;IACE,2BAAA;EC7EF;ED+EA;IACE,4BAAA;EC7EF;AACF;ADgFA;EACE,6BAAA;EACA,6CAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AC9EF;ADgFE;EAPF;IAQI,gBAAA;IACA,mBAAA;EC7EF;AACF;;ADgFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AC7EF;;ADgFA;EACE,eAAA;EACA,UAAA;EACA,gBAAA;EACA,yEAAA;EACA,0BAAA;EACA,qDAAA;EACA,uBAAA;AC7EF;;ADgFA;EACE,cAAA;EACA,WAAA;EACA,yEAAA;EACA,0BAAA;EACA,qDAAA;EACA,uBAAA;AC7EF;;ADgFA;EACE,gBAAA;EACA,sBAAA;EACA,yEAAA;EACA,0BAAA;EACA,qDAAA;EACA,uBAAA;AC7EF;AD+EE;EACE,gBAAA;AC7EJ;ADgFE;EACE,UAAA;AC9EJ;ADiFE;EACE,UAAA;AC/EJ;ADkFE;EACE,UAAA;AChFJ;;ADoFA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4CAAA;ACjFF;;ADoFA;EACE,SAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,qDAAA;EACA,qBAAA;ACjFF;;ADwFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;ACrFF;ADuFE;EATF;IAUI,eAAA;IACA,qBAAA;ECpFF;AACF;;ADuFA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;ACpFF;ADsFE;EARF;IASI,mBAAA;ECnFF;AACF;;ADsFA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;ACnFF;;ADsFA;EACE,aAAA;EACA,WAAA;EACA,eAAA;ACnFF;ADqFE;EALF;IAMI,WAAA;EClFF;EDoFE;IACE,SAAA;EClFJ;AACF;;ADsFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;ACnFF;ADqFE;EATF;IAUI,WAAA;EClFF;AACF;;ADqFA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AClFF;ADoFE;EACE,oBAAA;EACA,wBAAA;AClFJ;;AD0FA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,4CAAA;EACA,qBAAA;EACA,8DAAA;EACA,2CAAA;EACA,aAAA;EACA,+BAAA;ACvFF;ADyFE;EACE,2BAAA;ACvFJ;AD0FE;EAjBF;IAmBI,aAAA;ECxFF;AACF;;AD2FA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;ACxFF;;AD2FA;EACE,SAAA;ACxFF;;AD2FA;EACE,cAAA;ACxFF;;AD4FA;EACE,sEAAA;ACzFF;;ADiGA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AC9FF;ADgGE;EACE,6BAAA;EACA,sDAAA;AC9FJ;ADiGE;EACE,mBAAA;AC/FJ;ADkGE;EACE,6BAAA;EACA,wCAAA;AChGJ;ADmGE;EACE,4BAAA;ACjGJ;;ADqGA;EACE;IACE,UAAA;EClGF;EDoGA;IACE,YAAA;EClGF;AACF;ADsGA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;ACpGF;ADsGE;EACE,aAAA;ACpGJ;;ADwGA;EACE,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,wGAAA;EACA,sBAAA;EACA,mDAAA;ACrGF;ADuGE;EACE,wGAAA;EACA,+CAAA;ACrGJ;ADwGE;EACE,wGAAA;EACA,+CAAA;ACtGJ;ADyGE;EACE,sGAAA;EACA,8CAAA;ACvGJ;;AD2GA;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;ACxGF;;AD2GA;EACE,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;ACxGF;AD0GE;EACE,wBAAA;ACxGJ;AD2GE;EACE,wBAAA;ACzGJ;AD4GE;EACE,uBAAA;AC1GJ;;AD+GA;EACE,WAAA;EACA,kCAAA;EACA,cAAA;AC5GF;AD8GE;EACE,gBAAA;EACA,gDAAA;AC5GJ;;ADiHA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AC9GF;;ADiHA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AC9GF;;ADiHA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AC9GF;;ADkHA;EACE;;;IAGE,6DAAA;IACA,yBAAA;YAAA,iBAAA;EC/GF;AACF;ADmHA;EACE;IACE,2DAAA;ECjHF;AACF;AD6HA;EACE;IACE,+BAAA;IACA,gBAAA;IACA,kBAAA;EC3HF;ED+HM;IACE,gBAAA;IACA,MAAA;IACA,gBAAA;IACA,WAAA;IACA,yCAAA;EC7HR;AACF;AD+HU;EARF;IASI,6BAAA;EC5HV;AACF;ADuIA;EACE;IACE,WAAA;IACA,yBAAA;IACA,iBAAA;ECrIF;EDwII;IACE,gBAAA;IACA,yBAAA;IACA,kBAAA;IACA,sBAAA;IACA,cAAA;IACA,sBAAA;IACA,+CAAA;ECtIN;EDwIM;IACE,eAAA;IACA,yBAAA;YAAA,iBAAA;IACA,yBAAA;ECtIR;EDwIQ;IACE,6CAAA;IACA,wBAAA;ECtIV;EDyIQ;IACE,gBAAA;IACA,wBAAA;IACA,mBAAA;IACA,YAAA;IACA,6BAAA;ECvIV;ED0IQ;IACE,gBAAA;IACA,UAAA;IACA,wBAAA;ECxIV;ED2IQ;IACE,gBAAA;IACA,UAAA;IACA,wBAAA;ECzIV;EDgJI;IACE,0DAAA;IACA,yBAAA;EC9IN;EDgJM;IACE,6CAAA;IACA,yCAAA;IACA,2BAAA;EC9IR;EDiJM;IACE,mBAAA;EC/IR;EDkJM;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,sBAAA;EChJR;EDsJM;IACE,6CAAA;ECpJR;EDsJQ;IACE,6CAAA;ECpJV;ED2JE;IACE,6CAAA;ECzJJ;ED2JI;IACE,6CAAA;ECzJN;AACF;ADkKA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,qBAAA;AChKF;ADkKE;EANF;IAOI,qCAAA;EC/JF;AACF;ADiKE;EAVF;IAWI,qCAAA;EC9JF;AACF;ADgKE;EAdF;IAeI,qCAAA;EC7JF;AACF;;ADgKA;EACE,6BAAA;EACA,6CAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AC7JF;AD+JE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,uFAAA;EACA,oBAAA;EACA,sBAAA;EACA,+BAAA;AC7JJ;ADgKE;EACE;IACE,2BAAA;IACA,yCAAA;EC9JJ;EDgKI;IACE,oBAAA;EC9JN;AACF;ADkKE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,4CAAA;EACA,wBAAA;AChKJ;ADmKE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;ACjKJ;ADoKE;EACE,oBAAA;EACA,cAAA;EACA,gBAAA;AClKJ;ADqKE;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;ACnKJ;ADqKI;EACE,wBAAA;ACnKN;ADsKI;EACE,uBAAA;ACpKN;;AD6KA;EACE,aAAA;EACA,SAAA;AC1KF;AD4KE;EAJF;IAKI,qCAAA;IACA,YAAA;ECzKF;AACF;AD2KE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;ACzKJ;AD2KI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;ACzKN;AD2KM;EACE,uBAAA;EACA,oBAAA;ACzKR;AD6KI;;;EAGE,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;AC3KN;AD6KM;;;EACE,aAAA;EACA,+BAAA;EACA,sDAAA;ACzKR;AD4KM;;;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;ACxKR;AD2KM;;;EACE,8BAAA;ACvKR;ADyKQ;;;EACE,qDAAA;ACrKV;ADyKM;;;EACE,+BAAA;ACrKR;ADuKQ;;;EACE,sDAAA;ACnKV;ADwKI;EACE,iBAAA;EACA,gBAAA;ACtKN;ADyKI;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;ACvKN;AD0KI;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;ACxKN;AD0KM;EACE,mBAAA;ACxKR;AD6KE;EACE,iBAAA;AC3KJ;;ADmLA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AChLF;ADkLE;EANF;IAOI,YAAA;EC/KF;AACF;ADiLE;EACE,yBAAA;AC/KJ;ADkLE;EACE,uBAAA;AChLJ;ADmLE;EACE,8BAAA;ACjLJ;ADqLE;EACE,MAAA;ACnLJ;ADqLI;EACE,gBAAA;EACA,iBAAA;ACnLN;ADqLM;EACE,8BAAA;EACA,iCAAA;EACA,cAAA;ACnLR;ADsLM;EACE,+BAAA;EACA,kCAAA;ACpLR;ADuLM;EAEE,UAAA;ACtLR;;ADgMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EACA,+CAAA;AC7LF;AD+LE;EAVF;IAWI,mBAAA;IACA,uBAAA;EC5LF;AACF;AD8LE;EACE,SAAA;EACA,YAAA;AC5LJ;AD8LI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;AC5LN;AD8LM;EACE,wBAAA;EACA,qBAAA;EACA,2BAAA;AC5LR;AD8LQ;EACE,uCAAA;EACA,0BAAA;AC5LV;ADgMM;EACE,cAAA;AC9LR;ADmME;EACE,aAAA;EACA,YAAA;EACA,mBAAA;ACjMJ;ADmMI;EALF;IAMI,WAAA;EChMJ;AACF;;ADwMA;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;ACrMF;ADuME;EACE,mBAAA;ACrMJ;ADyME;EACE,wGAAA;EACA,wBAAA;EACA,kDAAA;ACvMJ;AD0ME;EACE,wGAAA;EACA,wBAAA;EACA,kDAAA;ACxMJ;AD2ME;EACE,sGAAA;EACA,uBAAA;EACA,iDAAA;ACzMJ;AD4ME;EACE,wGAAA;EACA,cAAA;EACA,kDAAA;AC1MJ;AD6ME;EACE,kGAAA;EACA,qBAAA;EACA,+CAAA;AC3MJ;AD8ME;EACE,kFAAA;EACA,cAAA;EACA,uCAAA;AC5MJ;AD+ME;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AC7MJ;ADiNE;EACE,YAAA;AC/MJ;ADiNI;EACE,6BAAA;EACA,YAAA;AC/MN;ADkNI;EACE,6BAAA;EACA,YAAA;AChNN;ADmNI;EACE,4BAAA;EACA,YAAA;ACjNN;ADoNI;EACE,6BAAA;EACA,cAAA;AClNN;ADqNI;EACE,0BAAA;EACA,YAAA;ACnNN;ADwNE;EACE,oBAAA;ACtNJ;AD2NI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;ACzNN;;ADmOA;EACE;;;;;IAKE,sBAAA;EChOF;EDoOA;IACE,+BAAA;EClOF;EDqOA;IACE;MACE,UAAA;MACA,2BAAA;ICnOF;IDqOA;MACE,UAAA;MACA,wBAAA;ICnOF;EACF;EDuOA;IACE,qCAAA;ECrOF;EDwOA;IACE;MACE,UAAA;MACA,2BAAA;ICtOF;IDwOA;MACE,UAAA;MACA,wBAAA;ICtOF;EACF;ED0OA;IACE,yDAAA;ECxOF;ED2OA;IACE;MACE,UAAA;MACA,qBAAA;ICzOF;ID2OA;MACE,UAAA;MACA,mBAAA;ICzOF;EACF;AACF;AD8OE;EACE,UAAA;EACA,wCAAA;AC5OJ;AD+OM;EACE,sBAAA;AC7OR;AD4OM;EACE,qBAAA;AC1OR;ADyOM;EACE,sBAAA;ACvOR;ADsOM;EACE,qBAAA;ACpOR;ADmOM;EACE,sBAAA;ACjOR;ADgOM;EACE,qBAAA;AC9NR;AD6NM;EACE,sBAAA;AC3NR;AD0NM;EACE,qBAAA;ACxNR;ADuNM;EACE,sBAAA;ACrNR;ADoNM;EACE,qBAAA;AClNR;ADiNM;EACE,sBAAA;AC/MR;AD8MM;EACE,qBAAA;AC5MR;AD2MM;EACE,sBAAA;ACzMR;ADwMM;EACE,qBAAA;ACtMR;ADqMM;EACE,sBAAA;ACnMR;ADkMM;EACE,qBAAA;AChMR;AD+LM;EACE,sBAAA;AC7LR;AD4LM;EACE,qBAAA;AC1LR;ADyLM;EACE,sBAAA;ACvLR;ADsLM;EACE,mBAAA;ACpLR;;AD2LA;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,kDAAA;EACA,mCAAA;EACA,kBAAA;EACA,oCAAA;ACxLF;AD0LE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;ACxLJ;AD2LE;EACE,aAAA;EACA,cAAA;EACA,iBAAA;ACzLJ;;AD6LA;EACE;IACE,yBAAA;EC1LF;AACF;AD8LA;EACE,uBAAA;AC5LF;AD8LE;EACE,UAAA;EACA,WAAA;AC5LJ;AD+LE;EACE,mBAAA;EACA,kBAAA;AC7LJ;ADgME;EACE,mBAAA;EACA,kBAAA;AC9LJ;ADgMI;EACE,mBAAA;AC9LN;;ADuME;;;EACE,oCAAA;EACA,mBAAA;AClMJ;;ADuMA;EACE;;;;IAIE,wBAAA;ECpMF;EDuMA;IACE,2BAAA;IACA,4BAAA;ECrMF;EDwMA;IACE,wBAAA;ECtMF;AACF;AAn+CA;EAEE,qBAAA;EACA,6BAAA;EAGA,uBAAA;EACA,gCAAA;EAGA,qBAAA;EACA,8BAAA;EAGA,kBAAA;EACA,2BAAA;EAGA,qBAAA;EACA,8BAAA;EAGA,oBAAA;EACA,6BAAA;EAGA,mBAAA;EACA,kBAAA;EAGA,qBAAA;EACA,wBAAA;EAGA,qBAAA;EACA,+BAAA;EAGA,+BAAA;EACA,kCAAA;EACA,iCAAA;EACA,8BAAA;EACA,kCAAA;EACA,uDAAA;EACA,4CAAA;EACA,6CAAA;EACA,4DAAA;EACA,2DAAA;EACA,gDAAA;EACA,wDAAA;EACA,+DAAA;EAGA,2CAAA;EACA,iDAAA;EACA,uDAAA;EACA,gEAAA;EACA,8EAAA;EAGA,wBAAA;EACA,uBAAA;EACA,+BAAA;EAGA,wBAAA;EAGA,0BAAA;EAGA,2CAAA;AAw8CF;;AAp8CA;EACE,iBAAA;EACA,YAAA;AAu8CF;;AAn8CA;EACE,sCAAA;EACA,mCAAA;EAGA,iBAAA;EACA,2BAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAo8CF;;AAh8CA;EACE,aAAA;EACA,iBAAA;AAm8CF;;AA/7CA;EACE,eAAA;EACA,MAAA;EACA,mCAAA;EACA,QAAA;EACA,+BAAA;EACA,qCAAA;EACA,+CAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,4CAAA;EACA,6BAAA;AAk8CF;AAh8CE;EAhBF;IAiBI,OAAA;EAm8CF;AACF;;AA/7CA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,oCAAA;EACA,sCAAA;EACA,sDAAA;EACA,aAAA;EACA,8CAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;EACA,gBAAA;AAk8CF;AAh8CE;EAhBF;IAiBI,kBAAA;EAm8CF;EAj8CE;IACE,cAAA;EAm8CJ;AACF;AAh8CE;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,6BAAA;AAk8CJ;AAh8CI;EACE,qBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;AAk8CN;AAh8CM;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAk8CR;AA/7CM;EACE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAi8CR;AA57CE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;AA87CJ;AA57CI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,eAAA;AA87CN;AA57CM;EACE,qBAAA;AA87CR;AA37CM;EACE,aAAA;AA67CR;AAz7CI;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,yCAAA;EACA,mBAAA;EACA,qBAAA;EACA,0BAAA;EACA,kBAAA;AA27CN;AAz7CM;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA27CR;AAx7CM;EACE,WAAA;EACA,sBAAA;EACA,yCAAA;AA07CR;AAv7CM;EACE,+CAAA;AAy7CR;AAt7CM;EACE,gDAAA;AAw7CR;AAn7CE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,wBAAA;EACA,aAAA;AAq7CJ;;AA/6CE;EACE,UAAA;AAk7CJ;;AA76CA;EACE,SAAA;EACA,0CAAA;EACA,iBAAA;EACA,6BAAA;AAg7CF;AA96CE;EANF;IAOI,cAAA;EAi7CF;AACF;;AA76CA;EACE,6DAAA;EACA,iBAAA;AAg7CF;;AA56CA;EACE,oBAAA;EACA,qBAAA;AA+6CF;AA76CE;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AA+6CJ;;AA16CA;EACE,eAAA;EACA,SAAA;EACA,mCAAA;EACA,QAAA;EACA,+BAAA;EACA,mCAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;AA66CF;AA36CE;EAfF;IAgBI,OAAA;EA86CF;AACF;;AAr6CE;EACE;IACE,6CAAA;EAw6CJ;EAr6CE;IACE,sCAAA;EAu6CJ;EAp6CE;IACE,sCAAA;EAs6CJ;EAn6CE;IACE,aAAA;EAq6CJ;EAl6CE;IACE,0BAAA;IACA,uCAAA;IACA,2BAAA;EAo6CJ;EAl6CI;IACE,UAAA;IACA,uBAAA;EAo6CN;EAl6CM;IACE,uBAAA;IACA,WAAA;EAo6CR;EAl6CQ;IACE,wBAAA;EAo6CV;EAj6CQ;IACE,yBAAA;EAm6CV;EA75CI;;IAEE,wBAAA;EA+5CN;EA35CM;IACE,2BAAA;IACA,6BAAA;IASA,qBAAA;EAq5CR;EA35CQ;IACE,aAAA;IACA,QAAA;EA65CV;EAn5CM;IACE,aAAA;EAq5CR;EAl5CM;IACE,kBAAA;EAo5CR;EAl5CQ;IACE,aAAA;EAo5CV;EAj5CQ;IACE,cAAA;IACA,yCAAA;IACA,iBAAA;IACA,eAAA;EAm5CV;EA/4CM;IACE,uBAAA;IACA,mBAAA;EAi5CR;EA/4CQ;IACE,aAAA;EAi5CV;EA94CQ;IACE,eAAA;IACA,eAAA;EAg5CV;EA74CQ;IACE,eAAA;EA+4CV;EA54CQ;IAEE,aAAA;EA64CV;EAz4CM;IACE,aAAA;EA24CR;EAt4CI;IACE,+CAAA;EAw4CN;EAr4CM;;IAEE,yBAAA;EAu4CR;EAn4CQ;IACE,2BAAA;IACA,6BAAA;IAQA,qBAAA;EA83CV;EAn4CU;IACE,cAAA;IACA,WAAA;EAq4CZ;EA93CM;IACE,2BAAA;IACA,iBAAA;EAg4CR;EA93CQ;IACE,2BAAA;EAg4CV;EA93CU;IACE,gCAAA;EAg4CZ;EA73CU;IACE,wBAAA;EA+3CZ;EAz3CQ;IACE,cAAA;EA23CV;EAx3CQ;IACE,2BAAA;IACA,wBAAA;EA03CV;EAx3CU;IACE,eAAA;IACA,kBAAA;EA03CZ;EAv3CU;IACE,sBAAA;EAy3CZ;EAt3CU;IAGE,qBAAA;EAs3CZ;EAj3CM;IACE,gBAAA;EAm3CR;EAj3CQ;IACE,qBAAA;EAm3CV;EAh3CQ;IACE,aAAA;EAk3CV;AACF;;AAz2CE;EACE;IACE,6CAAA;EA42CJ;EAz2CE;IACE,sCAAA;IACA,aAAA;EA22CJ;EAx2CE;IACE,sCAAA;EA02CJ;EAv2CE;IACE,eAAA;IACA,UAAA;IACA,uCAAA;IACA,UAAA;IACA,MAAA;IACA,4CAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,+BAAA;EAy2CJ;EAt2CM;IACE,wBAAA;EAw2CR;EAt2CM;IACE,yBAAA;EAw2CR;EAn2CE;IACE,0BAAA;IACA,kDAAA;IACA,oCAAA;EAq2CJ;EAn2CI;;IAEE,4BAAA;EAq2CN;EAl2CI;;IAEE,wBAAA;EAo2CN;EAj2CI;IACE,oBAAA;EAm2CN;EA/1CM;IACE,wBAAA;EAi2CR;EA91CM;IACE,kBAAA;IACA,eAAA;EAg2CR;EA91CQ;IACE,aAAA;EAg2CV;EA71CQ;IACE,cAAA;IACA,iBAAA;EA+1CV;EA11CQ;IACE,aAAA;EA41CV;EAz1CQ;IACE,eAAA;EA21CV;EAx1CQ;IACE,eAAA;EA01CV;EAv1CQ;IAEE,aAAA;EAw1CV;EAp1CM;IACE,aAAA;IACA,uBAAA;EAs1CR;EAn1CM;IACE,kBAAA;EAq1CR;EAl1CU;IACE,kBAAA;IACA,qDAAA;IACA,gBAAA;IACA,4CAAA;EAo1CZ;EAl1CY;IACE,qBAAA;IACA,kBAAA;EAo1Cd;EAj1CY;IACE,cAAA;IACA,wBAAA;IACA,WAAA;EAm1Cd;EA90CY;IACE,qBAAA;EAg1Cd;EA50CU;IACE,cAAA;IACA,sCAAA;IACA,kBAAA;IACA,YAAA;IACA,sCAAA;IACA,uBAAA;IACA,iBAAA;IACA,0BAAA;IACA,4CAAA;EA80CZ;EAz0CM;IACE,UAAA;EA20CR;EAv0CY;IACE,+CAAA;EAy0Cd;EAv0Cc;IACE,cAAA;EAy0ChB;EAl0CU;IACE,yBAAA;IACA,kCAAA;EAo0CZ;EAh0CQ;IACE,qBAAA;IACA,MAAA;IACA,6BAAA;EAk0CV;AACF;;AAvzCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AA0zCF;AAxzCE;EACE,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,iDAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,OAAA;AA0zCJ;AAxzCI;EACE,MAAA;EACA,WAAA;AA0zCN;AAvzCI;EACE,QAAA;AAyzCN;AAtzCI;EACE,SAAA;EACA,WAAA;AAwzCN;AApzCE;EACE,yBAAA;AAszCJ;AAnzCM;EACE,SAAA;EACA,QAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;AAqzCR;AAlzCM;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;AAozCR;AAjzCM;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;AAmzCR;;AA3yCI;EACE,SAAA;AA8yCN;AA5yCI;EACE,YAAA;AA8yCN;;AAryCA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;EACA,aAAA;EACA,aAAA;AAwyCF;;AApyCE;EACE,cAAA;AAuyCJ;AApyCE;EACE,yBAAA;EACA,aAAA;AAsyCJ;;AA9xCA;EACE,6CAAA;EACA,qBAAA;EACA,4CAAA;EACA,qBAAA;EACA,mCAAA;AAiyCF;AA/xCE;EACE,6BAAA;EACA,+CAAA;EACA,qBAAA;AAiyCJ;AA/xCI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAiyCN;AA7xCE;EACE,gBAAA;AA+xCJ;;AA1xCA;EACE,yBAAA;AA6xCF;AA3xCE;EACE,2BAAA;EACA,6CAAA;AA6xCJ;;AApxCA;EAAqB,6DAAA;AAwxCrB;;AAvxCA;EAAqB,6DAAA;AA2xCrB;;AA1xCA;EAAqB,6DAAA;AA8xCrB;;AA7xCA;EAAoB,4DAAA;AAiyCpB;;AAhyCA;EAAkB,0DAAA;AAoyClB;;AAjyCA;EAAgB,mCAAA;AAqyChB;;AApyCA;EAAgB,mCAAA;AAwyChB;;AAvyCA;EAAgB,mCAAA;AA2yChB;;AA1yCA;EAAe,kCAAA;AA8yCf;;AA7yCA;EAAa,gCAAA;AAizCb;;AA3yCA;EACE,WAAA;EACA,YAAA;AA8yCF;;AA3yCA;EACE,WAAA;EACA,YAAA;AA8yCF;;AA3yCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AA8yCF;;AAtyCE;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,wBAAA;AAyyCJ;AAtyCE;EACE,sBAAA;EACA,gBAAA;AAwyCJ;;AApyCA;EACE,mDAAA;AAuyCF;;AAhyCA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;AAmyCF;;AA5xCA;EACE,+CAAA;AA+xCF;AA7xCE;EACE,YAAA;EACA,oCAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA+xCJ;AA7xCI;EACE,yBAAA;EACA,wBAAA;AA+xCN;AA5xCI;EACE,wBAAA;EACA,sCAAA;EACA,6BAAA;AA8xCN;;AArxCA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uEAAA;EACA,aAAA;AAwxCF;AAtxCE;EACE,WAAA;EACA,gBAAA;AAwxCJ;AAtxCI;EACE,YAAA;EACA,0CAAA;EACA,sBAAA;AAwxCN;AArxCI;EACE,kBAAA;EACA,qBAAA;AAuxCN;AArxCM;EACE,wBAAA;EACA,gBAAA;EACA,iBAAA;AAuxCR;AApxCM;EACE,cAAA;EACA,gBAAA;AAsxCR;;AA5wCA;EACE,mBAAA;EACA,wCAAA;EACA,yCAAA;EACA,uBAAA;AA+wCF;AA7wCE;EACE,oBAAA;AA+wCJ;AA7wCI;EAEE,kDAAA;AA8wCN;AA1wCE;EACE,oCAAA;AA4wCJ;;AAtwCE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAywCJ;AAvwCI;EACE,qCAAA;AAywCN;AAtwCI;EACE,aAAA;AAwwCN;AArwCI;EACE,WAAA;EACA,YAAA;EACA,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAuwCN;AApwCI;EACE,gBAAA;AAswCN;AApwCM;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAswCR;AAnwCM;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAqwCR;;AA3vCA;EAAS,0BAAA;AA+vCT;;AA9vCA;EAAS,0BAAA;AAkwCT;;AA/vCA;EACE,aAAA;EACA,cAAA;AAkwCF;;AA9vCA;EACE,0CAAA;AAiwCF;;AA7vCA;;EAEE,+BAAA;EACA,2DAAA;AAgwCF;;AA5vCA;EACE,qBAAA;AA+vCF;;AAxvCA;EACE,gCAAA;EACA,6DAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AA2vCF;;AAxvCA;EACE,6BAAA;EACA,oBAAA;EACA,uDAAA;EACA,yCAAA;AA2vCF;AAzvCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;AA2vCJ;AAvvCI;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAyvCN;AArvCE;EACE,UAAA;EACA,gBAAA;EACA,YAAA;AAuvCJ;AArvCI;EACE,oCAAA;AAuvCN;AApvCI;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;AAsvCN;;AAjvCA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AAovCF;;AAjvCA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAovCF;;AAjvCA;EACE,kBAAA;EACA,mBAAA;AAovCF;AAlvCE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAovCJ;AAjvCE;EACE,cAAA;EACA,eAAA;EACA,SAAA;AAmvCJ;;AA/uCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;AAkvCF;;AA/uCA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AAkvCF;AAhvCE;EACE,2BAAA;EACA,0CAAA;AAkvCJ;AA/uCE;EACE,wBAAA;AAivCJ;AA9uCE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAgvCJ;AA9uCI;EACE,eAAA;EACA,YAAA;AAgvCN;AA5uCE;EACE,SAAA;EACA,iBAAA;AA8uCJ;AA5uCI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA8uCN;AA3uCI;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AA6uCN;AAzuCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA2uCJ;AAzuCI;EACE,kBAAA;EACA,cAAA;AA2uCN;AAruCI;EACE,6DAAA;AAuuCN;AApuCI;EACE,mCAAA;AAsuCN;AApuCM;EACE,cAAA;AAsuCR;AA/tCI;EACE,6DAAA;AAiuCN;AA9tCI;EACE,mCAAA;AAguCN;AA9tCM;EACE,cAAA;AAguCR;;AA1tCA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AA6tCF;AA3tCE;EACE,eAAA;AA6tCJ;;AAttCA;EACE;IACE,sBAAA;IACA,2DAAA;EAytCF;EAttCA;IACE,oBAAA;EAwtCF;EArtCA;IACE,qBAAA;EAutCF;EArtCE;IACE,iBAAA;EAutCJ;EAntCA;IACE,gBAAA;EAqtCF;EAntCE;IACE,WAAA;IACA,YAAA;EAqtCJ;EAntCI;IACE,kBAAA;EAqtCN;EAhtCI;IACE,iBAAA;EAktCN;EA/sCI;IACE,iBAAA;EAitCN;AACF;AAxsCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA0sCF;;AAvsCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;EACA,cAAA;EACA,WAAA;AA0sCF;AAxsCE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;AA0sCJ;AAxsCI;EACE,sBAAA;EACA,mBAAA;AA0sCN;AAvsCI;EACE,kBAAA;EACA,WAAA;AAysCN;AArsCE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;AAusCJ;;AAnsCA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,yBAAA;AAssCF;;AAlsCA;EACE,sBAAA;AAqsCF;AAnsCE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AAqsCJ;;AAjsCA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AAosCF;AAlsCE;EACE,SAAA;AAosCJ;;AAhsCA;;;EAGE,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mCAAA;EACA,wBAAA;EACA,cAAA;AAmsCF;AAjsCE;;;EACE,aAAA;EACA,+BAAA;AAqsCJ;AAlsCE;;;EACE,cAAA;AAssCJ;;AAlsCA;EACE,yDAAA;EACA,4BAAA;EACA,yCAAA;EACA,wBAAA;EACA,sBAAA;AAqsCF;;AAlsCA;EACE,YAAA;EACA,gBAAA;AAqsCF;;AAjsCA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAosCF;;AAjsCA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAosCF;AAlsCE;EACE,cAAA;AAosCJ;;AAhsCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,6DAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AAmsCF;AAjsCE;EACE,sBAAA;EACA,8CAAA;AAmsCJ;AAhsCE;EACE,YAAA;EACA,mBAAA;AAksCJ;AA/rCE;EACE,eAAA;EACA,sBAAA;AAisCJ;AA9rCE;EACE,iBAAA;EACA,gBAAA;AAgsCJ;;AA5rCA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;AA+rCF;AA7rCE;EACE,iBAAA;AA+rCJ;AA5rCE;EACE,8BAAA;AA8rCJ;;AA1rCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AA6rCF;;AA1rCA;EACE,aAAA;EACA,cAAA;EACA,6DAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;AA6rCF;AA3rCE;EACE,kBAAA;EACA,YAAA;AA6rCJ;;AAzrCA;EACE,kBAAA;AA4rCF;AA1rCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AA4rCJ;AAzrCE;EACE,cAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;AA2rCJ;;AAvrCA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,6DAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,6CAAA;EACA,6CAAA;AA0rCF;AAxrCE;EACE,iBAAA;AA0rCJ;AAvrCE;EACE,sBAAA;EACA,4CAAA;AAyrCJ;;AAprCA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAurCF;;AAprCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,wCAAA;AAurCF;AArrCE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAurCJ;;AAnrCA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;AAsrCF;AAprCE;EACE,mBAAA;AAsrCJ;AAnrCE;EACE,8BAAA;AAqrCJ;;AAjrCA;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gDAAA;AAorCF;AAlrCE;EACE,iBAAA;EACA,cAAA;AAorCJ;AAjrCE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AAmrCJ;AAhrCE;EACE,mBAAA;EACA,qBAAA;AAkrCJ;;AA7qCA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;AAgrCF;;AA7qCA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AAgrCF;AA9qCE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,wCAAA;AAgrCJ;AA7qCE;EACE,oBAAA;AA+qCJ;;AA3qCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AA8qCF;AA5qCE;EACE,mBAAA;AA8qCJ;;AA1qCA;EACE,UAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;AA6qCF;;AAzqCA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;AA4qCF;;AAzqCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AA4qCF;AAzqCE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,mBAAA;AA2qCJ;AAxqCE;EACE,6BAAA;AA0qCJ;;AAtqCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AAyqCF;AAvqCE;EACE,6BAAA;EACA,YAAA;EACA,4CAAA;AAyqCJ;AAtqCE;EACE,6BAAA;EACA,YAAA;AAwqCJ;AAtqCI;EACE,mBAAA;AAwqCN;;AAnqCA;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAsqCF;AApqCE;EACE,wBAAA;EACA,gBAAA;AAsqCJ;AAnqCE;EACE,wBAAA;AAqqCJ;;AAjqCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;AAoqCF;AAlqCE;EACE,6BAAA;AAoqCJ;;AAhqCA;EACE,kBAAA;EACA,mBAAA;AAmqCF;AAjqCE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAmqCJ;;AA/pCA;EACE,oBAAA;EACA,cAAA;AAkqCF;;AA9pCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,6DAAA;EACA,mBAAA;EACA,kBAAA;AAiqCF;;AA9pCA;EACE,kBAAA;EACA,aAAA;AAiqCF;AA/pCE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AAiqCJ;AA9pCE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAgqCJ;;AA5pCA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AA+pCF;AA7pCE;EACE,sBAAA;AA+pCJ;AA5pCE;EACE,mBAAA;EACA,SAAA;EACA,YAAA;AA8pCJ;;AAxpCE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,wBAAA;AA2pCJ;AAxpCE;EACE,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA0pCJ;AAxpCI;EACE,cAAA;AA0pCN;AAtpCE;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;AAwpCJ;;AAppCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAupCF;AArpCE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAupCJ;AArpCI;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAupCN;;AAlpCA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAqpCF;AAnpCE;EACE,yBAAA;AAqpCJ;;AAjpCA;EACE,+BAAA;EACA,yBAAA;EACA,kBAAA;AAopCF;;AAjpCA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAopCF;;AAjpCA;EACE,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAopCF;AAlpCE;EACE,sBAAA;EACA,mBAAA;AAopCJ;;AAhpCA;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAmpCF;AAjpCE;EACE,sBAAA;EACA,mBAAA;AAmpCJ;AAhpCE;EACE,eAAA;EACA,SAAA;EACA,cAAA;AAkpCJ;;AA7oCA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AAgpCF;AA9oCE;EACE,cAAA;EACA,cAAA;EACA,oBAAA;AAgpCJ;AA7oCE;EACE,cAAA;AA+oCJ;;AA3oCA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AA8oCF;;AA3oCA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AA8oCF;AA5oCE;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AA8oCJ;;AA1oCA;EACE,sBAAA;AA6oCF;;AA1oCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AA6oCF;AA3oCE;EACE,sBAAA;EACA,mBAAA;EACA,qBAAA;AA6oCJ;AA1oCE;EACE,YAAA;EACA,mBAAA;AA4oCJ;AAzoCE;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AA2oCJ;;AAtoCA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAyoCF;;AAroCA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,4BAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,wBAAA;EACA,sBAAA;EACA,0BAAA;AAwoCF;AAtoCE;EACE,mBAAA;EACA,+BAAA;AAwoCJ;AAroCE;EACE,kBAAA;AAuoCJ;AApoCE;EACE,SAAA;EACA,gBAAA;AAsoCJ;AAnoCE;EACE,kBAAA;EACA,cAAA;AAqoCJ;;AAjoCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAooCF;;AAhoCA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAmoCF;AAjoCE;EACE,mBAAA;EACA,cAAA;AAmoCJ;AAhoCE;EACE,mBAAA;AAkoCJ;;AA9nCA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;AAioCF;AA/nCE;EACE,kBAAA;AAioCJ;;AA7nCA;EACE,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AAgoCF;AA9nCE;EACE,+BAAA;EACA,mBAAA;AAgoCJ;AA7nCE;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;AA+nCJ;;AA3nCA;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AA8nCF;AA5nCE;EACE,mBAAA;EACA,cAAA;AA8nCJ;AA3nCE;EACE,mBAAA;EACA,cAAA;AA6nCJ;;AAznCA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AA4nCF;AA1nCE;EACE,mBAAA;AA4nCJ;;AAxnCA;EACE,qBAAA;EACA,cAAA;AA2nCF;AAznCE;EACE,mBAAA;EACA,cAAA;AA2nCJ;AAznCI;EACE,wBAAA;AA2nCN;;AAtnCA;EACE,SAAA;EACA,YAAA;AAynCF;AAvnCE;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AAynCJ;AAtnCE;EACE,cAAA;EACA,oBAAA;EACA,cAAA;AAwnCJ;;AApnCA;EACE,0BAAA;EACA,mBAAA;EACA,6BAAA;AAunCF;AArnCE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAunCJ;;AAnnCA;;EAEE,aAAA;EACA,aAAA;AAsnCF;;AAnnCA;;EAEE,SAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAsnCF;AApnCE;;EACE,sBAAA;AAunCJ;AApnCE;;EACE,6BAAA;EACA,+BAAA;EACA,YAAA;AAunCJ;;AAlnCA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAqnCF;;AAlnCA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAqnCF;AAnnCE;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;AAqnCJ;AAlnCE;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,wBAAA;AAonCJ;AAlnCI;EACE,aAAA;EACA,+BAAA;EACA,6CAAA;AAonCN;AAjnCI;EACE,cAAA;AAmnCN;;AA9mCA;EACE,oBAAA;EACA,cAAA;EACA,qBAAA;AAinCF;;AA7mCA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAgnCF;;AA7mCA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAgnCF;AA9mCE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AAgnCJ;AA7mCE;EACE,SAAA;AA+mCJ;;AA3mCA;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,yCAAA;EACA,qBAAA;EACA,mBAAA;AA8mCF;AA5mCE;EACE,aAAA;EACA,+BAAA;EACA,6CAAA;AA8mCJ;;AA1mCA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AA6mCF;;AA1mCA;EACE,sBAAA;EACA,uBAAA;EACA,WAAA;AA6mCF;;AAzmCA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,kCAAA;EACA,wBAAA;EACA,mBAAA;AA4mCF;;AAzmCA;EACE,aAAA;EACA,qCAAA;EACA,WAAA;EACA,sBAAA;AA4mCF;;AAzmCA;EACE,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AA4mCF;AA1mCE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA4mCJ;;AAxmCA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA2mCF;AAzmCE;EACE,YAAA;EACA,mBAAA;AA2mCJ;AAxmCE;EACE,qBAAA;AA0mCJ;;AAtmCA;EACE,aAAA;EACA,YAAA;AAymCF;;AAtmCA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,eAAA;EACA,0BAAA;AAymCF;AAvmCE;EACE,iBAAA;EACA,cAAA;AAymCJ;AAtmCE;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;AAwmCJ;AArmCE;EACE,sBAAA;EACA,mBAAA;EACA,+BAAA;AAumCJ;AArmCI;EACE,wBAAA;AAumCN;;AAlmCA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AAqmCF;AAnmCE;EACE,SAAA;EACA,gBAAA;AAqmCJ;AAlmCE;EACE,eAAA;EACA,cAAA;AAomCJ;AAjmCE;EACE,mBAAA;EACA,cAAA;AAmmCJ;AAhmCE;EACE,sBAAA;EACA,mBAAA;AAkmCJ;AA/lCE;EACE,cAAA;EACA,+BAAA;EACA,mCAAA;AAimCJ;AA/lCI;EACE,wBAAA;AAimCN;;AA3lCA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;AA8lCF;AA5lCE;EACE,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;AA8lCJ;AA5lCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AA8lCN;AA5lCM;EACE,eAAA;EACA,wBAAA;AA8lCR;;AAxlCA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0DAAA;AA2lCF;AAzlCE;EACE,aAAA;EACA,+BAAA;EACA,6CAAA;AA2lCJ;AAxlCE;EACE,cAAA;AA0lCJ;;AAtlCA;EACE,oBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAylCF;;AArlCA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AAwlCF;AAtlCE;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AAwlCJ;AArlCE;EACE,SAAA;AAulCJ;;AAllCA;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,gEAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,qDAAA;AAqlCF;AAllCE;EACE,UAAA;EACA,kBAAA;EACA,oBAAA;AAolCJ;;AAhlCA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;EACA,cAAA;AAmlCF;AAjlCE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAmlCJ;AAhlCE;EACE,oBAAA;AAklCJ;;AA9kCA;EACE,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAilCF;AA/kCE;EACE,sBAAA;EACA,YAAA;AAilCJ;AA9kCE;EACE,YAAA;EACA,mBAAA;AAglCJ;AA7kCE;EACE,eAAA;AA+kCJ;;AA3kCA;EACE,wBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA8kCF;AA5kCE;EACE,sBAAA;EACA,mBAAA;AA8kCJ;AA3kCE;EACE,eAAA;AA6kCJ;;AAxkCA;EACE,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,8DAAA;AA2kCF;AAzkCE;EACE,WAAA;EACA,uBAAA;AA2kCJ;;AAvkCA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA0kCF;AAxkCE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA0kCJ;AAvkCE;EACE,mBAAA;AAykCJ;;AAjkCA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;AAokCF;;AAjkCA;EACE;IAAO,UAAA;EAqkCP;EApkCA;IAAK,UAAA;EAukCL;AACF;AArkCA;EACE;IAAO,2BAAA;EAwkCP;EAvkCA;IAAK,wBAAA;EA0kCL;AACF;AAxkCA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;AA0kCF;AAvkCE;EACE,gDAAA;AAykCJ;;AArkCA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AAwkCF;;AArkCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;EACA,cAAA;AAwkCF;AAtkCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAwkCJ;;AApkCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAukCF;AArkCE;EACE,mBAAA;AAukCJ;AApkCE;EACE,kBAAA;EACA,cAAA;AAskCJ;;AAlkCA;EACE,SAAA;EACA,gBAAA;EACA,iCAAA;EACA,8CAAA;AAqkCF;;AAlkCA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AAqkCF;AAnkCE;EACE,iBAAA;EACA,sBAAA;EACA,YAAA;AAqkCJ;AAlkCE;EACE,SAAA;EACA,oBAAA;AAokCJ;;AAhkCA;EACE,iBAAA;AAmkCF;;AAhkCA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAmkCF;AAjkCE;EACE,mBAAA;AAmkCJ;AAhkCE;EACE,mBAAA;AAkkCJ;;AA9jCA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;AAikCF;;AA9jCA;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;AAikCF;AA/jCE;EACE,wBAAA;AAikCJ;;AA7jCA;EACE,oBAAA;EACA,cAAA;AAgkCF;;AA7jCA;EACE,kBAAA;EACA,wBAAA;EACA,cAAA;EACA,oBAAA;AAgkCF;;AA7jCA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,gCAAA;AAgkCF;AA9jCE;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AAgkCJ;AA7jCE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AA+jCJ;AA7jCI;EACE,cAAA;AA+jCN;AA3jCE;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AA6jCJ;AA3jCI;EACE,cAAA;AA6jCN;;AAvjCA;EACE,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;AA0jCF;AAxjCE;EACE,gBAAA;AA0jCJ;;AAtjCA;EACE,YAAA;EACA,mBAAA;AAyjCF;;AAtjCA;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAyjCF;AAvjCE;EACE,wBAAA;AAyjCJ;AAtjCE;EACE,cAAA;AAwjCJ;;AApjCA;EACE,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAujCF;;AApjCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,6BAAA;EACA,cAAA;EACA,8DAAA;AAujCF;;AApjCA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAujCF;;AApjCA;EACE,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAujCF;AArjCE;EACE,aAAA;AAujCJ;;AAljCA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,gBAAA;AAqjCF;AAnjCE;EACE,+BAAA;AAqjCJ;AAljCE;EACE,cAAA;AAojCJ;AAjjCE;EACE,cAAA;AAmjCJ;AAhjCE;EACE,mBAAA;EACA,cAAA;EACA,cAAA;AAkjCJ;;AA9iCA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAijCF;;AA1iCA;EAEE;IACE,eAAA;EA4iCF;EAxiCA;IACE,aAAA;EA0iCF;EAtiCA;IACE,iCAAA;IACA,kCAAA;IACA,YAAA;EAwiCF;EAtiCE;IACE,WAAA;EAwiCJ;EAtiCI;IACE,WAAA;EAwiCN;AACF;AA/hCA;EAEE;IACE,wBAAA;EAgiCF;EA7hCA;IACE,0DAAA;EA+hCF;EA3hCA;IACE,eAAA;IACA,gBAAA;EA6hCF;EAzhCA;IACE,mBAAA;IACA,uBAAA;IACA,qBAAA;IACA,sBAAA;EA2hCF;EAzhCE;IACE,sBAAA;EA2hCJ;EAzhCI;IACE,iBAAA;EA2hCN;EAvhCE;IACE,aAAA;EAyhCJ;EAphCA;IACE,uBAAA;IACA,mBAAA;EAshCF;EAphCE;IACE,eAAA;EAshCJ;EAjhCA;IACE,eAAA;IACA,eAAA;IACA,gBAAA;IACA,iCAAA;EAmhCF;EAhhCA;IACE,iBAAA;IACA,mBAAA;EAkhCF;EAhhCE;IACE,iBAAA;IACA,eAAA;EAkhCJ;EA/gCE;IACE,eAAA;EAihCJ;EA5gCA;IACE,gBAAA;IACA,oBAAA;EA8gCF;EA3gCA;IACE,gBAAA;IACA,yBAAA;EA6gCF;EAzgCA;;IAEE,gBAAA;IACA,eAAA;EA2gCF;EAvgCA;IACE,cAAA;IACA,4BAAA;EAygCF;EAtgCA;IACE,4BAAA;EAwgCF;EApgCA;IACE,WAAA;IACA,YAAA;EAsgCF;EAngCA;IACE,cAAA;IACA,eAAA;EAqgCF;EAjgCA;;;;IAIE,aAAA;EAmgCF;EAjgCE;;;;IACE,4BAAA;EAsgCJ;EAhgCE;IACE,6BAAA;EAkgCJ;EA7/BA;IACE,iBAAA;IACA,iBAAA;EA+/BF;EA3/BA;IACE,kBAAA;IACA,qBAAA;EA6/BF;EAz/BA;IACE,YAAA;IACA,cAAA;EA2/BF;EAv/BA;IACE,aAAA;EAy/BF;EAr/BA;IACE,iBAAA;EAu/BF;EAn/BA;IACE,sBAAA;EAq/BF;EAl/BA;IACE,sBAAA;IACA,sBAAA;EAo/BF;AACF;AA7+BA;EACE;IACE,+DAAA;EA++BF;EA3+BE;IACE,gBAAA;EA6+BJ;EAz+BA;IACE,kBAAA;EA2+BF;EAv+BA;;IAEE,aAAA;EAy+BF;AACF;AAj+BA;EAEE;IACE,wBAAA;EAk+BF;EA99BA;IACE,qBAAA;EAg+BF;EA59BA;IACE,eAAA;EA89BF;AACF;AAv9BA;EACE;IACE,mDAAA;IACA,sBAAA;EAy9BF;EAt9BA;IACE,kBAAA;EAw9BF;AACF;AAj9BA;EACE;IACE,2CAAA;EAm9BF;EAh9BA;IACE,qCAAA;IACA,2CAAA;EAk9BF;EA/8BA;IACE;MACE,qCAAA;MACA,gEAAA;IAi9BF;IA98BA;MACE,8EAAA;MACA,wDAAA;IAg9BF;EACF;AACF;AAv8BE;EACE,oBAAA;EACA,+CAAA;AAy8BJ;AAv8BI;EACE,iBAAA;EACA,gBAAA;AAy8BN;AAp8BI;EACE,iBAAA;EACA,gBAAA;AAs8BN;AAp8BM;EACE,cAAA;EACA,kBAAA;AAs8BR;AAh8BE;EACE,eAAA;EACA,+CAAA;AAk8BJ;AAh8BI;EACE,mBAAA;AAk8BN;AA97BE;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAg8BJ;AA97BI;EACE,eAAA;AAg8BN;AA77BI;EACE,iBAAA;EACA,gBAAA;AA+7BN;AA17BE;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;AA47BJ;AAz7BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,+CAAA;EACA,6BAAA;AA27BJ;AAz7BI;EACE,mBAAA;AA27BN;AAx7BI;EACE,mBAAA;EACA,gBAAA;AA07BN;AAv7BI;EACE,kBAAA;AAy7BN;AAt7BI;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAw7BN;AAp7BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,6CAAA;EACA,mBAAA;AAs7BJ;AAp7BI;EACE,wBAAA;AAs7BN;AAj7BE;EACE,aAAA;EACA,4DAAA;EACA,YAAA;AAm7BJ;AAh7BE;EACE,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,qDAAA;AAk7BJ;AAh7BI;EACE,sBAAA;EACA,0CAAA;AAk7BN;AA/6BI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAi7BN;;AA36BA;EAEI;IACE,eAAA;EA66BJ;EA16BE;IACE,kBAAA;EA46BJ;EAz6BE;IACE,0BAAA;IACA,eAAA;IACA,WAAA;EA26BJ;EAz6BI;IACE,SAAA;IACA,YAAA;EA26BN;EAx6BI;IACE,oBAAA;EA06BN;EAt6BE;IACE,qCAAA;IACA,WAAA;EAw6BJ;EAr6BE;IACE,uBAAA;EAu6BJ;AACF;AA/5BA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAi6BF;AA/5BE;EACE,6BAAA;EACA,wCAAA;EACA,qBAAA;EACA,gBAAA;AAi6BJ;AA95BE;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,qBAAA;EACA,2BAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;AAg6BJ;AA95BI;EACE,eAAA;EACA,wBAAA;AAg6BN;AA55BE;EACE,aAAA;AA85BJ;AA55BI;EACE,mBAAA;AA85BN;AA55BM;EACE,gBAAA;AA85BR;AA15BI;EACE,oBAAA;EACA,gBAAA;EACA,uBAAA;AA45BN;AAv5BE;EACE,iBAAA;EACA,gBAAA;AAy5BJ;AAt5BE;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,+CAAA;AAw5BJ;AAt5BI;EACE,mBAAA;AAw5BN;AAr5BI;EACE,iCAAA;AAu5BN;AAn5BE;EACE,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AAq5BJ;AAn5BI;EACE,iBAAA;AAq5BN;AAj5BE;EACE,SAAA;EACA,YAAA;AAm5BJ;AAh5BE;EACE,oBAAA;EACA,sBAAA;AAk5BJ;AAh5BI;EACE,8BAAA;AAk5BN;AA94BE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAg5BJ;AA74BE;EACE,kBAAA;AA+4BJ;AA34BE;EACE,mBAAA;EACA,2BAAA;EACA,wBAAA;EACA,YAAA;AA64BJ;AA34BI;EACE,SAAA;AA64BN;AA14BI;EACE,YAAA;EACA,oCAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,0BAAA;AA44BN;AA14BM;EACE,6CAAA;AA44BR;AAz4BM;EACE,6BAAA;EACA,wBAAA;EACA,4CAAA;AA24BR;AAx4BM;EACE,eAAA;AA04BR;AAv4BM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;AAy4BR;AAp4BE;EACE,6BAAA;AAs4BJ;AAn4BE;EACE,aAAA;AAq4BJ;AAj4BE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAm4BJ;AAh4BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;AAk4BJ;AAh4BI;EAEE,eAAA;AAi4BN;AA73BE;EACE,SAAA;EACA,YAAA;AA+3BJ;AA73BI;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA+3BN;AA53BI;EACE,cAAA;EACA,kBAAA;EACA,gCAAA;AA83BN;AA13BE;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;AA43BJ;AA13BI;;;;EAEE,oBAAA;AA83BN;AA13BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,2CAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;AA43BJ;AA13BI;EACE,4BAAA;EACA,YAAA;AA43BN;AAz3BI;EACE,eAAA;AA23BN;AAt3BE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAw3BJ;AAr3BE;EACE,mBAAA;EACA,wCAAA;EACA,qBAAA;EACA,gBAAA;EACA,0BAAA;AAu3BJ;AAr3BI;EACE,6CAAA;EACA,+BAAA;AAu3BN;AAp3BI;EACE,mBAAA;AAs3BN;AAl3BE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAo3BJ;AAj3BE;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAm3BJ;AAj3BI;EACE,kBAAA;EACA,gCAAA;EACA,0BAAA;AAm3BN;AAh3BI;EACE,wBAAA;AAk3BN;AA92BE;EACE,SAAA;EACA,YAAA;AAg3BJ;AA92BI;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAg3BN;AA72BI;EACE,cAAA;EACA,kBAAA;EACA,gCAAA;AA+2BN;AA52BI;EACE,oBAAA;AA82BN;AA12BE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,6CAAA;EACA,uDAAA;AA42BJ;AAz2BE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA22BJ;AAx2BE;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AA02BJ;AAt2BE;EACE,aAAA;EACA,YAAA;AAw2BJ;AAr2BE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,eAAA;EACA,0BAAA;AAu2BJ;AAr2BI;EACE,+BAAA;EACA,wBAAA;AAu2BN;AAp2BI;EACE,6BAAA;EACA,+BAAA;EACA,YAAA;AAs2BN;AAj2BE;EACE,aAAA;EACA,YAAA;AAm2BJ;AAh2BE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;AAk2BJ;AAh2BI;EACE,+BAAA;EACA,wBAAA;AAk2BN;AA/1BI;EACE,6BAAA;EACA,+BAAA;EACA,YAAA;AAi2BN;AA51BE;;EAEE,sBAAA;EACA,uBAAA;AA81BJ;AA51BI;;EACE,WAAA;AA+1BN;AA51BI;;;;EAEE,SAAA;EACA,oBAAA;AAg2BN;AA31BE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AA61BJ;AA11BE;EACE,aAAA;EACA,2DAAA;EACA,WAAA;AA41BJ;AAz1BE;EACE,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,2BAAA;AA21BJ;AAz1BI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA21BN;AAx1BI;EACE,YAAA;AA01BN;AAt1BE;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AAw1BJ;AAt1BI;EACE,4BAAA;EACA,qBAAA;AAw1BN;AAr1BI;EACE,mBAAA;AAu1BN;AAn1BE;EACE,gBAAA;AAq1BJ;AAl1BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,yCAAA;EACA,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,0BAAA;AAo1BJ;AAl1BI;EACE,+BAAA;EACA,6CAAA;AAo1BN;AAj1BI;EACE,iBAAA;EACA,wBAAA;AAm1BN;AAh1BI;EACE,mBAAA;EACA,gBAAA;EACA,2BAAA;AAk1BN;AA/0BI;EACE,kBAAA;EACA,gCAAA;AAi1BN;AA70BE;;EAEE,mBAAA;AA+0BJ;AA30BE;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,4CAAA;AA60BJ;;AAx0BA;EACE;IACE,SAAA;EA20BF;EAz0BE;IACE,0BAAA;IACA,kBAAA;EA20BJ;EAx0BE;IACE,iBAAA;EA00BJ;EAv0BE;IACE,4BAAA;EAy0BJ;EAv0BI;IACE,eAAA;IACA,kBAAA;EAy0BN;EAv0BM;IACE,mBAAA;EAy0BR;EAt0BM;IACE,eAAA;IACA,YAAA;IACA,mBAAA;EAw0BR;EAn0BE;IACE,iBAAA;EAq0BJ;EAj0BE;IACE,iBAAA;IACA,WAAA;EAm0BJ;EAh0BE;IACE,cAAA;IACA,eAAA;EAk0BJ;EAh0BI;IACE,iBAAA;EAk0BN;EA7zBI;IACE,oBAAA;EA+zBN;EA5zBI;IACE,iBAAA;EA8zBN;EA1zBE;IACE,wBAAA;IACA,qBAAA;EA4zBJ;EAzzBE;IACE,iBAAA;EA2zBJ;EAxzBE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EA0zBJ;EAvzBE;IACE,sBAAA;IACA,iBAAA;EAyzBJ;EArzBE;IACE,2DAAA;IACA,aAAA;EAuzBJ;EApzBE;IACE,aAAA;EAszBJ;EApzBI;IACE,kBAAA;EAszBN;EAnzBI;IACE,oBAAA;EAqzBN;EAjzBE;IACE,iBAAA;EAmzBJ;EAhzBE;IACE,oBAAA;EAkzBJ;EA/yBE;IACE,8BAAA;EAizBJ;EA/yBI;IACE,WAAA;EAizBN;AACF;AAxyBA;EACE,eAAA;EACA,cAAA;EACA,0BAAA;AA0yBF;AAxyBE;EACE,cAAA;EACA,0BAAA;AA0yBJ;;AAtyBA;EACE,qDAAA;AAyyBF;AAvyBE;EACE,sBAAA;EACA,qDAAA;AAyyBJ;AAvyBI;EACE,qBAAA;AAyyBN;;AAjyBA;EACE;;;;;;;;;;IAUE,0BAAA;EAoyBF;AACF","sourcesContent":["// =============================================\n// ADMIN MOBILE CARD STYLES\n// Mobile-first design for construction management\n// =============================================\n\n// =============================================\n// 1. CARD LIST CONTAINER\n// =============================================\n\n.admin-card-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n\n  @media (min-width: 768px) {\n    gap: 1rem;\n  }\n}\n\n// =============================================\n// 2. CARD ITEM\n// =============================================\n\n.admin-card-item {\n  background: var(--vz-card-bg);\n  border: 1px solid var(--vz-card-border-color);\n  border-radius: 0.75rem;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  transition: all 0.2s ease;\n\n  &:active {\n    transform: scale(0.99);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  @media (min-width: 768px) {\n    border-radius: 0.875rem;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    }\n  }\n}\n\n// Card Header\n.admin-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.875rem 1rem;\n  border-bottom: 1px solid var(--vz-border-color);\n  background: linear-gradient(to bottom, rgba(var(--vz-primary-rgb), 0.02), transparent);\n\n  @media (min-width: 768px) {\n    padding: 1rem 1.25rem;\n  }\n}\n\n.admin-card-title {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #212529;\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  @media (min-width: 768px) {\n    font-size: 1rem;\n  }\n}\n\n.admin-card-badge {\n  flex-shrink: 0;\n  margin-left: 0.75rem;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.375rem;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n\n  // Badge variants\n  &.badge-active {\n    background: rgba(var(--vz-success-rgb), 0.1);\n    color: var(--vz-success);\n  }\n\n  &.badge-inactive {\n    background: rgba(var(--vz-danger-rgb), 0.1);\n    color: var(--vz-danger);\n  }\n\n  &.badge-pending {\n    background: rgba(var(--vz-warning-rgb), 0.1);\n    color: var(--vz-warning);\n  }\n\n  &.badge-completed {\n    background: rgba(var(--vz-info-rgb), 0.1);\n    color: var(--vz-info);\n  }\n\n  &.badge-primary {\n    background: rgba(var(--vz-primary-rgb), 0.1);\n    color: var(--vz-primary);\n  }\n}\n\n// Card Body\n.admin-card-body {\n  padding: 1rem;\n\n  @media (min-width: 768px) {\n    padding: 1.25rem;\n  }\n}\n\n// Card Footer\n.admin-card-footer {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.875rem 1rem;\n  border-top: 1px solid var(--vz-border-color);\n  background: rgba(var(--vz-primary-rgb), 0.01);\n\n  @media (min-width: 768px) {\n    padding: 1rem 1.25rem;\n    gap: 0.75rem;\n  }\n}\n\n// =============================================\n// 3. INFO ROW - LABEL-VALUE PAIRS\n// =============================================\n\n.admin-info-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid rgba(var(--vz-border-color), 0.4);\n  }\n\n  @media (min-width: 768px) {\n    padding: 0.625rem 0;\n    gap: 1rem;\n  }\n}\n\n.admin-info-label {\n  flex-shrink: 0;\n  width: 90px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n\n  i {\n    font-size: 0.875rem;\n    margin-right: 0.375rem;\n    color: var(--vz-primary);\n  }\n\n  @media (min-width: 768px) {\n    width: 110px;\n    font-size: 0.8125rem;\n  }\n}\n\n.admin-info-value {\n  flex: 1;\n  font-size: 0.875rem;\n  color: #212529;\n  font-weight: 500;\n  word-break: break-word;\n\n  // Value variants\n  &.value-muted {\n    color: #6c757d;\n    font-style: italic;\n  }\n\n  &.value-highlight {\n    color: var(--vz-primary);\n    font-weight: 600;\n  }\n\n  &.value-success {\n    color: var(--vz-success);\n    font-weight: 600;\n  }\n\n  &.value-danger {\n    color: var(--vz-danger);\n    font-weight: 600;\n  }\n\n  @media (min-width: 768px) {\n    font-size: 0.9375rem;\n  }\n}\n\n// Compact info row variant\n.admin-info-row-compact {\n  padding: 0.375rem 0;\n  gap: 0.5rem;\n\n  .admin-info-label {\n    width: 70px;\n    font-size: 0.6875rem;\n  }\n\n  .admin-info-value {\n    font-size: 0.8125rem;\n  }\n}\n\n// =============================================\n// 4. TOUCH-FRIENDLY ACTION BUTTONS\n// =============================================\n\n.admin-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n  min-height: 44px;\n  padding: 0.625rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  text-decoration: none;\n  white-space: nowrap;\n\n  i {\n    font-size: 1rem;\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.96);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  // Full width variant\n  &.btn-block {\n    width: 100%;\n  }\n\n  @media (min-width: 768px) {\n    min-height: 40px;\n    padding: 0.5rem 1rem;\n    font-size: 0.8125rem;\n\n    &:hover:not(:disabled) {\n      transform: translateY(-1px);\n      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n    }\n\n    &:active:not(:disabled) {\n      transform: translateY(0);\n    }\n  }\n}\n\n// =============================================\n// 5. MOBILE-SPECIFIC BUTTON STYLES\n// =============================================\n\n.admin-btn-primary {\n  background: var(--vz-primary);\n  color: white;\n\n  &:hover:not(:disabled) {\n    background: rgba(var(--vz-primary-rgb), 0.9);\n  }\n\n  &:active:not(:disabled) {\n    background: rgba(var(--vz-primary-rgb), 0.85);\n  }\n}\n\n.admin-btn-success {\n  background: var(--vz-success);\n  color: white;\n\n  &:hover:not(:disabled) {\n    background: rgba(var(--vz-success-rgb), 0.9);\n  }\n\n  &:active:not(:disabled) {\n    background: rgba(var(--vz-success-rgb), 0.85);\n  }\n}\n\n.admin-btn-danger {\n  background: var(--vz-danger);\n  color: white;\n\n  &:hover:not(:disabled) {\n    background: rgba(var(--vz-danger-rgb), 0.9);\n  }\n\n  &:active:not(:disabled) {\n    background: rgba(var(--vz-danger-rgb), 0.85);\n  }\n}\n\n.admin-btn-warning {\n  background: var(--vz-warning);\n  color: #212529;\n\n  &:hover:not(:disabled) {\n    background: rgba(var(--vz-warning-rgb), 0.9);\n  }\n\n  &:active:not(:disabled) {\n    background: rgba(var(--vz-warning-rgb), 0.85);\n  }\n}\n\n.admin-btn-outline {\n  background: white;\n  color: var(--vz-primary);\n  border: 1px solid var(--vz-primary);\n\n  &:hover:not(:disabled) {\n    background: rgba(var(--vz-primary-rgb), 0.05);\n  }\n\n  &:active:not(:disabled) {\n    background: rgba(var(--vz-primary-rgb), 0.1);\n  }\n\n  // Outline variants\n  &.btn-outline-danger {\n    color: var(--vz-danger);\n    border-color: var(--vz-danger);\n\n    &:hover:not(:disabled) {\n      background: rgba(var(--vz-danger-rgb), 0.05);\n    }\n\n    &:active:not(:disabled) {\n      background: rgba(var(--vz-danger-rgb), 0.1);\n    }\n  }\n\n  &.btn-outline-success {\n    color: var(--vz-success);\n    border-color: var(--vz-success);\n\n    &:hover:not(:disabled) {\n      background: rgba(var(--vz-success-rgb), 0.05);\n    }\n\n    &:active:not(:disabled) {\n      background: rgba(var(--vz-success-rgb), 0.1);\n    }\n  }\n}\n\n.admin-btn-ghost {\n  background: rgba(var(--vz-primary-rgb), 0.08);\n  color: var(--vz-primary);\n\n  &:hover:not(:disabled) {\n    background: rgba(var(--vz-primary-rgb), 0.12);\n  }\n\n  &:active:not(:disabled) {\n    background: rgba(var(--vz-primary-rgb), 0.16);\n  }\n}\n\n// Icon-only button\n.admin-btn-icon {\n  padding: 0.625rem;\n  min-width: 44px;\n  border-radius: 0.5rem;\n\n  i {\n    font-size: 1.125rem;\n    margin: 0;\n  }\n\n  @media (min-width: 768px) {\n    min-width: 40px;\n    padding: 0.5rem;\n  }\n}\n\n// =============================================\n// 6. COLLAPSIBLE FILTER SECTION\n// =============================================\n\n.admin-filter-section {\n  background: var(--vz-card-bg);\n  border: 1px solid var(--vz-card-border-color);\n  border-radius: 0.75rem;\n  margin-bottom: 1rem;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.admin-filter-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 1rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:active {\n    background: rgba(var(--vz-primary-rgb), 0.04);\n  }\n\n  @media (min-width: 768px) {\n    &:hover {\n      background: rgba(var(--vz-primary-rgb), 0.03);\n    }\n  }\n}\n\n.admin-filter-toggle-text {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #212529;\n\n  i {\n    font-size: 1.125rem;\n    color: var(--vz-primary);\n  }\n}\n\n.admin-filter-toggle-icon {\n  font-size: 1.25rem;\n  color: #6c757d;\n  transition: transform 0.2s ease;\n\n  &.expanded {\n    transform: rotate(180deg);\n  }\n}\n\n.admin-filter-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n\n  &.expanded {\n    max-height: 1000px;\n  }\n}\n\n.admin-filter-body {\n  padding: 0 1rem 1rem;\n  border-top: 1px solid var(--vz-border-color);\n  padding-top: 1rem;\n}\n\n.admin-filter-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n\n  @media (min-width: 576px) {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.75rem;\n  }\n}\n\n.admin-filter-label {\n  flex-shrink: 0;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #495057;\n  min-width: 80px;\n}\n\n.admin-filter-input {\n  flex: 1;\n  min-height: 44px;\n  padding: 0.625rem 0.875rem;\n  font-size: 0.875rem;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  background: white;\n  transition: border-color 0.15s ease;\n\n  &:focus {\n    outline: none;\n    border-color: var(--vz-primary);\n    box-shadow: 0 0 0 3px rgba(var(--vz-primary-rgb), 0.1);\n  }\n\n  @media (min-width: 768px) {\n    min-height: 40px;\n    font-size: 16px; // Prevent zoom on iOS\n  }\n}\n\n.admin-filter-actions {\n  display: flex;\n  gap: 0.5rem;\n  padding-top: 0.75rem;\n  border-top: 1px dashed var(--vz-border-color);\n}\n\n// Filter badge counter\n.admin-filter-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.25rem;\n  height: 1.25rem;\n  padding: 0 0.375rem;\n  background: var(--vz-primary);\n  color: white;\n  border-radius: 0.625rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  margin-left: 0.5rem;\n}\n\n// =============================================\n// 7. EMPTY STATE STYLING\n// =============================================\n\n.admin-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1.5rem;\n  text-align: center;\n  background: var(--vz-card-bg);\n  border: 1px dashed var(--vz-card-border-color);\n  border-radius: 0.75rem;\n  min-height: 280px;\n\n  @media (min-width: 768px) {\n    padding: 4rem 2rem;\n    min-height: 320px;\n  }\n}\n\n.admin-empty-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(var(--vz-primary-rgb), 0.1), rgba(var(--vz-primary-rgb), 0.05));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.25rem;\n\n  i {\n    font-size: 2.5rem;\n    color: rgba(var(--vz-primary-rgb), 0.6);\n  }\n\n  @media (min-width: 768px) {\n    width: 100px;\n    height: 100px;\n\n    i {\n      font-size: 3rem;\n    }\n  }\n}\n\n.admin-empty-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #212529;\n  margin: 0 0 0.5rem;\n\n  @media (min-width: 768px) {\n    font-size: 1.25rem;\n  }\n}\n\n.admin-empty-text {\n  font-size: 0.875rem;\n  color: #6c757d;\n  margin: 0 0 1.5rem;\n  max-width: 400px;\n  line-height: 1.6;\n\n  @media (min-width: 768px) {\n    font-size: 0.9375rem;\n  }\n}\n\n.admin-empty-action {\n  margin-top: 0.5rem;\n}\n\n// =============================================\n// 8. LOADING SKELETON PLACEHOLDER\n// =============================================\n\n.admin-skeleton {\n  animation: skeleton-loading 1.2s ease-in-out infinite;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  border-radius: 0.375rem;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.admin-skeleton-card {\n  background: var(--vz-card-bg);\n  border: 1px solid var(--vz-card-border-color);\n  border-radius: 0.75rem;\n  padding: 1rem;\n  margin-bottom: 0.75rem;\n\n  @media (min-width: 768px) {\n    padding: 1.25rem;\n    margin-bottom: 1rem;\n  }\n}\n\n.admin-skeleton-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.admin-skeleton-title {\n  height: 1.25rem;\n  width: 60%;\n  max-width: 200px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.2s ease-in-out infinite;\n  border-radius: 0.375rem;\n}\n\n.admin-skeleton-badge {\n  height: 1.5rem;\n  width: 60px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.2s ease-in-out infinite;\n  border-radius: 0.375rem;\n}\n\n.admin-skeleton-line {\n  height: 0.875rem;\n  margin-bottom: 0.75rem;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.2s ease-in-out infinite;\n  border-radius: 0.375rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &.line-short {\n    width: 40%;\n  }\n\n  &.line-medium {\n    width: 65%;\n  }\n\n  &.line-long {\n    width: 85%;\n  }\n}\n\n.admin-skeleton-actions {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--vz-border-color);\n}\n\n.admin-skeleton-button {\n  flex: 1;\n  height: 44px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.2s ease-in-out infinite;\n  border-radius: 0.5rem;\n}\n\n// =============================================\n// 9. MOBILE PAGE HEADER ADJUSTMENTS\n// =============================================\n\n.admin-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 0;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n\n  @media (min-width: 768px) {\n    padding: 1rem 0;\n    margin-bottom: 1.5rem;\n  }\n}\n\n.admin-page-title {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #212529;\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n\n  @media (min-width: 768px) {\n    font-size: 1.375rem;\n  }\n}\n\n.admin-page-subtitle {\n  font-size: 0.8125rem;\n  color: #6c757d;\n  margin: 0.25rem 0 0;\n  font-weight: 400;\n}\n\n.admin-page-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n\n  @media (max-width: 575.98px) {\n    width: 100%;\n\n    .admin-action-btn {\n      flex: 1;\n    }\n  }\n}\n\n.admin-page-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  padding-top: 0.5rem;\n  font-size: 0.8125rem;\n  color: #6c757d;\n\n  @media (min-width: 768px) {\n    width: auto;\n  }\n}\n\n.admin-page-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n\n  i {\n    font-size: 0.9375rem;\n    color: var(--vz-primary);\n  }\n}\n\n// =============================================\n// 10. STICKY MOBILE ACTION BAR\n// =============================================\n\n.admin-sticky-action-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: white;\n  border-top: 1px solid var(--vz-border-color);\n  padding: 0.75rem 1rem;\n  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0));\n  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);\n  z-index: 1000;\n  transition: transform 0.3s ease;\n\n  &.hidden {\n    transform: translateY(100%);\n  }\n\n  @media (min-width: 992px) {\n    // Hide on desktop\n    display: none;\n  }\n}\n\n.admin-sticky-action-content {\n  display: flex;\n  gap: 0.75rem;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.admin-sticky-action-primary {\n  flex: 1;\n}\n\n.admin-sticky-action-secondary {\n  flex-shrink: 0;\n}\n\n// Add bottom padding to content when sticky bar is visible\n.has-sticky-action-bar {\n  padding-bottom: calc(80px + env(safe-area-inset-bottom, 0)) !important;\n}\n\n// =============================================\n// ADDITIONAL UTILITY CLASSES\n// =============================================\n\n// Status indicators\n.admin-status-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 0.5rem;\n\n  &.status-active {\n    background: var(--vz-success);\n    box-shadow: 0 0 0 3px rgba(var(--vz-success-rgb), 0.2);\n  }\n\n  &.status-inactive {\n    background: #adb5bd;\n  }\n\n  &.status-pending {\n    background: var(--vz-warning);\n    animation: pulse 2s ease-in-out infinite;\n  }\n\n  &.status-error {\n    background: var(--vz-danger);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n// Quick stats\n.admin-quick-stats {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.75rem 0;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.admin-stat-card {\n  flex-shrink: 0;\n  min-width: 140px;\n  padding: 0.875rem 1rem;\n  background: linear-gradient(135deg, rgba(var(--vz-primary-rgb), 0.1), rgba(var(--vz-primary-rgb), 0.05));\n  border-radius: 0.75rem;\n  border: 1px solid rgba(var(--vz-primary-rgb), 0.15);\n\n  &.stat-success {\n    background: linear-gradient(135deg, rgba(var(--vz-success-rgb), 0.1), rgba(var(--vz-success-rgb), 0.05));\n    border-color: rgba(var(--vz-success-rgb), 0.15);\n  }\n\n  &.stat-warning {\n    background: linear-gradient(135deg, rgba(var(--vz-warning-rgb), 0.1), rgba(var(--vz-warning-rgb), 0.05));\n    border-color: rgba(var(--vz-warning-rgb), 0.15);\n  }\n\n  &.stat-danger {\n    background: linear-gradient(135deg, rgba(var(--vz-danger-rgb), 0.1), rgba(var(--vz-danger-rgb), 0.05));\n    border-color: rgba(var(--vz-danger-rgb), 0.15);\n  }\n}\n\n.admin-stat-label {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  margin-bottom: 0.25rem;\n}\n\n.admin-stat-value {\n  font-size: 1.375rem;\n  font-weight: 700;\n  color: var(--vz-primary);\n  margin: 0;\n\n  .stat-success & {\n    color: var(--vz-success);\n  }\n\n  .stat-warning & {\n    color: var(--vz-warning);\n  }\n\n  .stat-danger & {\n    color: var(--vz-danger);\n  }\n}\n\n// Divider\n.admin-divider {\n  height: 1px;\n  background: var(--vz-border-color);\n  margin: 1rem 0;\n\n  &.divider-dashed {\n    background: none;\n    border-bottom: 1px dashed var(--vz-border-color);\n  }\n}\n\n// Responsive text utilities\n.admin-text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-text-clamp-2 {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.admin-text-clamp-3 {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n// Touch feedback enhancement\n@media (hover: none) and (pointer: coarse) {\n  .admin-card-item,\n  .admin-action-btn,\n  .admin-filter-toggle {\n    -webkit-tap-highlight-color: rgba(var(--vz-primary-rgb), 0.1);\n    user-select: none;\n  }\n}\n\n// Safe area support\n@supports (padding: env(safe-area-inset-bottom)) {\n  .admin-sticky-action-bar {\n    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom));\n  }\n}\n\n// =============================================\n// DESKTOP ENHANCEMENTS\n// Desktop-specific improvements for larger screens\n// =============================================\n\n// =============================================\n// 1. STICKY TABLE HEADERS\n// =============================================\n\n@media (min-width: 992px) {\n  .admin-table-container {\n    max-height: calc(100vh - 280px);\n    overflow-y: auto;\n    position: relative;\n\n    .table {\n      thead {\n        th {\n          position: sticky;\n          top: 0;\n          background: #fff;\n          z-index: 10;\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n          // Dark mode support\n          @media (prefers-color-scheme: dark) {\n            background: var(--vz-card-bg);\n          }\n        }\n      }\n    }\n  }\n}\n\n// =============================================\n// 2. ENHANCED TABLE STYLES FOR DESKTOP\n// =============================================\n\n@media (min-width: 768px) {\n  .admin-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n\n    thead {\n      th {\n        font-weight: 600;\n        text-transform: uppercase;\n        font-size: 0.75rem;\n        letter-spacing: 0.05em;\n        color: #6c757d;\n        padding: 0.875rem 1rem;\n        border-bottom: 2px solid var(--vz-border-color);\n\n        &.sortable {\n          cursor: pointer;\n          user-select: none;\n          transition: all 0.2s ease;\n\n          &:hover {\n            background: rgba(var(--vz-primary-rgb), 0.04);\n            color: var(--vz-primary);\n          }\n\n          &::after {\n            content: '\\f0dc';\n            font-family: 'remixicon';\n            margin-left: 0.5rem;\n            opacity: 0.3;\n            transition: opacity 0.2s ease;\n          }\n\n          &.sort-asc::after {\n            content: '\\f0de';\n            opacity: 1;\n            color: var(--vz-primary);\n          }\n\n          &.sort-desc::after {\n            content: '\\f0dd';\n            opacity: 1;\n            color: var(--vz-primary);\n          }\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        border-bottom: 1px solid rgba(var(--vz-border-color), 0.5);\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: rgba(var(--vz-primary-rgb), 0.03);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n          transform: translateY(-1px);\n        }\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        td {\n          padding: 1rem;\n          color: #212529;\n          font-size: 0.875rem;\n          vertical-align: middle;\n        }\n      }\n\n      // Zebra striping option\n      &.table-striped {\n        tr:nth-child(even) {\n          background: rgba(var(--vz-primary-rgb), 0.02);\n\n          &:hover {\n            background: rgba(var(--vz-primary-rgb), 0.05);\n          }\n        }\n      }\n    }\n\n    // Row selection state\n    tbody tr.selected {\n      background: rgba(var(--vz-primary-rgb), 0.08);\n\n      &:hover {\n        background: rgba(var(--vz-primary-rgb), 0.12);\n      }\n    }\n  }\n}\n\n// =============================================\n// 3. DESKTOP CARD GRID\n// =============================================\n\n.admin-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n\n  @media (min-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  @media (min-width: 992px) and (max-width: 1199.98px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  @media (min-width: 768px) and (max-width: 991.98px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.admin-stats-card {\n  background: var(--vz-card-bg);\n  border: 1px solid var(--vz-card-border-color);\n  border-radius: 0.75rem;\n  padding: 1.25rem;\n  transition: all 0.25s ease;\n  position: relative;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background: linear-gradient(90deg, var(--vz-primary), rgba(var(--vz-primary-rgb), 0.6));\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.3s ease;\n  }\n\n  @media (min-width: 768px) {\n    &:hover {\n      transform: translateY(-4px);\n      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n\n      &::before {\n        transform: scaleX(1);\n      }\n    }\n  }\n\n  .stats-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1rem;\n    font-size: 1.5rem;\n    background: rgba(var(--vz-primary-rgb), 0.1);\n    color: var(--vz-primary);\n  }\n\n  .stats-value {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #212529;\n    margin-bottom: 0.25rem;\n  }\n\n  .stats-label {\n    font-size: 0.8125rem;\n    color: #6c757d;\n    font-weight: 500;\n  }\n\n  .stats-change {\n    font-size: 0.75rem;\n    font-weight: 600;\n    margin-top: 0.5rem;\n\n    &.positive {\n      color: var(--vz-success);\n    }\n\n    &.negative {\n      color: var(--vz-danger);\n    }\n  }\n}\n\n// =============================================\n// 4. FORM GRID LAYOUT FOR DESKTOP\n// =============================================\n\n.admin-form-grid {\n  display: grid;\n  gap: 1rem;\n\n  @media (min-width: 768px) {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.25rem;\n  }\n\n  .admin-form-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.375rem;\n\n    label {\n      font-size: 0.875rem;\n      font-weight: 600;\n      color: #495057;\n      margin-bottom: 0;\n\n      .required {\n        color: var(--vz-danger);\n        margin-left: 0.25rem;\n      }\n    }\n\n    input,\n    select,\n    textarea {\n      padding: 0.625rem 0.875rem;\n      font-size: 0.875rem;\n      border: 1px solid #dee2e6;\n      border-radius: 0.5rem;\n      transition: all 0.2s ease;\n      background: white;\n\n      &:focus {\n        outline: none;\n        border-color: var(--vz-primary);\n        box-shadow: 0 0 0 3px rgba(var(--vz-primary-rgb), 0.1);\n      }\n\n      &:disabled {\n        background: #f8f9fa;\n        cursor: not-allowed;\n        opacity: 0.7;\n      }\n\n      &.is-invalid {\n        border-color: var(--vz-danger);\n\n        &:focus {\n          box-shadow: 0 0 0 3px rgba(var(--vz-danger-rgb), 0.1);\n        }\n      }\n\n      &.is-valid {\n        border-color: var(--vz-success);\n\n        &:focus {\n          box-shadow: 0 0 0 3px rgba(var(--vz-success-rgb), 0.1);\n        }\n      }\n    }\n\n    textarea {\n      min-height: 100px;\n      resize: vertical;\n    }\n\n    .field-hint {\n      font-size: 0.75rem;\n      color: #6c757d;\n      margin-top: 0.25rem;\n    }\n\n    .field-error {\n      font-size: 0.75rem;\n      color: var(--vz-danger);\n      margin-top: 0.25rem;\n      display: flex;\n      align-items: center;\n      gap: 0.25rem;\n\n      i {\n        font-size: 0.875rem;\n      }\n    }\n  }\n\n  .admin-form-field-full {\n    grid-column: 1 / -1;\n  }\n}\n\n// =============================================\n// 5. BETTER BUTTON GROUP STYLES\n// =============================================\n\n.admin-btn-group {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  align-items: center;\n\n  @media (min-width: 768px) {\n    gap: 0.75rem;\n  }\n\n  &.btn-group-end {\n    justify-content: flex-end;\n  }\n\n  &.btn-group-center {\n    justify-content: center;\n  }\n\n  &.btn-group-between {\n    justify-content: space-between;\n  }\n\n  // Connected button group (no gaps)\n  &.btn-group-connected {\n    gap: 0;\n\n    .admin-action-btn {\n      border-radius: 0;\n      margin-left: -1px;\n\n      &:first-child {\n        border-top-left-radius: 0.5rem;\n        border-bottom-left-radius: 0.5rem;\n        margin-left: 0;\n      }\n\n      &:last-child {\n        border-top-right-radius: 0.5rem;\n        border-bottom-right-radius: 0.5rem;\n      }\n\n      &:hover,\n      &:focus {\n        z-index: 1;\n      }\n    }\n  }\n}\n\n// =============================================\n// 6. PAGE HEADER ENHANCEMENT\n// =============================================\n\n.admin-page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid var(--vz-border-color);\n\n  @media (min-width: 992px) {\n    margin-bottom: 2rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .header-left {\n    flex: 1;\n    min-width: 0;\n\n    .page-breadcrumb {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      margin-bottom: 0.5rem;\n      font-size: 0.8125rem;\n      color: #6c757d;\n\n      a {\n        color: var(--vz-primary);\n        text-decoration: none;\n        transition: color 0.2s ease;\n\n        &:hover {\n          color: rgba(var(--vz-primary-rgb), 0.8);\n          text-decoration: underline;\n        }\n      }\n\n      .breadcrumb-separator {\n        color: #adb5bd;\n      }\n    }\n  }\n\n  .header-right {\n    display: flex;\n    gap: 0.75rem;\n    align-items: center;\n\n    @media (max-width: 767.98px) {\n      width: 100%;\n    }\n  }\n}\n\n// =============================================\n// 7. IMPROVED BADGE STYLES\n// =============================================\n\n.admin-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n\n  i {\n    font-size: 0.875rem;\n  }\n\n  // Badge variants with improved styling\n  &.badge-primary {\n    background: linear-gradient(135deg, rgba(var(--vz-primary-rgb), 0.15), rgba(var(--vz-primary-rgb), 0.1));\n    color: var(--vz-primary);\n    border: 1px solid rgba(var(--vz-primary-rgb), 0.2);\n  }\n\n  &.badge-success {\n    background: linear-gradient(135deg, rgba(var(--vz-success-rgb), 0.15), rgba(var(--vz-success-rgb), 0.1));\n    color: var(--vz-success);\n    border: 1px solid rgba(var(--vz-success-rgb), 0.2);\n  }\n\n  &.badge-danger {\n    background: linear-gradient(135deg, rgba(var(--vz-danger-rgb), 0.15), rgba(var(--vz-danger-rgb), 0.1));\n    color: var(--vz-danger);\n    border: 1px solid rgba(var(--vz-danger-rgb), 0.2);\n  }\n\n  &.badge-warning {\n    background: linear-gradient(135deg, rgba(var(--vz-warning-rgb), 0.15), rgba(var(--vz-warning-rgb), 0.1));\n    color: #856404;\n    border: 1px solid rgba(var(--vz-warning-rgb), 0.2);\n  }\n\n  &.badge-info {\n    background: linear-gradient(135deg, rgba(var(--vz-info-rgb), 0.15), rgba(var(--vz-info-rgb), 0.1));\n    color: var(--vz-info);\n    border: 1px solid rgba(var(--vz-info-rgb), 0.2);\n  }\n\n  &.badge-dark {\n    background: linear-gradient(135deg, rgba(33, 37, 41, 0.15), rgba(33, 37, 41, 0.1));\n    color: #212529;\n    border: 1px solid rgba(33, 37, 41, 0.2);\n  }\n\n  &.badge-light {\n    background: #f8f9fa;\n    color: #495057;\n    border: 1px solid #dee2e6;\n  }\n\n  // Solid badge variant\n  &.badge-solid {\n    border: none;\n\n    &.badge-primary {\n      background: var(--vz-primary);\n      color: white;\n    }\n\n    &.badge-success {\n      background: var(--vz-success);\n      color: white;\n    }\n\n    &.badge-danger {\n      background: var(--vz-danger);\n      color: white;\n    }\n\n    &.badge-warning {\n      background: var(--vz-warning);\n      color: #212529;\n    }\n\n    &.badge-info {\n      background: var(--vz-info);\n      color: white;\n    }\n  }\n\n  // Pill badge\n  &.badge-pill {\n    border-radius: 50rem;\n  }\n\n  // Badge with dot indicator\n  &.badge-dot {\n    &::before {\n      content: '';\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      background: currentColor;\n      display: inline-block;\n    }\n  }\n}\n\n// =============================================\n// 8. TRANSITION/ANIMATION IMPROVEMENTS\n// =============================================\n\n// Smooth transitions for interactive elements\n@media (min-width: 768px) {\n  .admin-card-item,\n  .admin-action-btn,\n  .admin-table tbody tr,\n  .admin-stats-card,\n  .admin-badge {\n    will-change: transform;\n  }\n\n  // Fade in animation for content\n  .admin-fade-in {\n    animation: fadeIn 0.4s ease-out;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  // Slide in from right\n  .admin-slide-in-right {\n    animation: slideInRight 0.3s ease-out;\n  }\n\n  @keyframes slideInRight {\n    from {\n      opacity: 0;\n      transform: translateX(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  // Scale in animation\n  .admin-scale-in {\n    animation: scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  }\n\n  @keyframes scaleIn {\n    from {\n      opacity: 0;\n      transform: scale(0.9);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n}\n\n// Stagger animation for lists\n.admin-stagger-list {\n  > * {\n    opacity: 0;\n    animation: fadeIn 0.4s ease-out forwards;\n\n    @for $i from 1 through 20 {\n      &:nth-child(#{$i}) {\n        animation-delay: #{$i * 0.05}s;\n      }\n    }\n  }\n}\n\n// Loading spinner improvement\n.admin-spinner {\n  display: inline-block;\n  width: 1.5rem;\n  height: 1.5rem;\n  border: 2px solid rgba(var(--vz-primary-rgb), 0.2);\n  border-top-color: var(--vz-primary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n\n  &.spinner-sm {\n    width: 1rem;\n    height: 1rem;\n    border-width: 1.5px;\n  }\n\n  &.spinner-lg {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-width: 3px;\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n// Smooth scrolling for containers\n.admin-smooth-scroll {\n  scroll-behavior: smooth;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n\n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n// Focus visible for accessibility\n.admin-action-btn,\n.admin-filter-toggle,\n.admin-table thead th.sortable {\n  &:focus-visible {\n    outline: 2px solid var(--vz-primary);\n    outline-offset: 2px;\n  }\n}\n\n// Print styles\n@media print {\n  .admin-action-btn,\n  .admin-filter-section,\n  .admin-page-actions,\n  .admin-sticky-action-bar {\n    display: none !important;\n  }\n\n  .admin-table-container {\n    max-height: none !important;\n    overflow: visible !important;\n  }\n\n  .admin-card-item {\n    page-break-inside: avoid;\n  }\n}\n","// ALKAYOL - Custom Theme\n// Bootstrap is loaded from CDN\n\n// Import admin mobile styles\n@import 'admin-mobile';\n\n// CSS Variables\n:root {\n  // Primary Color (Blue)\n  --vz-primary: #405189;\n  --vz-primary-rgb: 64, 81, 137;\n\n  // Secondary Color\n  --vz-secondary: #3577f1;\n  --vz-secondary-rgb: 53, 119, 241;\n\n  // Success (Green)\n  --vz-success: #0ab39c;\n  --vz-success-rgb: 10, 179, 156;\n\n  // Info (Cyan)\n  --vz-info: #299cdb;\n  --vz-info-rgb: 41, 156, 219;\n\n  // Warning (Orange)\n  --vz-warning: #f7b84b;\n  --vz-warning-rgb: 247, 184, 75;\n\n  // Danger (Red)\n  --vz-danger: #f06548;\n  --vz-danger-rgb: 240, 101, 72;\n\n  // Light/Dark\n  --vz-light: #f3f6f9;\n  --vz-dark: #212529;\n\n  // Body\n  --vz-body-bg: #f3f3f9;\n  --vz-body-color: #495057;\n\n  // Card\n  --vz-card-bg: #ffffff;\n  --vz-card-border-color: #e9ebec;\n\n  // Sidebar - Velzon Style\n  --vz-vertical-menu-width: 250px;\n  --vz-vertical-menu-width-md: 180px;\n  --vz-vertical-menu-width-sm: 70px;\n  --vz-vertical-menu-bg: #405189;\n  --vz-vertical-menu-border: #405189;\n  --vz-vertical-menu-item-color: rgba(255, 255, 255, 0.5);\n  --vz-vertical-menu-item-hover-color: #ffffff;\n  --vz-vertical-menu-item-active-color: #ffffff;\n  --vz-vertical-menu-item-active-bg: rgba(255, 255, 255, 0.15);\n  --vz-vertical-menu-sub-item-color: rgba(255, 255, 255, 0.5);\n  --vz-vertical-menu-sub-item-hover-color: #ffffff;\n  --vz-vertical-menu-title-color: rgba(255, 255, 255, 0.5);\n  --vz-vertical-menu-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n\n  // Legacy aliases\n  --vz-sidebar-bg: var(--vz-vertical-menu-bg);\n  --vz-sidebar-width: var(--vz-vertical-menu-width);\n  --vz-sidebar-width-sm: var(--vz-vertical-menu-width-sm);\n  --vz-sidebar-menu-item-color: var(--vz-vertical-menu-item-color);\n  --vz-sidebar-menu-item-active-color: var(--vz-vertical-menu-item-active-color);\n\n  // Header\n  --vz-header-height: 70px;\n  --vz-header-bg: #ffffff;\n  --vz-header-item-color: #495057;\n\n  // Footer\n  --vz-footer-height: 50px;\n\n  // Border\n  --vz-border-color: #e9ebec;\n\n  // Font\n  --vz-font-sans-serif: \"Manrope\", sans-serif;\n}\n\n// iOS PWA: viewport dışında kalan ve safe area bölgelerinin arka planını beyaz yap\nhtml {\n  background: white;\n  height: 100%;\n}\n\n// Body\nbody {\n  font-family: var(--vz-font-sans-serif);\n  background-color: var(--vz-body-bg);\n  // iOS PWA standalone: body background fills the home-indicator safe zone.\n  // Must be white so the bottom bar area doesn't show a dark/gray strip.\n  background: white;\n  color: var(--vz-body-color);\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden; // Prevent horizontal scroll\n}\n\n// Wrapper\n.wrapper {\n  display: flex;\n  min-height: 100vh;\n}\n\n// Header\n.app-header {\n  position: fixed;\n  top: 0;\n  left: var(--vz-vertical-menu-width);\n  right: 0;\n  height: var(--vz-header-height);\n  background-color: var(--vz-header-bg);\n  border-bottom: 1px solid var(--vz-border-color);\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1.5rem;\n  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);\n  transition: all 0.1s ease-out;\n\n  @media (max-width: 991.98px) {\n    left: 0;\n  }\n}\n\n// Sidebar - Velzon Style\n.app-menu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: var(--vz-vertical-menu-width);\n  background: var(--vz-vertical-menu-bg);\n  border-right: 1px solid var(--vz-vertical-menu-border);\n  z-index: 1002;\n  box-shadow: var(--vz-vertical-menu-box-shadow);\n  transition: all 0.1s ease-out;\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 calc(var(--vz-header-height) + 25px) 0;\n  overflow: hidden; // Prevent sidebar from scrolling with page\n\n  @media (max-width: 767.98px) {\n    margin-left: -100%;\n\n    .vertical-sidebar-enable & {\n      margin-left: 0;\n    }\n  }\n\n  .navbar-brand-box {\n    height: var(--vz-header-height);\n    min-height: var(--vz-header-height); // Prevent shrinking\n    display: flex;\n    align-items: center;\n    justify-content: flex-start; // Left aligned when expanded\n    padding: 0 1.3rem;\n    transition: all 0.1s ease-out;\n\n    .logo {\n      text-decoration: none;\n      line-height: var(--vz-header-height);\n      display: flex;\n      align-items: center;\n\n      .logo-lg {\n        display: inline-block;\n        color: #fff;\n        font-size: 1.1rem;\n        font-weight: 600;\n      }\n\n      .logo-sm {\n        display: none;\n        color: #fff;\n        font-size: 1.5rem;\n        font-weight: 700;\n      }\n    }\n  }\n\n  .navbar-nav {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    flex: 1;\n    overflow-y: auto;\n\n    .menu-title {\n      padding: 12px 20px;\n      font-size: 11px;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      color: var(--vz-vertical-menu-title-color);\n      cursor: default;\n\n      span {\n        display: inline-block;\n      }\n\n      i {\n        display: none;\n      }\n    }\n\n    .nav-item .nav-link {\n      display: flex;\n      align-items: center;\n      padding: 0.625rem 1.5rem;\n      color: var(--vz-vertical-menu-item-color);\n      font-size: 0.925rem;\n      text-decoration: none;\n      transition: all 0.15s ease;\n      position: relative;\n\n      i {\n        display: inline-block;\n        min-width: 1.75rem;\n        font-size: 18px;\n        line-height: inherit;\n      }\n\n      svg {\n        width: 18px;\n        margin-right: 0.665rem;\n        color: var(--vz-vertical-menu-item-color);\n      }\n\n      &:hover {\n        color: var(--vz-vertical-menu-item-hover-color);\n      }\n\n      &.active {\n        color: var(--vz-vertical-menu-item-active-color);\n      }\n    }\n  }\n\n  .sidebar-background {\n    position: absolute;\n    z-index: -1;\n    height: 100%;\n    width: 100%;\n    display: block;\n    top: 0;\n    left: 0;\n    background-size: cover;\n    background-position: 50%;\n    opacity: 0.07;\n  }\n}\n\n// Navbar Menu - Container Fluid Reset\n.navbar-menu {\n  .container-fluid {\n    padding: 0;\n  }\n}\n\n// Main Content\n.main-content {\n  flex: 1;\n  margin-left: var(--vz-vertical-menu-width);\n  min-height: 100vh;\n  transition: all 0.1s ease-out;\n\n  @media (max-width: 767.98px) {\n    margin-left: 0;\n  }\n}\n\n// Page Content\n.page-content {\n  padding: calc(var(--vz-header-height) + 1.5rem) 1.5rem 1.5rem;\n  min-height: 100vh;\n}\n\n// Page Title\n.page-title-box {\n  padding-bottom: 1rem;\n  margin-bottom: 1.5rem;\n\n  h4 {\n    font-size: 1.1rem;\n    font-weight: 600;\n    margin-bottom: 0;\n  }\n}\n\n// Footer\n.footer {\n  position: fixed;\n  bottom: 0;\n  left: var(--vz-vertical-menu-width);\n  right: 0;\n  height: var(--vz-footer-height);\n  background-color: var(--vz-card-bg);\n  border-top: 1px solid var(--vz-border-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  color: var(--vz-body-color);\n  transition: all 0.1s ease-out;\n\n  @media (max-width: 767.98px) {\n    left: 0;\n  }\n}\n\n// =============================================\n// SIDEBAR SIZE VARIATIONS - Velzon Style\n// =============================================\n\n// Small Sidebar with Hover (sm-hover) - Desktop only\n[data-sidebar-size=\"sm-hover\"] {\n  @media (min-width: 768px) {\n    .main-content {\n      margin-left: var(--vz-vertical-menu-width-sm);\n    }\n\n    .app-header {\n      left: var(--vz-vertical-menu-width-sm);\n    }\n\n    .footer {\n      left: var(--vz-vertical-menu-width-sm);\n    }\n\n    .topnav-hamburger {\n      display: none;\n    }\n\n    .app-menu {\n      position: fixed !important; // Ensure sidebar stays fixed when page scrolls\n      width: var(--vz-vertical-menu-width-sm);\n      overflow: hidden !important;\n\n      .navbar-brand-box {\n        padding: 0;\n        justify-content: center;\n\n        .logo {\n          justify-content: center;\n          width: 100%;\n\n          .logo-lg {\n            display: none !important;\n          }\n\n          .logo-sm {\n            display: block !important;\n          }\n        }\n      }\n\n      // Hide scrollbar but allow scrolling when collapsed\n      .simplebar-scrollbar,\n      .simplebar-track {\n        display: none !important;\n      }\n\n      #scrollbar {\n        .simplebar-content-wrapper {\n          overflow-y: auto !important;\n          overflow-x: hidden !important;\n\n          // Hide webkit scrollbar\n          &::-webkit-scrollbar {\n            display: none;\n            width: 0;\n          }\n\n          // Firefox\n          scrollbar-width: none;\n        }\n      }\n\n      .navbar-nav {\n\n        .badge {\n          display: none;\n        }\n\n        .menu-title {\n          text-align: center;\n\n          span {\n            display: none;\n          }\n\n          i {\n            display: block;\n            color: var(--vz-vertical-menu-item-color);\n            line-height: 36px;\n            font-size: 1rem;\n          }\n        }\n\n        .nav-link {\n          justify-content: center;\n          padding: 0.625rem 0;\n\n          span {\n            display: none;\n          }\n\n          i {\n            font-size: 22px;\n            min-width: auto;\n          }\n\n          svg {\n            margin-right: 0;\n          }\n\n          &:after,\n          &:before {\n            display: none;\n          }\n        }\n\n        .menu-dropdown {\n          display: none;\n        }\n      }\n\n      // Hover expand\n      &:hover {\n        width: var(--vz-vertical-menu-width) !important;\n\n        // Show scrollbar on hover (same as expanded state)\n        .simplebar-scrollbar,\n        .simplebar-track {\n          display: block !important;\n        }\n\n        #scrollbar {\n          .simplebar-content-wrapper {\n            overflow-y: auto !important;\n            overflow-x: hidden !important;\n\n            // Show webkit scrollbar\n            &::-webkit-scrollbar {\n              display: block;\n              width: auto;\n            }\n\n            scrollbar-width: auto;\n          }\n        }\n\n        .navbar-brand-box {\n          justify-content: flex-start;\n          padding: 0 1.3rem;\n\n          .logo {\n            justify-content: flex-start;\n\n            .logo-lg {\n              display: inline-block !important;\n            }\n\n            .logo-sm {\n              display: none !important;\n            }\n          }\n        }\n\n        .navbar-nav {\n          .menu-dropdown.show {\n            display: block;\n          }\n\n          .nav-link {\n            justify-content: flex-start;\n            padding: 0.625rem 1.5rem;\n\n            i {\n              font-size: 18px;\n              min-width: 1.75rem;\n            }\n\n            svg {\n              margin-right: 0.665rem;\n            }\n\n            span,\n            &:after,\n            &:before {\n              display: inline-block;\n            }\n          }\n        }\n\n        .menu-title {\n          text-align: left;\n\n          span {\n            display: inline-block;\n          }\n\n          i {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Small Sidebar (Collapsed) - Desktop only\n[data-sidebar-size=\"sm\"] {\n  @media (min-width: 768px) {\n    .main-content {\n      margin-left: var(--vz-vertical-menu-width-sm);\n    }\n\n    .app-header {\n      left: var(--vz-vertical-menu-width-sm);\n      z-index: 1003;\n    }\n\n    .footer {\n      left: var(--vz-vertical-menu-width-sm);\n    }\n\n    .navbar-brand-box {\n      position: fixed;\n      padding: 0;\n      width: var(--vz-vertical-menu-width-sm);\n      z-index: 1;\n      top: 0;\n      background-color: var(--vz-vertical-menu-bg);\n      text-align: center;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: var(--vz-header-height);\n\n      .logo {\n        .logo-lg {\n          display: none !important;\n        }\n        .logo-sm {\n          display: block !important;\n        }\n      }\n    }\n\n    .app-menu {\n      position: fixed !important; // Keep sidebar fixed when page scrolls\n      width: var(--vz-vertical-menu-width-sm) !important;\n      padding-top: var(--vz-header-height);\n\n      .simplebar-mask,\n      .simplebar-content-wrapper {\n        overflow: visible !important;\n      }\n\n      .simplebar-scrollbar,\n      .vertical-menu-btn {\n        display: none !important;\n      }\n\n      .simplebar-offset {\n        bottom: 0 !important;\n      }\n\n      .navbar-nav {\n        .badge {\n          display: none !important;\n        }\n\n        .menu-title {\n          text-align: center;\n          font-size: 1rem;\n\n          span {\n            display: none;\n          }\n\n          i {\n            display: block;\n            line-height: 36px;\n          }\n        }\n\n        .nav-link {\n          span {\n            display: none;\n          }\n\n          i {\n            font-size: 22px;\n          }\n\n          svg {\n            margin-right: 0;\n          }\n\n          &:after,\n          &:before {\n            display: none;\n          }\n        }\n\n        .menu-dropdown {\n          display: none;\n          height: auto !important;\n        }\n\n        .nav-item {\n          position: relative;\n\n          &:hover {\n            > a.menu-link {\n              position: relative;\n              width: calc(200px + var(--vz-vertical-menu-width-sm));\n              transition: none;\n              background-color: var(--vz-vertical-menu-bg);\n\n              span {\n                display: inline-block;\n                padding-left: 25px;\n              }\n\n              &:after {\n                display: block;\n                transform: rotate(90deg);\n                color: #fff;\n              }\n            }\n\n            .nav-link {\n              span {\n                display: inline-block;\n              }\n            }\n\n            > .menu-dropdown {\n              display: block;\n              left: var(--vz-vertical-menu-width-sm);\n              position: absolute;\n              width: 200px;\n              background: var(--vz-vertical-menu-bg);\n              height: auto !important;\n              padding: 0.5rem 0;\n              border-radius: 0 0 3px 3px;\n              box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n            }\n          }\n        }\n\n        .nav-sm {\n          padding: 0;\n\n          .nav-item {\n            &:hover {\n              > .nav-link {\n                color: var(--vz-vertical-menu-item-hover-color);\n\n                &:after {\n                  color: inherit;\n                }\n              }\n            }\n          }\n\n          .nav-link {\n            &:after {\n              display: block !important;\n              transform: rotate(0deg) !important;\n            }\n          }\n\n          .menu-dropdown {\n            left: 100% !important;\n            top: 0;\n            border-radius: 3px !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n// =============================================\n// HAMBURGER ICON\n// =============================================\n\n.hamburger-icon {\n  width: 20px;\n  height: 14px;\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n\n  span {\n    background-color: var(--vz-header-item-color);\n    position: absolute;\n    border-radius: 2px;\n    transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n    width: 100%;\n    height: 2px;\n    display: block;\n    left: 0;\n\n    &:nth-child(1) {\n      top: 0;\n      width: 100%;\n    }\n\n    &:nth-child(2) {\n      top: 6px;\n    }\n\n    &:nth-child(3) {\n      bottom: 0;\n      width: 100%;\n    }\n  }\n\n  &.open {\n    transform: rotate(-90deg);\n\n    span {\n      &:nth-child(1) {\n        left: 1px;\n        top: 5px;\n        width: 20px;\n        transform: rotate(90deg);\n        transition-delay: 150ms;\n      }\n\n      &:nth-child(2) {\n        left: 3px;\n        top: 13px;\n        width: 10px;\n        transform: rotate(45deg);\n        transition-delay: 50ms;\n      }\n\n      &:nth-child(3) {\n        left: 9px;\n        top: 13px;\n        width: 10px;\n        transform: rotate(-45deg);\n        transition-delay: 100ms;\n      }\n    }\n  }\n}\n\n.vertical-menu-btn {\n  &:hover .hamburger-icon:not(.open) span {\n    &:nth-child(1) {\n      top: -1px;\n    }\n    &:nth-child(3) {\n      bottom: -1px;\n    }\n  }\n}\n\n// =============================================\n// VERTICAL OVERLAY (Mobile)\n// =============================================\n\n.vertical-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(33, 37, 41, 0.35);\n  z-index: 1003;\n  display: none;\n}\n\n.vertical-sidebar-enable {\n  .vertical-overlay {\n    display: block;\n  }\n\n  .app-menu {\n    margin-left: 0 !important;\n    z-index: 1004;\n  }\n}\n\n// =============================================\n// CARD STYLES\n// =============================================\n\n.card {\n  border: 1px solid var(--vz-card-border-color);\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);\n  margin-bottom: 1.5rem;\n  background-color: var(--vz-card-bg);\n\n  .card-header {\n    background-color: transparent;\n    border-bottom: 1px solid var(--vz-border-color);\n    padding: 1rem 1.25rem;\n\n    .card-title {\n      font-size: 1rem;\n      font-weight: 600;\n      margin-bottom: 0;\n    }\n  }\n\n  .card-body {\n    padding: 1.25rem;\n  }\n}\n\n// Card Animate\n.card-animate {\n  transition: all 0.3s ease;\n\n  &:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 5px 15px rgba(56, 65, 74, 0.15);\n  }\n}\n\n// =============================================\n// COLOR UTILITIES\n// =============================================\n\n// Subtle backgrounds\n.bg-primary-subtle { background-color: rgba(var(--vz-primary-rgb), 0.1) !important; }\n.bg-success-subtle { background-color: rgba(var(--vz-success-rgb), 0.1) !important; }\n.bg-warning-subtle { background-color: rgba(var(--vz-warning-rgb), 0.1) !important; }\n.bg-danger-subtle { background-color: rgba(var(--vz-danger-rgb), 0.1) !important; }\n.bg-info-subtle { background-color: rgba(var(--vz-info-rgb), 0.1) !important; }\n\n// Text colors for subtle backgrounds\n.text-primary { color: var(--vz-primary) !important; }\n.text-success { color: var(--vz-success) !important; }\n.text-warning { color: var(--vz-warning) !important; }\n.text-danger { color: var(--vz-danger) !important; }\n.text-info { color: var(--vz-info) !important; }\n\n// =============================================\n// AVATAR STYLES\n// =============================================\n\n.avatar-sm {\n  width: 2rem;\n  height: 2rem;\n}\n\n.avatar-lg {\n  width: 4rem;\n  height: 4rem;\n}\n\n.avatar-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  font-weight: 500;\n  border-radius: 0.25rem;\n}\n\n// =============================================\n// TABLE STYLES\n// =============================================\n\n.table {\n  th {\n    font-weight: 600;\n    font-size: 0.8rem;\n    text-transform: uppercase;\n    letter-spacing: 0.03rem;\n    color: #878a99;\n    border-bottom-width: 1px;\n  }\n\n  td {\n    vertical-align: middle;\n    padding: 0.75rem;\n  }\n}\n\n.table-hover tbody tr:hover {\n  background-color: rgba(var(--vz-primary-rgb), 0.04);\n}\n\n// =============================================\n// BADGES\n// =============================================\n\n.badge {\n  font-weight: 500;\n  font-size: 0.75rem;\n  padding: 0.35em 0.65em;\n}\n\n// =============================================\n// TABS\n// =============================================\n\n.nav-tabs-custom {\n  border-bottom: 1px solid var(--vz-border-color);\n\n  .nav-link {\n    border: none;\n    border-bottom: 2px solid transparent;\n    color: var(--vz-body-color);\n    padding: 0.75rem 1rem;\n    font-weight: 500;\n    background: none;\n\n    &:hover {\n      border-color: transparent;\n      color: var(--vz-primary);\n    }\n\n    &.active {\n      color: var(--vz-primary);\n      border-bottom-color: var(--vz-primary);\n      background-color: transparent;\n    }\n  }\n}\n\n// =============================================\n// AUTH PAGES\n// =============================================\n\n.auth-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--vz-primary) 0%, #364574 100%);\n  padding: 2rem;\n\n  .auth-card {\n    width: 100%;\n    max-width: 420px;\n\n    .card {\n      border: none;\n      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n      border-radius: 0.75rem;\n    }\n\n    .auth-logo {\n      text-align: center;\n      margin-bottom: 1.5rem;\n\n      h4 {\n        color: var(--vz-primary);\n        font-weight: 700;\n        font-size: 1.5rem;\n      }\n\n      p {\n        color: #878a99;\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n// =============================================\n// DROPDOWN STYLES\n// =============================================\n\n.dropdown-menu {\n  font-size: 0.875rem;\n  border: 1px solid var(--vz-border-color);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  border-radius: 0.375rem;\n\n  .dropdown-item {\n    padding: 0.5rem 1rem;\n\n    &:hover,\n    &:focus {\n      background-color: rgba(var(--vz-primary-rgb), 0.1);\n    }\n  }\n\n  .dropdown-divider {\n    border-color: var(--vz-border-color);\n  }\n}\n\n// User Dropdown\n.user-dropdown {\n  .dropdown-toggle {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem;\n    border-radius: 0.375rem;\n    background: none;\n    border: none;\n    cursor: pointer;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    &::after {\n      display: none;\n    }\n\n    .user-avatar {\n      width: 36px;\n      height: 36px;\n      background-color: var(--vz-primary);\n      color: white;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 600;\n      font-size: 0.875rem;\n    }\n\n    .user-info {\n      text-align: left;\n\n      .user-name {\n        display: block;\n        font-weight: 600;\n        font-size: 0.875rem;\n        color: #212529;\n        margin: 0;\n        line-height: 1.3;\n      }\n\n      .user-role {\n        display: block;\n        font-size: 0.75rem;\n        color: #878a99;\n        margin: 0;\n        line-height: 1.3;\n      }\n    }\n  }\n}\n\n// =============================================\n// UTILITIES\n// =============================================\n\n.fs-22 { font-size: 22px !important; }\n.fs-24 { font-size: 24px !important; }\n\n// Spinner\n.spinner-border {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n// SimpleBar\n.simplebar-scrollbar::before {\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n// Form controls custom\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--vz-primary);\n  box-shadow: 0 0 0 0.15rem rgba(var(--vz-primary-rgb), 0.15);\n}\n\n// Menu Link helper\n.menu-link {\n  text-decoration: none;\n}\n\n// =============================================\n// FORMEN LAYOUT - SIMPLIFIED INTERFACE\n// =============================================\n\n.forman-layout {\n  height: var(--app-height, 100vh);\n  background: linear-gradient(180deg, #f8f9fa 0%, #f0f2f5 100%);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  overscroll-behavior: none;\n}\n\n.forman-header {\n  background: var(--vz-primary);\n  padding: 1rem 1.5rem;\n  padding-top: calc(1rem + env(safe-area-inset-top, 0px));\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n\n  .forman-header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    max-width: 600px;\n    margin: 0 auto;\n  }\n\n  .forman-logo {\n    .logo-text {\n      color: white;\n      font-size: 1.5rem;\n      font-weight: 800;\n      letter-spacing: 0.05rem;\n    }\n  }\n\n  .user-dropdown .dropdown-toggle {\n    padding: 0;\n    background: none;\n    border: none;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.1);\n    }\n\n    .user-avatar {\n      width: 40px;\n      height: 40px;\n      background: rgba(255, 255, 255, 0.2);\n      color: white;\n      font-size: 1rem;\n    }\n  }\n}\n\n.forman-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0; // Important for flex children to shrink\n}\n\n.forman-dashboard {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 2rem 1.5rem;\n  max-width: 600px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.forman-welcome {\n  text-align: center;\n  margin-bottom: 2rem;\n\n  h1 {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #212529;\n    margin-bottom: 0.5rem;\n  }\n\n  p {\n    color: #6c757d;\n    font-size: 1rem;\n    margin: 0;\n  }\n}\n\n.forman-modules {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  flex: 1;\n}\n\n.forman-module-card {\n  display: flex;\n  align-items: center;\n  background: white;\n  border: none;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: left;\n  width: 100%;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n\n  .module-icon {\n    width: 64px;\n    height: 64px;\n    border-radius: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n\n    i {\n      font-size: 2rem;\n      color: white;\n    }\n  }\n\n  .module-content {\n    flex: 1;\n    margin-left: 1rem;\n\n    h2 {\n      font-size: 1.25rem;\n      font-weight: 700;\n      color: #212529;\n      margin: 0 0 0.25rem;\n    }\n\n    p {\n      font-size: 0.875rem;\n      color: #6c757d;\n      margin: 0;\n    }\n  }\n\n  .module-arrow {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #f8f9fa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n\n    i {\n      font-size: 1.25rem;\n      color: #6c757d;\n    }\n  }\n\n  // QR Module - Blue\n  &.forman-module-qr {\n    .module-icon {\n      background: linear-gradient(135deg, #3577f1 0%, #2962d9 100%);\n    }\n\n    &:hover .module-arrow {\n      background: rgba(53, 119, 241, 0.1);\n\n      i {\n        color: #3577f1;\n      }\n    }\n  }\n\n  // Daily Record Module - Green\n  &.forman-module-daily {\n    .module-icon {\n      background: linear-gradient(135deg, #0ab39c 0%, #099885 100%);\n    }\n\n    &:hover .module-arrow {\n      background: rgba(10, 179, 156, 0.1);\n\n      i {\n        color: #0ab39c;\n      }\n    }\n  }\n}\n\n.forman-date {\n  text-align: center;\n  margin-top: 2rem;\n  padding: 1rem;\n  color: #6c757d;\n  font-size: 0.875rem;\n\n  i {\n    font-size: 1rem;\n  }\n}\n\n// Forman pages - removed, merged into mobile native design below\n\n// Forman Mobile Optimizations\n@media (max-width: 575.98px) {\n  .forman-header {\n    padding: 0.875rem 1rem;\n    padding-top: calc(0.875rem + env(safe-area-inset-top, 0px));\n  }\n\n  .forman-dashboard {\n    padding: 1.5rem 1rem;\n  }\n\n  .forman-welcome {\n    margin-bottom: 1.5rem;\n\n    h1 {\n      font-size: 1.5rem;\n    }\n  }\n\n  .forman-module-card {\n    padding: 1.25rem;\n\n    .module-icon {\n      width: 56px;\n      height: 56px;\n\n      i {\n        font-size: 1.75rem;\n      }\n    }\n\n    .module-content {\n      h2 {\n        font-size: 1.1rem;\n      }\n\n      p {\n        font-size: 0.8rem;\n      }\n    }\n  }\n}\n\n// =============================================\n// FORMEN PAGES - MOBILE NATIVE DESIGN\n// =============================================\n\n.forman-page {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0; // Important for flex children to shrink\n  background: #f5f6f8;\n  overflow: hidden;\n}\n\n.forman-page-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.75rem 1rem;\n  background: white;\n  border-bottom: 1px solid #e9ecef;\n  flex-shrink: 0;\n  z-index: 10;\n\n  .back-btn {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    background: #f0f0f5;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n\n    &:active {\n      transform: scale(0.92);\n      background: #e4e4ea;\n    }\n\n    i {\n      font-size: 1.25rem;\n      color: #333;\n    }\n  }\n\n  h1 {\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: #212529;\n    margin: 0;\n    flex: 1;\n  }\n}\n\n.forman-page-content {\n  flex: 1;\n  min-height: 0;\n  padding: 1rem;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: none;\n}\n\n// Form Fields\n.forman-field {\n  margin-bottom: 0.75rem;\n\n  label {\n    display: block;\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: #868e96;\n    margin-bottom: 0.25rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n}\n\n.forman-field-row {\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n\n  .flex-1 {\n    flex: 1;\n  }\n}\n\n.forman-input,\n.forman-select,\n.forman-textarea {\n  width: 100%;\n  padding: 0.625rem 0.75rem;\n  font-size: 0.9375rem;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  background: white;\n  transition: border-color 0.15s ease;\n  -webkit-appearance: none;\n  color: #212529;\n\n  &:focus {\n    outline: none;\n    border-color: var(--vz-primary);\n  }\n\n  &::placeholder {\n    color: #adb5bd;\n  }\n}\n\n.forman-select {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%236c757d'%3e%3cpath d='M12 15l-5-5h10z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 1.25rem;\n  padding-right: 2.25rem;\n}\n\n.forman-textarea {\n  resize: none;\n  min-height: 70px;\n}\n\n// QR Scanner Area\n.forman-qr-area {\n  position: relative;\n  background: white;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  margin: 1rem 0;\n  text-align: center;\n}\n\n.forman-qr-reader {\n  display: none;\n  width: 100%;\n  max-width: 300px;\n  margin: 0 auto 1rem;\n  border-radius: 0.75rem;\n  overflow: hidden;\n\n  &.active {\n    display: block;\n  }\n}\n\n.forman-qr-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 2rem;\n  background: linear-gradient(135deg, #3577f1 0%, #2962d9 100%);\n  border: none;\n  border-radius: 1rem;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  &:hover:not(:disabled) {\n    transform: scale(1.02);\n    box-shadow: 0 8px 25px rgba(53, 119, 241, 0.3);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  i {\n    font-size: 3rem;\n    margin-bottom: 0.75rem;\n  }\n\n  span {\n    font-size: 1.1rem;\n    font-weight: 600;\n  }\n}\n\n.forman-qr-close {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  padding: 0.5rem 1rem;\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  border-radius: 2rem;\n  color: white;\n  font-weight: 500;\n  font-size: 0.875rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  z-index: 10;\n  backdrop-filter: blur(4px);\n\n  i {\n    font-size: 1.1rem;\n  }\n\n  &:active {\n    background: rgba(0, 0, 0, 0.8);\n  }\n}\n\n.forman-qr-result {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1.25rem;\n  gap: 0.75rem;\n}\n\n.forman-qr-result-icon {\n  width: 3.5rem;\n  height: 3.5rem;\n  background: linear-gradient(135deg, #0ab39c 0%, #099885 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(10, 179, 156, 0.3);\n\n  i {\n    font-size: 1.75rem;\n    color: white;\n  }\n}\n\n.forman-qr-result-text {\n  text-align: center;\n\n  strong {\n    display: block;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #0ab39c;\n    margin-bottom: 0.25rem;\n  }\n\n  span {\n    display: block;\n    font-size: 0.8rem;\n    color: #6c757d;\n    word-break: break-all;\n    max-width: 200px;\n  }\n}\n\n.forman-qr-retry {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background: linear-gradient(135deg, #405189 0%, #354370 100%);\n  border: none;\n  border-radius: 2rem;\n  color: white;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 0.5rem;\n  box-shadow: 0 2px 8px rgba(64, 81, 137, 0.25);\n  transition: transform 0.15s, box-shadow 0.15s;\n\n  i {\n    font-size: 1.1rem;\n  }\n\n  &:active {\n    transform: scale(0.97);\n    box-shadow: 0 1px 4px rgba(64, 81, 137, 0.2);\n  }\n}\n\n// Photos\n.forman-photos {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.forman-photo-item {\n  position: relative;\n  width: 72px;\n  height: 72px;\n  border-radius: 0.75rem;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.forman-photo-remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 22px;\n  height: 22px;\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n\n  i {\n    font-size: 0.875rem;\n  }\n\n  &:active {\n    background: rgba(0, 0, 0, 0.8);\n  }\n}\n\n.forman-photo-add {\n  width: 72px;\n  height: 72px;\n  border: 2px dashed #ced4da;\n  border-radius: 0.75rem;\n  background: #f8f9fa;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n\n  i {\n    font-size: 1.5rem;\n    color: #6c757d;\n  }\n\n  span {\n    font-size: 0.7rem;\n    color: #6c757d;\n    font-weight: 500;\n  }\n\n  &:active {\n    background: #e9ecef;\n    border-color: #adb5bd;\n  }\n}\n\n// Tabs\n.forman-tabs {\n  display: flex;\n  background: #e9ecef;\n  border-radius: 0.5rem;\n  padding: 3px;\n  margin-bottom: 0.75rem;\n}\n\n.forman-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  padding: 0.5rem 0.625rem;\n  background: transparent;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &.active {\n    background: white;\n    color: #212529;\n    font-weight: 600;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n\n  i {\n    font-size: 0.9375rem;\n  }\n}\n\n.forman-tab-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.125rem;\n  height: 1.125rem;\n  padding: 0 0.3rem;\n  background: var(--vz-primary);\n  color: white;\n  border-radius: 0.75rem;\n  font-size: 0.65rem;\n  font-weight: 700;\n\n  .forman-tab:not(.active) & {\n    background: #6c757d;\n  }\n}\n\n.forman-tab-dot {\n  width: 6px;\n  height: 6px;\n  background: var(--vz-success);\n  border-radius: 50%;\n  margin-left: 4px;\n}\n\n// Stepper (Wizard)\n.forman-stepper {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.75rem 0;\n  margin-bottom: 0.5rem;\n}\n\n.forman-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.375rem;\n  flex: 1;\n  position: relative;\n\n  // Connector line\n  &:not(:last-child)::after {\n    content: '';\n    position: absolute;\n    top: 14px;\n    left: calc(50% + 16px);\n    width: calc(100% - 32px);\n    height: 2px;\n    background: #dee2e6;\n  }\n\n  &.completed:not(:last-child)::after {\n    background: var(--vz-success);\n  }\n}\n\n.forman-step-dot {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  background: #e9ecef;\n  color: #6c757d;\n  position: relative;\n  z-index: 1;\n  transition: all 0.2s ease;\n\n  .forman-step.active & {\n    background: var(--vz-primary);\n    color: white;\n    box-shadow: 0 0 0 4px rgba(64, 81, 137, 0.2);\n  }\n\n  .forman-step.completed & {\n    background: var(--vz-success);\n    color: white;\n\n    i {\n      font-size: 0.875rem;\n    }\n  }\n}\n\n.forman-step-label {\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: #6c757d;\n  text-align: center;\n\n  .forman-step.active & {\n    color: var(--vz-primary);\n    font-weight: 600;\n  }\n\n  .forman-step.completed & {\n    color: var(--vz-success);\n  }\n}\n\n.forman-step-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1rem;\n  height: 1rem;\n  padding: 0 0.25rem;\n  margin-left: 0.25rem;\n  background: var(--vz-primary);\n  color: white;\n  border-radius: 0.5rem;\n  font-size: 0.5625rem;\n  font-weight: 700;\n\n  .forman-step.completed & {\n    background: var(--vz-success);\n  }\n}\n\n.forman-step-title {\n  text-align: center;\n  margin-bottom: 1rem;\n\n  h2 {\n    font-size: 1.125rem;\n    font-weight: 700;\n    color: #212529;\n    margin: 0 0 0.25rem;\n  }\n}\n\n.forman-step-subtitle {\n  font-size: 0.8125rem;\n  color: #6c757d;\n}\n\n// Locked Overlay (şantiye seçilmediğinde)\n.forman-locked-overlay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 250px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 1rem;\n  margin-top: 0.5rem;\n}\n\n.forman-locked-content {\n  text-align: center;\n  padding: 2rem;\n\n  i {\n    font-size: 3rem;\n    color: #adb5bd;\n    margin-bottom: 1rem;\n    display: block;\n  }\n\n  p {\n    font-size: 1rem;\n    color: #6c757d;\n    margin: 0 0 1.25rem;\n    font-weight: 500;\n  }\n}\n\n.forman-btn-select-site {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background: var(--vz-primary);\n  border: none;\n  border-radius: 0.5rem;\n  color: white;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:active {\n    transform: scale(0.96);\n  }\n\n  i {\n    font-size: 1.125rem;\n    margin: 0;\n    color: white;\n  }\n}\n\n// Kayıt mevcut - kilitli durumu\n.forman-record-exists {\n  h3 {\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: #495057;\n    margin: 0.75rem 0 0.5rem;\n  }\n\n  p {\n    font-size: 0.9375rem;\n    color: #6c757d;\n    margin: 0 0 1rem;\n    font-weight: 400;\n\n    strong {\n      color: #495057;\n    }\n  }\n\n  > i {\n    font-size: 3.5rem;\n    color: #f59e0b;\n    margin-bottom: 0.5rem;\n  }\n}\n\n.forman-record-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n\n  span {\n    display: flex;\n    align-items: center;\n    gap: 0.375rem;\n    font-size: 0.875rem;\n    color: #6c757d;\n\n    i {\n      font-size: 1rem;\n      color: #6c757d;\n      margin: 0;\n    }\n  }\n}\n\n.forman-record-locked-badge {\n  background: #fef3c7;\n  color: #92400e;\n  padding: 0.25rem 0.625rem;\n  border-radius: 1rem;\n  font-weight: 500;\n\n  i {\n    color: #f59e0b !important;\n  }\n}\n\n.forman-record-hint {\n  font-size: 0.8125rem !important;\n  color: #9ca3af !important;\n  font-style: italic;\n}\n\n.forman-record-actions {\n  display: flex;\n  gap: 0.625rem;\n  justify-content: center;\n  margin-top: 1.25rem;\n}\n\n.forman-locked-action-btn {\n  flex: 1;\n  padding: 0.625rem 1rem;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  color: #6b7280;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.15s ease;\n\n  &:active {\n    transform: scale(0.97);\n    background: #f3f4f6;\n  }\n}\n\n.forman-btn-outline {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.625rem 1rem;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  color: #6c757d;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:active {\n    transform: scale(0.97);\n    background: #f8f9fa;\n  }\n\n  i {\n    font-size: 1rem;\n    margin: 0;\n    color: inherit;\n  }\n}\n\n// Eksik gün uyarı banner\n.forman-missing-days-banner {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n  background: #fef3c7;\n  border: 1px solid #fbbf24;\n  border-radius: 0.75rem;\n  padding: 0.875rem 1rem;\n  margin-bottom: 1rem;\n\n  strong {\n    display: block;\n    color: #92400e;\n    font-size: 0.9375rem;\n  }\n\n  p {\n    color: #78350f;\n  }\n}\n\n.forman-missing-days-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.forman-missing-date-badge {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  background: #fff;\n  border: 1px solid #fbbf24;\n  border-radius: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #92400e;\n\n  i {\n    font-size: 1.125rem;\n    color: #f59e0b;\n    margin: 0;\n  }\n}\n\n.forman-no-work-bar {\n  padding: 0 1rem 0.5rem;\n}\n\n.forman-no-work-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.625rem 1rem;\n  background: #fff1f2;\n  border: 1.5px dashed #fda4af;\n  border-radius: 0.625rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #be123c;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:active {\n    transform: scale(0.98);\n    background: #ffe4e6;\n    border-color: #fb7185;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  i {\n    font-size: 1.125rem;\n    color: #e11d48;\n    margin: 0;\n  }\n}\n\n// List Items\n.forman-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n// Personel Seç butonu\n.forman-select-personnel-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.875rem 1rem;\n  background: white;\n  border: 1.5px dashed #ced4da;\n  border-radius: 0.625rem;\n  cursor: pointer;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: var(--vz-primary);\n  margin-bottom: 0.75rem;\n  transition: all 0.15s ease;\n\n  &:active {\n    background: #f0f7ff;\n    border-color: var(--vz-primary);\n  }\n\n  > i:first-child {\n    font-size: 1.25rem;\n  }\n\n  > span {\n    flex: 1;\n    text-align: left;\n  }\n\n  > i:last-child {\n    font-size: 1.25rem;\n    color: #adb5bd;\n  }\n}\n\n.forman-select-personnel-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.5rem;\n  height: 1.5rem;\n  padding: 0 0.375rem;\n  border-radius: 999px;\n  background: var(--vz-primary);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n// Kaldır butonu\n.forman-remove-btn {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  border-radius: 50%;\n  color: #adb5bd;\n  cursor: pointer;\n  margin-left: auto;\n\n  &:active {\n    background: #fee2e2;\n    color: #dc3545;\n  }\n\n  i {\n    font-size: 1.125rem;\n  }\n}\n\n.forman-group-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  padding: 0.5rem 0 0.25rem;\n\n  &:not(:first-child) {\n    margin-top: 0.5rem;\n  }\n}\n\n.forman-list-item {\n  background: white;\n  border-radius: 0.625rem;\n  overflow: hidden;\n  border: 1px solid #e9ecef;\n\n  &.selected {\n    border-color: var(--vz-primary);\n    background: #f8faff;\n  }\n\n  &.disabled {\n    opacity: 0.55;\n    pointer-events: none;\n    background: #f9fafb;\n  }\n}\n\n.forman-status-badge {\n  flex-shrink: 0;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  padding: 0.2rem 0.5rem;\n  border-radius: 1rem;\n  margin-left: auto;\n\n  &--leave {\n    background: #dbeafe;\n    color: #1e40af;\n  }\n\n  &--report {\n    background: #fef3c7;\n    color: #92400e;\n  }\n}\n\n.forman-list-item-main {\n  display: flex;\n  align-items: center;\n  padding: 0.875rem;\n  cursor: pointer;\n\n  &:active {\n    background: #f8f9fa;\n  }\n}\n\n.forman-list-item-check {\n  margin-right: 0.75rem;\n  flex-shrink: 0;\n\n  i {\n    font-size: 1.375rem;\n    color: #ced4da;\n\n    &.ri-checkbox-circle-fill {\n      color: var(--vz-primary);\n    }\n  }\n}\n\n.forman-list-item-info {\n  flex: 1;\n  min-width: 0;\n\n  strong {\n    display: block;\n    font-size: 0.9375rem;\n    font-weight: 500;\n    color: #212529;\n    margin-bottom: 0.125rem;\n  }\n\n  span {\n    display: block;\n    font-size: 0.8125rem;\n    color: #6c757d;\n  }\n}\n\n.forman-list-item-options {\n  padding: 0.625rem 0.875rem;\n  background: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n\n  label {\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: #868e96;\n    margin-bottom: 0.375rem;\n    display: block;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n  }\n}\n\n.forman-wage-buttons,\n.forman-usage-buttons {\n  display: flex;\n  gap: 0.375rem;\n}\n\n.forman-wage-btn,\n.forman-usage-btn {\n  flex: 1;\n  min-height: 44px;\n  padding: 0.5rem 0.625rem;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 0.375rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:active {\n    transform: scale(0.96);\n  }\n\n  &.active {\n    background: var(--vz-primary);\n    border-color: var(--vz-primary);\n    color: white;\n  }\n}\n\n// Work Entry Options\n.forman-work-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.forman-work-input {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n\n  label {\n    flex-shrink: 0;\n    margin-bottom: 0;\n    min-width: 100px;\n  }\n\n  input {\n    flex: 1;\n    max-width: 150px;\n    padding: 0.5rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 600;\n    text-align: center;\n    border: 2px solid #dee2e6;\n    border-radius: 0.5rem;\n    background: white;\n    color: var(--vz-primary);\n\n    &:focus {\n      outline: none;\n      border-color: var(--vz-primary);\n      box-shadow: 0 0 0 3px rgba(64, 81, 137, 0.15);\n    }\n\n    &::placeholder {\n      color: #adb5bd;\n    }\n  }\n}\n\n.forman-work-remaining {\n  font-size: 0.8125rem;\n  color: #6c757d;\n  padding-left: 0.25rem;\n}\n\n// Vehicle Options\n.forman-vehicle-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.forman-vehicle-option-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n\n  label {\n    flex-shrink: 0;\n    margin-bottom: 0;\n    min-width: 70px;\n    font-size: 0.8125rem;\n    font-weight: 500;\n    color: #6c757d;\n  }\n\n  .forman-usage-buttons {\n    flex: 1;\n  }\n}\n\n.forman-select {\n  flex: 1;\n  min-width: 140px;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  background: white;\n  color: #495057;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 12px;\n  padding-right: 2rem;\n\n  &:focus {\n    outline: none;\n    border-color: var(--vz-primary);\n    box-shadow: 0 0 0 2px rgba(64, 81, 137, 0.15);\n  }\n}\n\n.forman-driver-hint {\n  font-size: 0.75rem;\n  color: #6c757d;\n  font-style: italic;\n  width: 100%;\n  margin-top: 0.25rem;\n}\n\n.forman-driver-row {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n// Photo Upload\n.forman-photo-count {\n  margin-left: auto;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--vz-primary);\n  background: rgba(64, 81, 137, 0.1);\n  padding: 0.125rem 0.5rem;\n  border-radius: 1rem;\n}\n\n.forman-photo-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.forman-photo-item {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  background: #f8f9fa;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.forman-photo-remove {\n  position: absolute;\n  top: 0.25rem;\n  right: 0.25rem;\n  width: 1.5rem;\n  height: 1.5rem;\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  i {\n    color: white;\n    font-size: 0.875rem;\n  }\n\n  &:active {\n    transform: scale(0.9);\n  }\n}\n\n.forman-photo-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.forman-photo-btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border: 2px dashed #dee2e6;\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  i {\n    font-size: 1.5rem;\n    color: #6c757d;\n  }\n\n  span {\n    font-size: 0.8125rem;\n    font-weight: 500;\n    color: #6c757d;\n  }\n\n  &:active {\n    transform: scale(0.98);\n    background: #e9ecef;\n    border-color: var(--vz-primary);\n\n    i, span {\n      color: var(--vz-primary);\n    }\n  }\n}\n\n.forman-driver-trigger {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  color: #6c757d;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  span {\n    flex: 1;\n    text-align: left;\n  }\n\n  .ri-user-line {\n    font-size: 1rem;\n    color: #adb5bd;\n  }\n\n  .ri-arrow-down-s-line {\n    font-size: 1.125rem;\n    color: #adb5bd;\n  }\n\n  &:active {\n    transform: scale(0.98);\n    background: #f8f9fa;\n  }\n\n  &.has-value {\n    color: #212529;\n    border-color: var(--vz-primary);\n    background: rgba(64, 81, 137, 0.05);\n\n    .ri-user-line {\n      color: var(--vz-primary);\n    }\n  }\n}\n\n// Notes Section\n.forman-notes-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  padding: 0.5rem 0;\n\n  .forman-field {\n    background: white;\n    border-radius: 0.75rem;\n    padding: 1rem;\n    border: 1px solid #e9ecef;\n\n    label {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      font-size: 0.875rem;\n      font-weight: 600;\n      color: #495057;\n      margin-bottom: 0.75rem;\n\n      i {\n        font-size: 1rem;\n        color: var(--vz-primary);\n      }\n    }\n  }\n}\n\n.forman-textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  font-size: 0.9375rem;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 100px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus {\n    outline: none;\n    border-color: var(--vz-primary);\n    box-shadow: 0 0 0 3px rgba(64, 81, 137, 0.15);\n  }\n\n  &::placeholder {\n    color: #adb5bd;\n  }\n}\n\n.forman-field-hint {\n  font-size: 0.8125rem;\n  color: #868e96;\n  margin: 0;\n  font-style: italic;\n}\n\n// Empty State\n.forman-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #6c757d;\n\n  i {\n    font-size: 3rem;\n    margin-bottom: 1rem;\n    opacity: 0.5;\n  }\n\n  p {\n    margin: 0;\n  }\n}\n\n// Bottom Actions — flex child, position: fixed değil\n.forman-bottom-actions {\n  flex-shrink: 0;\n  background: white;\n  padding: 0.75rem 1rem;\n  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n  z-index: 100;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n\n  // BottomSheet açıkken: layout korunur, bar görünmez + tıklanamaz\n  &.sheet-open {\n    opacity: 0;\n    visibility: hidden;\n    pointer-events: none;\n  }\n}\n\n.forman-summary {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  font-size: 0.8125rem;\n  color: #6c757d;\n\n  span {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n  }\n\n  i {\n    font-size: 0.9375rem;\n  }\n}\n\n.forman-btn-primary {\n  width: 100%;\n  padding: 0.75rem;\n  background: var(--vz-primary);\n  border: none;\n  border-radius: 0.5rem;\n  color: white;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n\n  &:active:not(:disabled) {\n    transform: scale(0.98);\n    opacity: 0.9;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  i {\n    font-size: 1rem;\n  }\n}\n\n.forman-btn-secondary {\n  padding: 0.75rem 1.25rem;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  color: #495057;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n\n  &:active {\n    transform: scale(0.98);\n    background: #f8f9fa;\n  }\n\n  i {\n    font-size: 1rem;\n  }\n}\n\n// Wizard Actions\n.forman-wizard-actions {\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0));\n\n  .forman-btn-primary {\n    width: auto;\n    padding: 0.75rem 1.5rem;\n  }\n}\n\n.forman-summary-mini {\n  display: flex;\n  gap: 0.75rem;\n  font-size: 0.75rem;\n  color: #868e96;\n\n  span {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n  }\n\n  i {\n    font-size: 0.875rem;\n  }\n}\n\n// =============================================\n// BOTTOM SHEET - MOBILE NATIVE MODAL\n// =============================================\n\n.bottom-sheet-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n  display: flex;\n  align-items: flex-end;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { transform: translateY(100%); }\n  to { transform: translateY(0); }\n}\n\n.bottom-sheet {\n  width: 100%;\n  max-height: 70vh;\n  background: white;\n  border-radius: 1rem 1rem 0 0;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease;\n\n  // Footer yoksa (single-select) safe area padding'i sheet'e ekle\n  &:not(:has(.bottom-sheet-footer)) {\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n}\n\n.bottom-sheet-handle {\n  width: 36px;\n  height: 4px;\n  background: #dee2e6;\n  border-radius: 2px;\n  margin: 0.75rem auto 0;\n  flex-shrink: 0;\n}\n\n.bottom-sheet-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1rem 0.75rem;\n  border-bottom: 1px solid #e9ecef;\n  flex-shrink: 0;\n\n  h3 {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #212529;\n    margin: 0;\n  }\n}\n\n.bottom-sheet-close {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: #f3f3f9;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  &:active {\n    background: #e9ecef;\n  }\n\n  i {\n    font-size: 1.25rem;\n    color: #6c757d;\n  }\n}\n\n.bottom-sheet-content {\n  flex: 1;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: env(safe-area-inset-bottom, 0);\n}\n\n.bottom-sheet-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #6c757d;\n\n  i {\n    font-size: 2.5rem;\n    margin-bottom: 0.75rem;\n    opacity: 0.5;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.9375rem;\n  }\n}\n\n.bottom-sheet-options {\n  padding: 0.5rem 0;\n}\n\n.bottom-sheet-option {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.875rem 1rem;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:active {\n    background: #f8f9fa;\n  }\n\n  &.selected {\n    background: #f0f7ff;\n  }\n}\n\n.bottom-sheet-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.bottom-sheet-option-label {\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: #212529;\n\n  .selected & {\n    color: var(--vz-primary);\n  }\n}\n\n.bottom-sheet-option-sublabel {\n  font-size: 0.8125rem;\n  color: #6c757d;\n}\n\n.bottom-sheet-option-check {\n  font-size: 1.25rem;\n  color: var(--vz-primary);\n  flex-shrink: 0;\n  margin-left: 0.75rem;\n}\n\n.bottom-sheet-search {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0 1rem 0.75rem;\n  border-bottom: 1px solid #f2f4f7;\n\n  i {\n    color: #98a2b3;\n    font-size: 1.1rem;\n    flex-shrink: 0;\n  }\n\n  input {\n    flex: 1;\n    border: none;\n    outline: none;\n    font-size: 1rem; // 16px — iOS zoom'u engeller\n    padding: 0.5rem 0;\n    background: transparent;\n\n    &::placeholder {\n      color: #adb5bd;\n    }\n  }\n\n  button {\n    background: none;\n    border: none;\n    padding: 0.25rem;\n    color: #98a2b3;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      color: #495057;\n    }\n  }\n}\n\n// BottomSheet Multi-select additions\n.bottom-sheet-group-header {\n  padding: 0.625rem 1rem 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #6c757d;\n  background: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n\n  &:first-child {\n    border-top: none;\n  }\n}\n\n.bottom-sheet-option.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.bottom-sheet-option-check-left {\n  flex-shrink: 0;\n  margin-right: 0.75rem;\n  font-size: 1.25rem;\n  color: #adb5bd;\n  display: flex;\n  align-items: center;\n\n  .selected & {\n    color: var(--vz-primary);\n  }\n\n  .disabled & {\n    color: #dc3545;\n  }\n}\n\n.bottom-sheet-option-badge {\n  flex-shrink: 0;\n  margin-left: 0.5rem;\n  padding: 0.125rem 0.5rem;\n  font-size: 0.6875rem;\n  font-weight: 500;\n  border-radius: 999px;\n  background: #fff3cd;\n  color: #856404;\n}\n\n.bottom-sheet-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  border-top: 1px solid #e9ecef;\n  flex-shrink: 0;\n  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0));\n}\n\n.bottom-sheet-footer-count {\n  font-size: 0.875rem;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.bottom-sheet-footer-btn {\n  padding: 0.5rem 1.5rem;\n  background: var(--vz-primary);\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n\n  &:active {\n    opacity: 0.85;\n  }\n}\n\n// Custom Select Trigger Button\n.forman-select-trigger {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.625rem 0.75rem;\n  font-size: 0.9375rem;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n  text-align: left;\n\n  &:active {\n    border-color: var(--vz-primary);\n  }\n\n  &.has-value {\n    color: #212529;\n  }\n\n  &.placeholder {\n    color: #adb5bd;\n  }\n\n  i {\n    font-size: 1.125rem;\n    color: #6c757d;\n    flex-shrink: 0;\n  }\n}\n\n.forman-select-trigger-text {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// =============================================\n// RESPONSIVE - TABLET\n// =============================================\n\n@media (max-width: 991.98px) {\n  // Header mobile adjustments\n  .app-header {\n    padding: 0 1rem;\n  }\n\n  // Hide user name/role on tablet, show only avatar\n  .user-dropdown .dropdown-toggle .user-info {\n    display: none;\n  }\n\n  // Page title adjustments\n  .page-title-box {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 0.75rem;\n\n    .page-title-right {\n      width: 100%;\n\n      .btn {\n        width: 100%;\n      }\n    }\n  }\n}\n\n// =============================================\n// RESPONSIVE - MOBILE\n// =============================================\n\n@media (max-width: 575.98px) {\n  // Reduce header height on mobile\n  :root {\n    --vz-header-height: 60px;\n  }\n\n  .page-content {\n    padding: calc(var(--vz-header-height) + 1rem) 0.75rem 1rem;\n  }\n\n  // Container fluid padding\n  .container-fluid {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  // Card mobile optimizations\n  .card {\n    margin-bottom: 1rem;\n    border-radius: 0.375rem;\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n\n    .card-header {\n      padding: 0.875rem 1rem;\n\n      .card-title {\n        font-size: 0.9rem;\n      }\n    }\n\n    .card-body {\n      padding: 1rem;\n    }\n  }\n\n  // Page title mobile\n  .page-title-box {\n    padding-bottom: 0.75rem;\n    margin-bottom: 1rem;\n\n    h4 {\n      font-size: 1rem;\n    }\n  }\n\n  // Table mobile optimizations\n  .table-responsive {\n    margin: 0 -1rem;\n    padding: 0 1rem;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table {\n    font-size: 0.8rem;\n    white-space: nowrap;\n\n    th {\n      font-size: 0.7rem;\n      padding: 0.5rem;\n    }\n\n    td {\n      padding: 0.5rem;\n    }\n  }\n\n  // Buttons touch-friendly\n  .btn {\n    min-height: 44px;\n    padding: 0.5rem 1rem;\n  }\n\n  .btn-sm {\n    min-height: 36px;\n    padding: 0.375rem 0.75rem;\n  }\n\n  // Form controls touch-friendly\n  .form-control,\n  .form-select {\n    min-height: 44px;\n    font-size: 16px; // Prevents zoom on iOS\n  }\n\n  // Modal mobile fullscreen\n  .modal-dialog {\n    margin: 0.5rem;\n    max-width: calc(100% - 1rem);\n  }\n\n  .modal-lg {\n    max-width: calc(100% - 1rem);\n  }\n\n  // Avatar sizes mobile\n  .avatar-lg {\n    width: 3rem;\n    height: 3rem;\n  }\n\n  .avatar-sm {\n    width: 1.75rem;\n    height: 1.75rem;\n  }\n\n  // Quick access buttons - full width on mobile\n  .btn-outline-primary.w-100,\n  .btn-outline-success.w-100,\n  .btn-outline-info.w-100,\n  .btn-outline-warning.w-100 {\n    padding: 1rem;\n\n    i.fs-24 {\n      font-size: 1.5rem !important;\n    }\n  }\n\n  // Dashboard stats cards\n  .card-animate {\n    .fs-22 {\n      font-size: 1.25rem !important;\n    }\n  }\n\n  // Footer mobile\n  .footer {\n    font-size: 0.7rem;\n    padding: 0 0.5rem;\n  }\n\n  // Badge mobile\n  .badge {\n    font-size: 0.65rem;\n    padding: 0.25em 0.5em;\n  }\n\n  // Form switch mobile\n  .form-check-input {\n    width: 2.5em;\n    height: 1.25em;\n  }\n\n  // Breadcrumb hide on mobile\n  .breadcrumb {\n    display: none;\n  }\n\n  // CountUp smaller on mobile\n  h2 .countup {\n    font-size: 1.5rem;\n  }\n\n  // Row gutters mobile\n  .row {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-3 {\n    --bs-gutter-x: 0.75rem;\n    --bs-gutter-y: 0.75rem;\n  }\n}\n\n// =============================================\n// RESPONSIVE - EXTRA SMALL\n// =============================================\n\n@media (max-width: 375px) {\n  .page-content {\n    padding: calc(var(--vz-header-height) + 0.75rem) 0.5rem 0.75rem;\n  }\n\n  .card {\n    .card-body {\n      padding: 0.75rem;\n    }\n  }\n\n  .table {\n    font-size: 0.75rem;\n  }\n\n  // Hide table columns on very small screens\n  .table td:nth-child(n+5),\n  .table th:nth-child(n+5) {\n    display: none;\n  }\n}\n\n// =============================================\n// TOUCH IMPROVEMENTS\n// =============================================\n\n// Improve touch targets\n@media (hover: none) and (pointer: coarse) {\n  // Touch-friendly links in navbar\n  .navbar-nav .nav-item .nav-link {\n    padding: 0.875rem 1.5rem;\n  }\n\n  // Touch-friendly dropdown items\n  .dropdown-item {\n    padding: 0.75rem 1rem;\n  }\n\n  // Touch-friendly table rows\n  .table-hover tbody tr {\n    cursor: pointer;\n  }\n}\n\n// =============================================\n// LANDSCAPE MOBILE\n// =============================================\n\n@media (max-height: 500px) and (orientation: landscape) {\n  .page-content {\n    padding-top: calc(var(--vz-header-height) + 0.5rem);\n    padding-bottom: 0.5rem;\n  }\n\n  .footer {\n    position: relative;\n  }\n}\n\n// =============================================\n// SAFE AREA (NOTCH) SUPPORT\n// =============================================\n\n@supports (padding: env(safe-area-inset-bottom)) {\n  .footer {\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n\n  .app-menu {\n    padding-top: env(safe-area-inset-top);\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n\n  @media (max-width: 991.98px) {\n    .app-header {\n      padding-top: env(safe-area-inset-top);\n      height: calc(var(--vz-header-height) + env(safe-area-inset-top));\n    }\n\n    .page-content {\n      padding-top: calc(var(--vz-header-height) + env(safe-area-inset-top) + 1.5rem);\n      padding-bottom: calc(env(safe-area-inset-bottom) + 1rem);\n    }\n  }\n}\n\n// =============================================\n// DAILY RECORD DETAIL MODAL\n// =============================================\n\n.daily-record-detail {\n  // Header\n  .detail-header {\n    padding-bottom: 1rem;\n    border-bottom: 1px solid var(--vz-border-color);\n\n    h5 {\n      font-size: 1.1rem;\n      font-weight: 600;\n    }\n  }\n\n  .detail-meta {\n    p {\n      font-size: 0.9rem;\n      line-height: 1.6;\n\n      i {\n        width: 1.25rem;\n        text-align: center;\n      }\n    }\n  }\n\n  // Sections\n  .detail-section {\n    padding: 1rem 0;\n    border-bottom: 1px solid var(--vz-border-color);\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .detail-section-title {\n    font-size: 0.95rem;\n    font-weight: 600;\n    margin-bottom: 0.75rem;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n\n    i {\n      font-size: 1rem;\n    }\n\n    .badge {\n      font-size: 0.7rem;\n      font-weight: 500;\n    }\n  }\n\n  // List\n  .detail-list {\n    background: var(--vz-light);\n    border-radius: 0.5rem;\n    overflow: hidden;\n  }\n\n  .detail-list-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid var(--vz-border-color);\n    background: var(--vz-card-bg);\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    strong {\n      font-size: 0.875rem;\n      font-weight: 600;\n    }\n\n    small {\n      font-size: 0.75rem;\n    }\n\n    .badge {\n      font-size: 0.7rem;\n      font-weight: 500;\n      white-space: nowrap;\n    }\n  }\n\n  .detail-list-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 1rem;\n    background: rgba(var(--vz-primary-rgb), 0.08);\n    font-size: 0.875rem;\n\n    strong {\n      color: var(--vz-primary);\n    }\n  }\n\n  // Photos\n  .detail-photos {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    gap: 0.75rem;\n  }\n\n  .detail-photo {\n    position: relative;\n    aspect-ratio: 1;\n    border-radius: 0.5rem;\n    overflow: hidden;\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n    &:hover {\n      transform: scale(1.05);\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    }\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n}\n\n// Mobile adjustments\n@media (max-width: 767.98px) {\n  .daily-record-detail {\n    .detail-header h5 {\n      font-size: 1rem;\n    }\n\n    .detail-meta p {\n      font-size: 0.85rem;\n    }\n\n    .detail-list-item {\n      padding: 0.625rem 0.875rem;\n      flex-wrap: wrap;\n      gap: 0.5rem;\n\n      > div:first-child {\n        flex: 1;\n        min-width: 0;\n      }\n\n      strong {\n        font-size: 0.8125rem;\n      }\n    }\n\n    .detail-photos {\n      grid-template-columns: repeat(3, 1fr);\n      gap: 0.5rem;\n    }\n\n    .detail-photo {\n      border-radius: 0.375rem;\n    }\n  }\n}\n\n// =============================================\n// DAILY RECORD FORM MODAL\n// =============================================\n\n.daily-record-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n\n  .form-section {\n    background: var(--vz-card-bg);\n    border: 1px solid var(--vz-border-color);\n    border-radius: 0.5rem;\n    overflow: hidden;\n  }\n\n  .form-section-title {\n    font-size: 0.9rem;\n    font-weight: 600;\n    margin: 0;\n    padding: 0.75rem 1rem;\n    background: var(--vz-light);\n    border-bottom: 1px solid var(--vz-border-color);\n    display: flex;\n    align-items: center;\n\n    i {\n      font-size: 1rem;\n      color: var(--vz-primary);\n    }\n  }\n\n  .form-section-content {\n    padding: 1rem;\n\n    .form-group {\n      margin-bottom: 1rem;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    label {\n      font-size: 0.8125rem;\n      font-weight: 500;\n      margin-bottom: 0.375rem;\n    }\n  }\n\n  // Usage History List\n  .usage-history-list {\n    max-height: 350px;\n    overflow-y: auto;\n  }\n\n  .usage-history-item {\n    display: flex;\n    gap: 0.75rem;\n    padding: 0.875rem 1rem;\n    border-bottom: 1px solid var(--vz-border-color);\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover {\n      background-color: var(--vz-light);\n    }\n  }\n\n  .usage-history-date {\n    flex-shrink: 0;\n    font-size: 0.75rem;\n    color: var(--vz-primary);\n    font-weight: 500;\n    white-space: nowrap;\n\n    i {\n      font-size: 0.8rem;\n    }\n  }\n\n  .usage-history-content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .usage-history-site {\n    font-size: 0.8125rem;\n    margin-bottom: 0.25rem;\n\n    strong {\n      color: var(--vz-heading-color);\n    }\n  }\n\n  .usage-history-details {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .usage-history-notes {\n    font-style: italic;\n  }\n\n  // Tabs\n  .form-tabs {\n    border-bottom: none;\n    background: var(--vz-light);\n    padding: 0.5rem 0.5rem 0;\n    gap: 0.25rem;\n\n    .nav-item {\n      flex: 1;\n    }\n\n    .nav-link {\n      border: none;\n      border-radius: 0.375rem 0.375rem 0 0;\n      padding: 0.625rem 0.75rem;\n      font-size: 0.8125rem;\n      font-weight: 500;\n      color: var(--vz-body-color);\n      background: transparent;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 0.375rem;\n      transition: all 0.15s ease;\n\n      &:hover {\n        background: rgba(var(--vz-primary-rgb), 0.05);\n      }\n\n      &.active {\n        background: var(--vz-card-bg);\n        color: var(--vz-primary);\n        box-shadow: 0 -2px 0 var(--vz-primary) inset;\n      }\n\n      i {\n        font-size: 1rem;\n      }\n\n      .tab-badge {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        min-width: 1.25rem;\n        height: 1.25rem;\n        padding: 0 0.375rem;\n        font-size: 0.6875rem;\n        font-weight: 600;\n        background: var(--vz-primary);\n        color: white;\n        border-radius: 1rem;\n      }\n    }\n  }\n\n  .tab-content {\n    background: var(--vz-card-bg);\n  }\n\n  .tab-section {\n    padding: 1rem;\n  }\n\n  // Selected List\n  .selected-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .selected-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.75rem;\n    background: var(--vz-light);\n    border-radius: 0.375rem;\n    gap: 0.75rem;\n\n    &.vehicle-item,\n    &.work-item {\n      flex-wrap: wrap;\n    }\n  }\n\n  .selected-item-info {\n    flex: 1;\n    min-width: 0;\n\n    strong {\n      display: block;\n      font-size: 0.875rem;\n      font-weight: 600;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    small {\n      display: block;\n      font-size: 0.75rem;\n      color: var(--vz-secondary-color);\n    }\n  }\n\n  .selected-item-actions,\n  .selected-item-fields {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n\n    .form-control,\n    .form-select {\n      font-size: 0.8125rem;\n    }\n  }\n\n  .btn-remove {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.75rem;\n    height: 1.75rem;\n    padding: 0;\n    border: none;\n    border-radius: 0.25rem;\n    background: rgba(var(--vz-danger-rgb), 0.1);\n    color: var(--vz-danger);\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &:hover {\n      background: var(--vz-danger);\n      color: white;\n    }\n\n    i {\n      font-size: 1rem;\n    }\n  }\n\n  // Selectable List (Toggle pattern like forman page)\n  .selectable-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .selectable-item {\n    background: #f8f9fa;\n    border: 1px solid var(--vz-border-color);\n    border-radius: 0.5rem;\n    overflow: hidden;\n    transition: all 0.15s ease;\n\n    &.selected {\n      background: rgba(var(--vz-primary-rgb), 0.05);\n      border-color: var(--vz-primary);\n    }\n\n    &:hover:not(.selected) {\n      background: #f0f0f5;\n    }\n  }\n\n  .selectable-item-main {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem;\n    cursor: pointer;\n    user-select: none;\n  }\n\n  .selectable-item-check {\n    flex-shrink: 0;\n    width: 1.5rem;\n    height: 1.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    i {\n      font-size: 1.25rem;\n      color: var(--vz-secondary-color);\n      transition: all 0.15s ease;\n    }\n\n    .selectable-item.selected & i {\n      color: var(--vz-primary);\n    }\n  }\n\n  .selectable-item-info {\n    flex: 1;\n    min-width: 0;\n\n    strong {\n      display: block;\n      font-size: 0.875rem;\n      font-weight: 600;\n      color: var(--vz-body-color);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    small {\n      display: block;\n      font-size: 0.75rem;\n      color: var(--vz-secondary-color);\n    }\n\n    .progress {\n      margin-top: 0.375rem;\n    }\n  }\n\n  .selectable-item-options {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.5rem 1rem;\n    padding: 0.625rem 0.75rem;\n    background: rgba(var(--vz-primary-rgb), 0.03);\n    border-top: 1px dashed rgba(var(--vz-primary-rgb), 0.2);\n  }\n\n  .option-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n  }\n\n  .option-label {\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: var(--vz-secondary-color);\n    white-space: nowrap;\n  }\n\n  // Wage Buttons\n  .wage-buttons {\n    display: flex;\n    gap: 0.25rem;\n  }\n\n  .wage-btn {\n    min-width: 2.25rem;\n    height: 1.75rem;\n    padding: 0 0.5rem;\n    font-size: 0.75rem;\n    font-weight: 600;\n    border: 1px solid var(--vz-border-color);\n    border-radius: 0.25rem;\n    background: white;\n    color: var(--vz-body-color);\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &:hover {\n      border-color: var(--vz-primary);\n      color: var(--vz-primary);\n    }\n\n    &.active {\n      background: var(--vz-primary);\n      border-color: var(--vz-primary);\n      color: white;\n    }\n  }\n\n  // Usage Buttons\n  .usage-buttons {\n    display: flex;\n    gap: 0.25rem;\n  }\n\n  .usage-btn {\n    padding: 0.25rem 0.625rem;\n    font-size: 0.75rem;\n    font-weight: 500;\n    border: 1px solid var(--vz-border-color);\n    border-radius: 0.25rem;\n    background: white;\n    color: var(--vz-body-color);\n    cursor: pointer;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n\n    &:hover {\n      border-color: var(--vz-success);\n      color: var(--vz-success);\n    }\n\n    &.active {\n      background: var(--vz-success);\n      border-color: var(--vz-success);\n      color: white;\n    }\n  }\n\n  // Vehicle & Work Options\n  .vehicle-options,\n  .work-options {\n    flex-direction: column;\n    align-items: flex-start;\n\n    .option-row {\n      width: 100%;\n    }\n\n    .form-select,\n    .form-control {\n      flex: 1;\n      font-size: 0.8125rem;\n    }\n  }\n\n  // Photo Section\n  .photo-label {\n    display: block;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: var(--vz-secondary-color);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin-bottom: 0.5rem;\n  }\n\n  .photo-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n    gap: 0.5rem;\n  }\n\n  .photo-item {\n    position: relative;\n    aspect-ratio: 1;\n    border-radius: 0.375rem;\n    overflow: hidden;\n    background: var(--vz-light);\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    &.existing {\n      opacity: 0.7;\n    }\n  }\n\n  .photo-remove {\n    position: absolute;\n    top: 0.25rem;\n    right: 0.25rem;\n    width: 1.5rem;\n    height: 1.5rem;\n    padding: 0;\n    border: none;\n    border-radius: 50%;\n    background: rgba(var(--vz-danger-rgb), 0.9);\n    color: white;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.15s ease;\n\n    &:hover {\n      background: var(--vz-danger);\n      transform: scale(1.1);\n    }\n\n    i {\n      font-size: 0.875rem;\n    }\n  }\n\n  .photo-upload-area {\n    margin-top: 1rem;\n  }\n\n  .photo-upload-btn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.25rem;\n    width: 100%;\n    padding: 1.5rem;\n    border: 2px dashed var(--vz-border-color);\n    border-radius: 0.5rem;\n    background: var(--vz-light);\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &:hover {\n      border-color: var(--vz-primary);\n      background: rgba(var(--vz-primary-rgb), 0.05);\n    }\n\n    i {\n      font-size: 1.5rem;\n      color: var(--vz-primary);\n    }\n\n    span {\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: var(--vz-body-color);\n    }\n\n    small {\n      font-size: 0.75rem;\n      color: var(--vz-secondary-color);\n    }\n  }\n\n  .existing-photos,\n  .new-photos {\n    margin-bottom: 1rem;\n  }\n\n  // Form Actions\n  .form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--vz-border-color);\n  }\n}\n\n// Mobile adjustments for form\n@media (max-width: 767.98px) {\n  .daily-record-form {\n    gap: 1rem;\n\n    .form-section-title {\n      padding: 0.625rem 0.875rem;\n      font-size: 0.85rem;\n    }\n\n    .form-section-content {\n      padding: 0.875rem;\n    }\n\n    .form-tabs {\n      padding: 0.375rem 0.375rem 0;\n\n      .nav-link {\n        padding: 0.5rem;\n        font-size: 0.75rem;\n\n        i {\n          font-size: 0.875rem;\n        }\n\n        .tab-badge {\n          min-width: 1rem;\n          height: 1rem;\n          font-size: 0.625rem;\n        }\n      }\n    }\n\n    .tab-section {\n      padding: 0.875rem;\n    }\n\n    // Selectable list mobile\n    .selectable-item-main {\n      padding: 0.625rem;\n      gap: 0.5rem;\n    }\n\n    .selectable-item-check {\n      width: 1.25rem;\n      height: 1.25rem;\n\n      i {\n        font-size: 1.1rem;\n      }\n    }\n\n    .selectable-item-info {\n      strong {\n        font-size: 0.8125rem;\n      }\n\n      small {\n        font-size: 0.7rem;\n      }\n    }\n\n    .selectable-item-options {\n      padding: 0.5rem 0.625rem;\n      gap: 0.375rem 0.75rem;\n    }\n\n    .option-label {\n      font-size: 0.7rem;\n    }\n\n    .wage-btn {\n      min-width: 2rem;\n      height: 1.625rem;\n      font-size: 0.7rem;\n    }\n\n    .usage-btn {\n      padding: 0.2rem 0.5rem;\n      font-size: 0.7rem;\n    }\n\n    // Photo grid mobile\n    .photo-grid {\n      grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));\n      gap: 0.375rem;\n    }\n\n    .photo-upload-btn {\n      padding: 1rem;\n\n      i {\n        font-size: 1.25rem;\n      }\n\n      span {\n        font-size: 0.8125rem;\n      }\n    }\n\n    .selected-item {\n      padding: 0.625rem;\n    }\n\n    .selected-item-info strong {\n      font-size: 0.8125rem;\n    }\n\n    .form-actions {\n      flex-direction: column-reverse;\n\n      .btn {\n        width: 100%;\n      }\n    }\n  }\n}\n\n// ═══════════════════════════════════════════════════════════════════════════\n// WAYBILL STYLES\n// ═══════════════════════════════════════════════════════════════════════════\n\n.waybill-number-link {\n  cursor: pointer;\n  color: #405189;\n  transition: all 0.15s ease;\n\n  &:hover {\n    color: #3577f1;\n    text-decoration: underline;\n  }\n}\n\n.waybill-photo-link {\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n\n    img {\n      transform: scale(1.1);\n    }\n  }\n}\n\n// ═══════════════════════════════════════════════════════════════\n// iOS Safari: input'lara odaklanınca auto-zoom'u engelle\n// ═══════════════════════════════════════════════════════════════\n@media screen and (max-width: 768px) {\n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"password\"],\n  input[type=\"number\"],\n  input[type=\"tel\"],\n  input[type=\"url\"],\n  input[type=\"search\"],\n  input[type=\"date\"],\n  select,\n  textarea {\n    font-size: 16px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
